/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.4.0 (NJsonSchema v10.1.26.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken,
  AxiosError
} from "axios";
import axios from "./api";
import moment from "moment";

export class AddressService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAddressDto | undefined , cancelToken?: CancelToken | undefined): Promise<AddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Address/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<AddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Address/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param name (optional) Name
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<AddressDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<AddressDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<AddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Address/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAddressDto | undefined , cancelToken?: CancelToken | undefined): Promise<AddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Address/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<AddressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddressDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddressDto>(<any>null);
    }
}

export class AuditLogService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取审计日志
     * @param sorting (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param hasException (optional) 是否异常
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, hasException: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<AuditLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAll?";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined && serviceName !== null)
            url_ += "serviceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined && methodName !== null)
            url_ += "methodName=" + encodeURIComponent("" + methodName) + "&";
        if (hasException !== undefined && hasException !== null)
            url_ += "hasException=" + encodeURIComponent("" + hasException) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<AuditLogDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditLogDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditLogDtoPagedResultDto>(<any>null);
    }
}

export class CarouselService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 添加轮播广告
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCarouselDto | undefined , cancelToken?: CancelToken | undefined): Promise<CarouselDto> {
        let url_ = this.baseUrl + "/api/services/app/Carousel/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CarouselDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarouselDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarouselDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Carousel/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param title (optional) 标题
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(title: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<CarouselDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Carousel/GetAll?";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CarouselDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarouselDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarouselDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<CarouselDto> {
        let url_ = this.baseUrl + "/api/services/app/Carousel/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CarouselDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarouselDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarouselDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCarouselDto | undefined , cancelToken?: CancelToken | undefined): Promise<CarouselDto> {
        let url_ = this.baseUrl + "/api/services/app/Carousel/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CarouselDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CarouselDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CarouselDto>(<any>null);
    }

    /**
     * 获取产品列表用于下拉框
     * @return Success
     */
    getProductAll(  cancelToken?: CancelToken | undefined): Promise<ProDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Carousel/GetProductAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductAll(_response);
        });
    }

    protected processGetProductAll(response: AxiosResponse): Promise<ProDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDto[]>(<any>null);
    }
}

export class ChartMessageService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取聊天列表
     * @param studentName (optional) 学生名字
     * @param type (optional) 全部，当天家长互动，当天未答复
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getGroupAll(studentName: string | null | undefined, type: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<CharMessageStatisticsDto> {
        let url_ = this.baseUrl + "/api/services/app/ChartMessage/GetGroupAll?";
        if (studentName !== undefined && studentName !== null)
            url_ += "studentName=" + encodeURIComponent("" + studentName) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupAll(_response);
        });
    }

    protected processGetGroupAll(response: AxiosResponse): Promise<CharMessageStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CharMessageStatisticsDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CharMessageStatisticsDto>(<any>null);
    }

    /**
     * 根据家长的Openid获取聊天记录
     * @param currentUserId (optional) 
     * @return Success
     */
    getCurrentUserMessage(currentUserId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<CurrentUserMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/ChartMessage/GetCurrentUserMessage?";
        if (currentUserId !== undefined && currentUserId !== null)
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserMessage(_response);
        });
    }

    protected processGetCurrentUserMessage(response: AxiosResponse): Promise<CurrentUserMessageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CurrentUserMessageDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CurrentUserMessageDto>(<any>null);
    }

    /**
     * 家长客服联系分析接口
     * @return Success
     */
    getStudentMessageAnalysis(  cancelToken?: CancelToken | undefined): Promise<StudentMessageAnalysisDto> {
        let url_ = this.baseUrl + "/api/services/app/ChartMessage/GetStudentMessageAnalysis";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudentMessageAnalysis(_response);
        });
    }

    protected processGetStudentMessageAnalysis(response: AxiosResponse): Promise<StudentMessageAnalysisDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudentMessageAnalysisDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentMessageAnalysisDto>(<any>null);
    }

    /**
     * 如果学生有未读消息，推送通知给家长
     * @param currentUserId (optional) 
     * @return Success
     */
    wxPushToParent(currentUserId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ChartMessage/WxPushToParent?";
        if (currentUserId !== undefined && currentUserId !== null)
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWxPushToParent(_response);
        });
    }

    protected processWxPushToParent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class CouponService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 添加轮播广告
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCouponDto | undefined , cancelToken?: CancelToken | undefined): Promise<CouponDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupon/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CouponDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CouponDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CouponDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupon/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param title (optional) 标题
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(title: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<CouponDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupon/GetAll?";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CouponDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CouponDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CouponDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<CouponDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupon/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CouponDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CouponDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CouponDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCouponDto | undefined , cancelToken?: CancelToken | undefined): Promise<CouponDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupon/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<CouponDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CouponDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CouponDto>(<any>null);
    }

    /**
     * 获取产品列表用于下拉框
     * @return Success
     */
    getProductAll(  cancelToken?: CancelToken | undefined): Promise<ProDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Coupon/GetProductAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductAll(_response);
        });
    }

    protected processGetProductAll(response: AxiosResponse): Promise<ProDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDto[]>(<any>null);
    }
}

export class CustomizedPushNotificationService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取所有发布的自定义通知
     * @param tenantId (optional) 
     * @param productId (optional) 
     * @param content (optional) 推送内容
     * @param customizedPush (optional) 推送类型 跳转分类
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCustomizedPushNotificationPage(tenantId: number | null | undefined, productId: number | null | undefined, content: string | null | undefined, customizedPush: CustomizedPush | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<CustomizedPushNotificationPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomizedPushNotification/GetCustomizedPushNotificationPage?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (content !== undefined && content !== null)
            url_ += "content=" + encodeURIComponent("" + content) + "&";
        if (customizedPush === null)
            throw new Error("The parameter 'customizedPush' cannot be null.");
        else if (customizedPush !== undefined)
            url_ += "customizedPush=" + encodeURIComponent("" + customizedPush) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomizedPushNotificationPage(_response);
        });
    }

    protected processGetCustomizedPushNotificationPage(response: AxiosResponse): Promise<CustomizedPushNotificationPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomizedPushNotificationPageDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomizedPushNotificationPageDtoPagedResultDto>(<any>null);
    }

    /**
     * 创建自定义发布推送
     * @param body (optional) 
     * @return Success
     */
    createCustomizedPushNotification(body: CreateCustomizedPushNotificationDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomizedPushNotification/CreateCustomizedPushNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCustomizedPushNotification(_response);
        });
    }

    protected processCreateCustomizedPushNotification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 再次发起推送
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    geteCustomizedPushNotificationPushAgain(id: number | undefined, tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomizedPushNotification/GeteCustomizedPushNotificationPushAgain?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeteCustomizedPushNotificationPushAgain(_response);
        });
    }

    protected processGeteCustomizedPushNotificationPushAgain(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 通过学校过去年级
     * @param tenantId (optional) 
     * @return Success
     */
    getGradeInfoListDto(tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<GradeInfoListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomizedPushNotification/GetGradeInfoListDto?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGradeInfoListDto(_response);
        });
    }

    protected processGetGradeInfoListDto(response: AxiosResponse): Promise<GradeInfoListDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GradeInfoListDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeInfoListDto[]>(<any>null);
    }
}

export class ExportUnicomRegistrationService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 导出晨午晚检统计表格
     * @param body (optional) 
     * @return Success
     */
    exportUnicomRegistration(body: ExportUnicomRegistrationInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ExportUnicomRegistration/ExportUnicomRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportUnicomRegistration(_response);
        });
    }

    protected processExportUnicomRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出微信电话绑定情况表
     * @param body (optional) 
     * @return Success
     */
    exportWxPhoneParent(body: ExportWxParentInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ExportUnicomRegistration/ExportWxPhoneParent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportWxPhoneParent(_response);
        });
    }

    protected processExportWxPhoneParent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param list (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportWxPhoneParentToExcel(list: WxPhoneParentDto[] | null | undefined, body: ExportWxParentInput | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ExportUnicomRegistration/ExportWxPhoneParentToExcel?";
        if (list !== undefined && list !== null)
            list && list.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "list[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportWxPhoneParentToExcel(_response);
        });
    }

    protected processExportWxPhoneParentToExcel(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class FaceSettingService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * @param schoolName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettings(schoolName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FaceSetting/GetAllSettings?";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSettings(_response);
        });
    }

    protected processGetAllSettings(response: AxiosResponse): Promise<PagedResultDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultDtoPagedResultDto>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    updateFeatures(tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/FaceSetting/UpdateFeatures?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFeatures(_response);
        });
    }

    protected processUpdateFeatures(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    updateTeacherFeatures(tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/FaceSetting/UpdateTeacherFeatures?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTeacherFeatures(_response);
        });
    }

    protected processUpdateTeacherFeatures(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    updateClearTeacherFeatures(tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/FaceSetting/UpdateClearTeacherFeatures?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateClearTeacherFeatures(_response);
        });
    }

    protected processUpdateClearTeacherFeatures(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    updateClearStudentFeatures(tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/FaceSetting/UpdateClearStudentFeatures?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateClearStudentFeatures(_response);
        });
    }

    protected processUpdateClearStudentFeatures(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class FaceTempleteService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取学生会员分页列表
     * @param tenantId (optional) 学校Id
     * @param gradeNo (optional) 年级
     * @param classNo (optional) 班级
     * @param paidStatus (optional) 付费状态
     * @param phoneNumber (optional) 电话号码
     * @param name (optional) 姓名
     * @param sorting (optional) Sorting information.
    Should include sorting field and optionally a direction (ASC or DESC)
    Can contain more than one field separated by comma (,).
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPagedFaceTempletePaid(tenantId: number | undefined, gradeNo: number | null | undefined, classNo: number | null | undefined, paidStatus: PaidStatus | undefined, phoneNumber: string | null | undefined, name: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<FaceTempletePaidDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FaceTemplete/GetPagedFaceTempletePaid?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (gradeNo !== undefined && gradeNo !== null)
            url_ += "gradeNo=" + encodeURIComponent("" + gradeNo) + "&";
        if (classNo !== undefined && classNo !== null)
            url_ += "classNo=" + encodeURIComponent("" + classNo) + "&";
        if (paidStatus === null)
            throw new Error("The parameter 'paidStatus' cannot be null.");
        else if (paidStatus !== undefined)
            url_ += "paidStatus=" + encodeURIComponent("" + paidStatus) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedFaceTempletePaid(_response);
        });
    }

    protected processGetPagedFaceTempletePaid(response: AxiosResponse): Promise<FaceTempletePaidDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FaceTempletePaidDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FaceTempletePaidDtoPagedResultDto>(<any>null);
    }

    /**
     * 根据FaceTempleteId获取详细信息
     * @param id (optional) 
     * @return Success
     */
    getFaceTempletePaidDetail(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<FaceTempletePaidDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/FaceTemplete/GetFaceTempletePaidDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFaceTempletePaidDetail(_response);
        });
    }

    protected processGetFaceTempletePaidDetail(response: AxiosResponse): Promise<FaceTempletePaidDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FaceTempletePaidDetailDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FaceTempletePaidDetailDto>(<any>null);
    }

    /**
     * 根据FaceTempleteId获取订单详细信息
     * @param id (optional) 
     * @return Success
     */
    getFaceTempletePaidOrderDetail(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<FaceTempletePaidOrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/FaceTemplete/GetFaceTempletePaidOrderDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFaceTempletePaidOrderDetail(_response);
        });
    }

    protected processGetFaceTempletePaidOrderDetail(response: AxiosResponse): Promise<FaceTempletePaidOrderDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FaceTempletePaidOrderDetailDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FaceTempletePaidOrderDetailDto>(<any>null);
    }

    /**
     * 更新学生会员
     * @param body (optional) 
     * @return Success
     */
    updateFaceTempleteVipType(body: UpdateFaceTempleteVipTypeInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/FaceTemplete/UpdateFaceTempleteVipType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFaceTempleteVipType(_response);
        });
    }

    protected processUpdateFaceTempleteVipType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取学生充值记录分页列表
     * @param faceTempleteId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPagedFaceTempleteVipPaymentRecord(faceTempleteId: number | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<VipPaymentRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FaceTemplete/GetPagedFaceTempleteVipPaymentRecord?";
        if (faceTempleteId === null)
            throw new Error("The parameter 'faceTempleteId' cannot be null.");
        else if (faceTempleteId !== undefined)
            url_ += "faceTempleteId=" + encodeURIComponent("" + faceTempleteId) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedFaceTempleteVipPaymentRecord(_response);
        });
    }

    protected processGetPagedFaceTempleteVipPaymentRecord(response: AxiosResponse): Promise<VipPaymentRecordDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VipPaymentRecordDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VipPaymentRecordDtoPagedResultDto>(<any>null);
    }

    /**
     * 获取学生家长绑定微信电话的情况
     * @param tenantId (optional) 学校Id
     * @param studentName (optional) 姓名
     * @param gradeNo (optional) 年级
     * @param classNo (optional) 班级
     * @param bangdingY (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWxPhoneParent(tenantId: number | null | undefined, studentName: string | null | undefined, gradeNo: number | null | undefined, classNo: number | null | undefined, bangdingY: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<WxPhoneParentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FaceTemplete/GetWxPhoneParent?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (studentName !== undefined && studentName !== null)
            url_ += "studentName=" + encodeURIComponent("" + studentName) + "&";
        if (gradeNo !== undefined && gradeNo !== null)
            url_ += "gradeNo=" + encodeURIComponent("" + gradeNo) + "&";
        if (classNo !== undefined && classNo !== null)
            url_ += "classNo=" + encodeURIComponent("" + classNo) + "&";
        if (bangdingY !== undefined && bangdingY !== null)
            url_ += "bangdingY=" + encodeURIComponent("" + bangdingY) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWxPhoneParent(_response);
        });
    }

    protected processGetWxPhoneParent(response: AxiosResponse): Promise<WxPhoneParentDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WxPhoneParentDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WxPhoneParentDtoPagedResultDto>(<any>null);
    }

    /**
     * 上方统计
     * @param tenantId (optional) 学校Id
     * @param studentName (optional) 姓名
     * @param gradeNo (optional) 年级
     * @param classNo (optional) 班级
     * @param bangdingY (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWxPhoneParentStatic(tenantId: number | null | undefined, studentName: string | null | undefined, gradeNo: number | null | undefined, classNo: number | null | undefined, bangdingY: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<WxPhoneParentStatic> {
        let url_ = this.baseUrl + "/api/services/app/FaceTemplete/GetWxPhoneParentStatic?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (studentName !== undefined && studentName !== null)
            url_ += "studentName=" + encodeURIComponent("" + studentName) + "&";
        if (gradeNo !== undefined && gradeNo !== null)
            url_ += "gradeNo=" + encodeURIComponent("" + gradeNo) + "&";
        if (classNo !== undefined && classNo !== null)
            url_ += "classNo=" + encodeURIComponent("" + classNo) + "&";
        if (bangdingY !== undefined && bangdingY !== null)
            url_ += "bangdingY=" + encodeURIComponent("" + bangdingY) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWxPhoneParentStatic(_response);
        });
    }

    protected processGetWxPhoneParentStatic(response: AxiosResponse): Promise<WxPhoneParentStatic> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WxPhoneParentStatic.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WxPhoneParentStatic>(<any>null);
    }
}

export class MemberPushSettingService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取所有学校设置
     * @param schoolName (optional) 姓名
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettings(schoolName: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<MemberPushSettingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberPushSetting/GetAllSettings?";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSettings(_response);
        });
    }

    protected processGetAllSettings(response: AxiosResponse): Promise<MemberPushSettingDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MemberPushSettingDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MemberPushSettingDtoPagedResultDto>(<any>null);
    }

    /**
     * 更新设置
     * @param body (optional) 
     * @return Success
     */
    updateMemberPushSetting(body: MemberPushSettingDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberPushSetting/UpdateMemberPushSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberPushSetting(_response);
        });
    }

    protected processUpdateMemberPushSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 开启或者关闭设置
     * @param body (optional) 
     * @return Success
     */
    openOrCloseSetting(body: Int32EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberPushSetting/OpenOrCloseSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOpenOrCloseSetting(_response);
        });
    }

    protected processOpenOrCloseSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class OderService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 创建订单
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Oder/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDto>(<any>null);
    }

    /**
     * 删除订单
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Oder/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取订单列表
     * @param orderNumber (optional) 订单号
     * @param orderRecordState (optional) 订单状态
     * @param companyNumber (optional) 物流单号
     * @param receName (optional) 收货人姓名
     * @param receMobile (optional) 收货人电话
     * @param createTime (optional) 下单时间
     * @param createTime2 (optional) 下单时间
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(orderNumber: string | null | undefined, orderRecordState: OrderState | undefined, companyNumber: string | null | undefined, receName: string | null | undefined, receMobile: string | null | undefined, createTime: moment.Moment | null | undefined, createTime2: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Oder/GetAll?";
        if (orderNumber !== undefined && orderNumber !== null)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (orderRecordState === null)
            throw new Error("The parameter 'orderRecordState' cannot be null.");
        else if (orderRecordState !== undefined)
            url_ += "orderRecordState=" + encodeURIComponent("" + orderRecordState) + "&";
        if (companyNumber !== undefined && companyNumber !== null)
            url_ += "companyNumber=" + encodeURIComponent("" + companyNumber) + "&";
        if (receName !== undefined && receName !== null)
            url_ += "receName=" + encodeURIComponent("" + receName) + "&";
        if (receMobile !== undefined && receMobile !== null)
            url_ += "receMobile=" + encodeURIComponent("" + receMobile) + "&";
        if (createTime !== undefined && createTime !== null)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&";
        if (createTime2 !== undefined && createTime2 !== null)
            url_ += "createTime2=" + encodeURIComponent(createTime2 ? "" + createTime2.toJSON() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<OrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDtoPagedResultDto>(<any>null);
    }

    /**
     * 获取订单明细
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Oder/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDto>(<any>null);
    }

    /**
     * 订单更新（网页端用不上）
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Oder/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDto>(<any>null);
    }

    /**
     * 物流管理（发货时下拉显示）
     * @return Success
     */
    getTransportList(  cancelToken?: CancelToken | undefined): Promise<TransportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Oder/GetTransportList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTransportList(_response);
        });
    }

    protected processGetTransportList(response: AxiosResponse): Promise<TransportDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TransportDto[]>(<any>null);
    }

    /**
     * 订单发货
     * @param body (optional) 发货参数
     * @return Success
     */
    setOrderDelivery(body: OrderDeliveryInput | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Oder/SetOrderDelivery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOrderDelivery(_response);
        });
    }

    protected processSetOrderDelivery(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 订单状态统计页面
     * @return Success
     */
    getOrderStatistics(  cancelToken?: CancelToken | undefined): Promise<OrderStatisticDto> {
        let url_ = this.baseUrl + "/api/services/app/Oder/GetOrderStatistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderStatistics(_response);
        });
    }

    protected processGetOrderStatistics(response: AxiosResponse): Promise<OrderStatisticDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderStatisticDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderStatisticDto>(<any>null);
    }

    /**
     * 退货信息获取
     * @param orderNumber (optional) 订单号
     * @return Success
     */
    getOrderReturn(orderNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<OrderReturnDto> {
        let url_ = this.baseUrl + "/api/services/app/Oder/GetOrderReturn?";
        if (orderNumber !== undefined && orderNumber !== null)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderReturn(_response);
        });
    }

    protected processGetOrderReturn(response: AxiosResponse): Promise<OrderReturnDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderReturnDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderReturnDto>(<any>null);
    }

    /**
     * 订单状态改变接口
     * @param body (optional) 取消参数
     * @return Success
     */
    setOrderCancel(body: OrderCancelInput | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Oder/SetOrderCancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOrderCancel(_response);
        });
    }

    protected processSetOrderCancel(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 拒绝退订
     * @param body (optional) 
     * @return Success
     */
    setOrderRefuse(body: OrderRefuseInput | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Oder/SetOrderRefuse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOrderRefuse(_response);
        });
    }

    protected processSetOrderRefuse(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 将订单状态Enum转换为list
     * @return Success
     */
    getOrderStateData(  cancelToken?: CancelToken | undefined): Promise<{ [key: string]: StringStringTuple; }> {
        let url_ = this.baseUrl + "/api/services/app/Oder/getOrderStateData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderStateData(_response);
        });
    }

    protected processGetOrderStateData(response: AxiosResponse): Promise<{ [key: string]: StringStringTuple; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key] ? StringStringTuple.fromJS(resultData200[key]) : new StringStringTuple();
                }
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: StringStringTuple; }>(<any>null);
    }

    /**
     * 获取快递测试
     * @param body (optional) 
     * @return Success
     */
    queryTrack(body: TrackInput | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/services/app/Oder/QueryTrack";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryTrack(_response);
        });
    }

    protected processQueryTrack(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class OperationPointsService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取当前登录教师的个人积分情况以及积分总分
     * @param tenantId (optional) 学校ID
     * @param name (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOperationPoints(tenantId: number | null | undefined, name: string | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationPointsDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationPoints/GetOperationPoints?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOperationPoints(_response);
        });
    }

    protected processGetOperationPoints(response: AxiosResponse): Promise<OperationPointsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperationPointsDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationPointsDto>(<any>null);
    }

    /**
     * 获取这个教师的所有积分数据
     * @param userId (optional) 学校ID
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDefailPoints(userId: number | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationPointsDetailItemPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationPoints/GetDefailPoints?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefailPoints(_response);
        });
    }

    protected processGetDefailPoints(response: AxiosResponse): Promise<OperationPointsDetailItemPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OperationPointsDetailItemPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationPointsDetailItemPagedResultDto>(<any>null);
    }

    /**
     * 获取这个学校的规则使用,如果没有插入默认数据
     * @param id (optional) 
     * @return Success
     */
    getRuleUserReamark(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<RuleUserReamarkDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationPoints/GetRuleUserReamark?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRuleUserReamark(_response);
        });
    }

    protected processGetRuleUserReamark(response: AxiosResponse): Promise<RuleUserReamarkDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RuleUserReamarkDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleUserReamarkDto>(<any>null);
    }

    /**
     * 更改学校的使用规则
     * @param body (optional) 
     * @return Success
     */
    updateRuleUserReamark(body: RuleUserReamarkDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationPoints/UpdateRuleUserReamark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRuleUserReamark(_response);
        });
    }

    protected processUpdateRuleUserReamark(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class OperationsManagementService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 创建运维人员
     * @param body (optional) 
     * @return Success
     */
    createOperations(body: CreateOperationsInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationsManagement/CreateOperations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOperations(_response);
        });
    }

    protected processCreateOperations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 提交运维人员运维的相关学校
     * @param body (optional) 
     * @return Success
     */
    createTenantWorkUserRelationship(body: CreateTenantWorkUserRelationshipInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationsManagement/CreateTenantWorkUserRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenantWorkUserRelationship(_response);
        });
    }

    protected processCreateTenantWorkUserRelationship(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取编辑详情
     * @param id (optional) 
     * @return Success
     */
    getTenantWorkUserRelationship(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantWorkUserRelationshipDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationsManagement/GetTenantWorkUserRelationship?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantWorkUserRelationship(_response);
        });
    }

    protected processGetTenantWorkUserRelationship(response: AxiosResponse): Promise<TenantWorkUserRelationshipDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantWorkUserRelationshipDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantWorkUserRelationshipDto>(<any>null);
    }

    /**
     * 删除运维人员
     * @param id (optional) 
     * @return Success
     */
    deleteOperations(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OperationsManagement/DeleteOperations?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOperations(_response);
        });
    }

    protected processDeleteOperations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 运维人员列表
     * @param userName (optional) 学校名称
     * @param phoneNumber (optional) 用户电话
     * @param tenantName (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTenantWorkUserRelationshipPage(userName: string | null | undefined, phoneNumber: string | null | undefined, tenantName: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantWorkUserRelationshipPageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationsManagement/GetTenantWorkUserRelationshipPage?";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantWorkUserRelationshipPage(_response);
        });
    }

    protected processGetTenantWorkUserRelationshipPage(response: AxiosResponse): Promise<TenantWorkUserRelationshipPageDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantWorkUserRelationshipPageDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantWorkUserRelationshipPageDtoPagedResultDto>(<any>null);
    }

    /**
     * 0 获取所有学校  1   获取还没有别运维的学校
     * @param type (optional) 
     * @return Success
     */
    getCanWorkSchools(type: number | undefined , cancelToken?: CancelToken | undefined): Promise<SimpleTenantDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationsManagement/GetCanWorkSchools?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCanWorkSchools(_response);
        });
    }

    protected processGetCanWorkSchools(response: AxiosResponse): Promise<SimpleTenantDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SimpleTenantDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleTenantDtoListResultDto>(<any>null);
    }

    /**
     * 创建运维人员的时候，查询用
     * @param phone (optional) 
     * @return Success
     */
    getUserByPhone(phone: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetWorkUserDto> {
        let url_ = this.baseUrl + "/api/services/app/OperationsManagement/GetUserByPhone?";
        if (phone !== undefined && phone !== null)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserByPhone(_response);
        });
    }

    protected processGetUserByPhone(response: AxiosResponse): Promise<GetWorkUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWorkUserDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWorkUserDto>(<any>null);
    }

    /**
     * 获取每一天的统计情况，当天是事实数据，之前的是十点的定时数据
     * @param dateTimeStr (optional) 
     * @param responsibleName (optional) 学校负责人姓名
     * @param schoolName (optional) 学校名称
     * @param tenantRegion (optional) 
     * @param isShowOffDevice (optional) 是否显示有人打卡 也有设备不在线的学校
     * @param schoolType (optional) 
     * @return Success
     */
    getStudentDailyAttendanceStaticEveryDay(dateTimeStr: string | null | undefined, responsibleName: string | null | undefined, schoolName: string | null | undefined, tenantRegion: string | null | undefined, isShowOffDevice: boolean | null | undefined, schoolType: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<StudentDailyAttendanceStaticEveryDay[]> {
        let url_ = this.baseUrl + "/api/services/app/OperationsManagement/GetStudentDailyAttendanceStaticEveryDay?";
        if (dateTimeStr !== undefined && dateTimeStr !== null)
            url_ += "dateTimeStr=" + encodeURIComponent("" + dateTimeStr) + "&";
        if (responsibleName !== undefined && responsibleName !== null)
            url_ += "responsibleName=" + encodeURIComponent("" + responsibleName) + "&";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (tenantRegion !== undefined && tenantRegion !== null)
            url_ += "tenantRegion=" + encodeURIComponent("" + tenantRegion) + "&";
        if (isShowOffDevice !== undefined && isShowOffDevice !== null)
            url_ += "isShowOffDevice=" + encodeURIComponent("" + isShowOffDevice) + "&";
        if (schoolType !== undefined && schoolType !== null)
            url_ += "schoolType=" + encodeURIComponent("" + schoolType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudentDailyAttendanceStaticEveryDay(_response);
        });
    }

    protected processGetStudentDailyAttendanceStaticEveryDay(response: AxiosResponse): Promise<StudentDailyAttendanceStaticEveryDay[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StudentDailyAttendanceStaticEveryDay.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentDailyAttendanceStaticEveryDay[]>(<any>null);
    }
}

export class OrderDetailService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrderDetailDto | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OrderDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDetailDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param name (optional) Name
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<OrderDetailDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDetailDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrderDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDetailDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOrderDetailDto | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OrderDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderDetailDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailDto>(<any>null);
    }
}

export class OrderRecordService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取订单汇总数据
     * @return Success
     */
    getOrderRecordSummary(  cancelToken?: CancelToken | undefined): Promise<OrderRecordSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetOrderRecordSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderRecordSummary(_response);
        });
    }

    protected processGetOrderRecordSummary(response: AxiosResponse): Promise<OrderRecordSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRecordSummaryDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRecordSummaryDto>(<any>null);
    }

    /**
     * 获取学校排行
     * @return Success
     */
    getSchoolRank(  cancelToken?: CancelToken | undefined): Promise<SchoolRankDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetSchoolRank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchoolRank(_response);
        });
    }

    protected processGetSchoolRank(response: AxiosResponse): Promise<SchoolRankDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SchoolRankDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SchoolRankDtoListResultDto>(<any>null);
    }

    /**
     * 获取订单分页列表
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 学校Id
     * @param orderNo (optional) 订单编号
     * @param orderUserNameOrPhoneNumber (optional) 订单用户姓名或电话号码
     * @param faceTemplateName (optional) 学生姓名
     * @param gradeNo (optional) 学生年级
     * @param classNo (optional) 学生班级
     * @param startDate (optional) 下单开始日期
     * @param endDate (optional) 下单截止日期
     * @param startPayDate (optional) 支付开始日期
     * @param endPayDate (optional) 支付截止日期
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param orderRecordState (optional) 订单状态
     * @param orderRecordWayType (optional) 支付方式
     * @param sorting (optional) 
     * @return Success
     */
    getPagedOrderRecordFaceTemplete(maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | null | undefined, orderNo: string | null | undefined, orderUserNameOrPhoneNumber: string | null | undefined, faceTemplateName: string | null | undefined, gradeNo: number | null | undefined, classNo: number | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, startPayDate: moment.Moment | null | undefined, endPayDate: moment.Moment | null | undefined, minAmount: number | null | undefined, maxAmount: number | null | undefined, orderRecordState: OrderRecordState | undefined, orderRecordWayType: OrderRecordWayType | undefined, sorting: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<OrderRecordFaceTempleteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetPagedOrderRecordFaceTemplete?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (orderNo !== undefined && orderNo !== null)
            url_ += "orderNo=" + encodeURIComponent("" + orderNo) + "&";
        if (orderUserNameOrPhoneNumber !== undefined && orderUserNameOrPhoneNumber !== null)
            url_ += "orderUserNameOrPhoneNumber=" + encodeURIComponent("" + orderUserNameOrPhoneNumber) + "&";
        if (faceTemplateName !== undefined && faceTemplateName !== null)
            url_ += "faceTemplateName=" + encodeURIComponent("" + faceTemplateName) + "&";
        if (gradeNo !== undefined && gradeNo !== null)
            url_ += "gradeNo=" + encodeURIComponent("" + gradeNo) + "&";
        if (classNo !== undefined && classNo !== null)
            url_ += "classNo=" + encodeURIComponent("" + classNo) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (startPayDate !== undefined && startPayDate !== null)
            url_ += "startPayDate=" + encodeURIComponent(startPayDate ? "" + startPayDate.toJSON() : "") + "&";
        if (endPayDate !== undefined && endPayDate !== null)
            url_ += "endPayDate=" + encodeURIComponent(endPayDate ? "" + endPayDate.toJSON() : "") + "&";
        if (minAmount !== undefined && minAmount !== null)
            url_ += "minAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount !== undefined && maxAmount !== null)
            url_ += "maxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (orderRecordState === null)
            throw new Error("The parameter 'orderRecordState' cannot be null.");
        else if (orderRecordState !== undefined)
            url_ += "orderRecordState=" + encodeURIComponent("" + orderRecordState) + "&";
        if (orderRecordWayType === null)
            throw new Error("The parameter 'orderRecordWayType' cannot be null.");
        else if (orderRecordWayType !== undefined)
            url_ += "orderRecordWayType=" + encodeURIComponent("" + orderRecordWayType) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedOrderRecordFaceTemplete(_response);
        });
    }

    protected processGetPagedOrderRecordFaceTemplete(response: AxiosResponse): Promise<OrderRecordFaceTempleteDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRecordFaceTempleteDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRecordFaceTempleteDtoPagedResultDto>(<any>null);
    }

    /**
     * 获取导出订单列表
     * @param tenantId (optional) 学校Id
     * @param orderNo (optional) 订单编号
     * @param orderUserNameOrPhoneNumber (optional) 订单用户姓名或电话号码
     * @param faceTemplateName (optional) 学生姓名
     * @param gradeNo (optional) 学生年级
     * @param classNo (optional) 学生班级
     * @param startDate (optional) 下单开始日期
     * @param endDate (optional) 下单截止日期
     * @param startPayDate (optional) 支付开始日期
     * @param endPayDate (optional) 支付截止日期
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param orderRecordState (optional) 订单状态
     * @param orderRecordWayType (optional) 支付方式
     * @param sorting (optional) 
     * @return Success
     */
    getOrderRecordFaceTemplateForExport(tenantId: number | null | undefined, orderNo: string | null | undefined, orderUserNameOrPhoneNumber: string | null | undefined, faceTemplateName: string | null | undefined, gradeNo: number | null | undefined, classNo: number | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, startPayDate: moment.Moment | null | undefined, endPayDate: moment.Moment | null | undefined, minAmount: number | null | undefined, maxAmount: number | null | undefined, orderRecordState: OrderRecordState | undefined, orderRecordWayType: OrderRecordWayType | undefined, sorting: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<ExportOrderRecordFaceTemplateDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetOrderRecordFaceTemplateForExport?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (orderNo !== undefined && orderNo !== null)
            url_ += "orderNo=" + encodeURIComponent("" + orderNo) + "&";
        if (orderUserNameOrPhoneNumber !== undefined && orderUserNameOrPhoneNumber !== null)
            url_ += "orderUserNameOrPhoneNumber=" + encodeURIComponent("" + orderUserNameOrPhoneNumber) + "&";
        if (faceTemplateName !== undefined && faceTemplateName !== null)
            url_ += "faceTemplateName=" + encodeURIComponent("" + faceTemplateName) + "&";
        if (gradeNo !== undefined && gradeNo !== null)
            url_ += "gradeNo=" + encodeURIComponent("" + gradeNo) + "&";
        if (classNo !== undefined && classNo !== null)
            url_ += "classNo=" + encodeURIComponent("" + classNo) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (startPayDate !== undefined && startPayDate !== null)
            url_ += "startPayDate=" + encodeURIComponent(startPayDate ? "" + startPayDate.toJSON() : "") + "&";
        if (endPayDate !== undefined && endPayDate !== null)
            url_ += "endPayDate=" + encodeURIComponent(endPayDate ? "" + endPayDate.toJSON() : "") + "&";
        if (minAmount !== undefined && minAmount !== null)
            url_ += "minAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount !== undefined && maxAmount !== null)
            url_ += "maxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (orderRecordState === null)
            throw new Error("The parameter 'orderRecordState' cannot be null.");
        else if (orderRecordState !== undefined)
            url_ += "orderRecordState=" + encodeURIComponent("" + orderRecordState) + "&";
        if (orderRecordWayType === null)
            throw new Error("The parameter 'orderRecordWayType' cannot be null.");
        else if (orderRecordWayType !== undefined)
            url_ += "orderRecordWayType=" + encodeURIComponent("" + orderRecordWayType) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderRecordFaceTemplateForExport(_response);
        });
    }

    protected processGetOrderRecordFaceTemplateForExport(response: AxiosResponse): Promise<ExportOrderRecordFaceTemplateDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportOrderRecordFaceTemplateDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportOrderRecordFaceTemplateDtoListResultDto>(<any>null);
    }

    /**
     * 获取订单支付数量
     * @return Success
     */
    getOrderRecordStateCount(  cancelToken?: CancelToken | undefined): Promise<OrderRecordStateCountDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetOrderRecordStateCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderRecordStateCount(_response);
        });
    }

    protected processGetOrderRecordStateCount(response: AxiosResponse): Promise<OrderRecordStateCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRecordStateCountDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRecordStateCountDto>(<any>null);
    }

    /**
     * 获取学校的广告位
     * @param id (optional) 
     * @return Success
     */
    getAdvertisingSpace(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<AdvertisingSpaceDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetAdvertisingSpace?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdvertisingSpace(_response);
        });
    }

    protected processGetAdvertisingSpace(response: AxiosResponse): Promise<AdvertisingSpaceDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdvertisingSpaceDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvertisingSpaceDto>(<any>null);
    }

    /**
     * 创建广告位
     * @param body (optional) 
     * @return Success
     */
    createAdvertisingSpace(body: AdvertisingSpaceInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/CreateAdvertisingSpace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAdvertisingSpace(_response);
        });
    }

    protected processCreateAdvertisingSpace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 编辑广告位
     * @param body (optional) 
     * @return Success
     */
    updateAdvertisingSpace(body: AdvertisingSpaceInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/UpdateAdvertisingSpace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAdvertisingSpace(_response);
        });
    }

    protected processUpdateAdvertisingSpace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除广告位
     * @param id (optional) 
     * @return Success
     */
    deleteAdvertisingSpace(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/DeleteAdvertisingSpace?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAdvertisingSpace(_response);
        });
    }

    protected processDeleteAdvertisingSpace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 更新广告的排序
     * @param body (optional) 
     * @return Success
     */
    updateAdvertisingSpaceOrder(body: UpateOrderInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/UpdateAdvertisingSpaceOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAdvertisingSpaceOrder(_response);
        });
    }

    protected processUpdateAdvertisingSpaceOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取所有学校联通登记的情况 按照学校为单位
     * @param schoolName (optional) 学校名称
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderRecordRegistration(schoolName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderRecordRegistrationDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetOrderRecordRegistration?";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderRecordRegistration(_response);
        });
    }

    protected processGetOrderRecordRegistration(response: AxiosResponse): Promise<OrderRecordRegistrationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRecordRegistrationDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRecordRegistrationDto>(<any>null);
    }

    /**
     * 根据学校获取学校的联通登记的情况
     * @param name (optional) 名称
     * @param schoolName (optional) 学校名称
     * @param gradeNo (optional) 年级
     * @param classNo (optional) 班级
     * @param majorName (optional) 专业名称
     * @param majorClassNo (optional) 专业班级号
    当为职中或者非12年教育的班级时，使用该班级号代替ClassNo
     * @param registrationType (optional) 登记类型
     * @param orderRecordState (optional) 
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param sorting (optional) 
     * @param type (optional) 详细请求分类
     * @param tenantId (optional) 学校ID
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderRecordRegistrationBySchoolId(name: string | null | undefined, schoolName: string | null | undefined, gradeNo: number | null | undefined, classNo: number | null | undefined, majorName: string | null | undefined, majorClassNo: string | null | undefined, registrationType: RegistrationType | undefined, orderRecordState: OrderRecordState | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, sorting: string | null | undefined, type: number | null | undefined, tenantId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderRecordRegistrationBySchoolIdDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetOrderRecordRegistrationBySchoolId?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (gradeNo !== undefined && gradeNo !== null)
            url_ += "gradeNo=" + encodeURIComponent("" + gradeNo) + "&";
        if (classNo !== undefined && classNo !== null)
            url_ += "classNo=" + encodeURIComponent("" + classNo) + "&";
        if (majorName !== undefined && majorName !== null)
            url_ += "majorName=" + encodeURIComponent("" + majorName) + "&";
        if (majorClassNo !== undefined && majorClassNo !== null)
            url_ += "majorClassNo=" + encodeURIComponent("" + majorClassNo) + "&";
        if (registrationType === null)
            throw new Error("The parameter 'registrationType' cannot be null.");
        else if (registrationType !== undefined)
            url_ += "registrationType=" + encodeURIComponent("" + registrationType) + "&";
        if (orderRecordState === null)
            throw new Error("The parameter 'orderRecordState' cannot be null.");
        else if (orderRecordState !== undefined)
            url_ += "orderRecordState=" + encodeURIComponent("" + orderRecordState) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderRecordRegistrationBySchoolId(_response);
        });
    }

    protected processGetOrderRecordRegistrationBySchoolId(response: AxiosResponse): Promise<OrderRecordRegistrationBySchoolIdDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRecordRegistrationBySchoolIdDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRecordRegistrationBySchoolIdDto>(<any>null);
    }

    /**
     * 获取所有学校的数据
     * @param name (optional) 名称
     * @param schoolName (optional) 学校名称
     * @param gradeNo (optional) 年级
     * @param classNo (optional) 班级
     * @param majorName (optional) 专业名称
     * @param majorClassNo (optional) 专业班级号
    当为职中或者非12年教育的班级时，使用该班级号代替ClassNo
     * @param registrationType (optional) 登记类型
     * @param orderRecordState (optional) 
     * @param startTime (optional) 开始时间
     * @param endTime (optional) 结束时间
     * @param sorting (optional) 
     * @param type (optional) 详细请求分类
     * @param tenantId (optional) 学校ID
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOrderRecordRegistrationAll(name: string | null | undefined, schoolName: string | null | undefined, gradeNo: number | null | undefined, classNo: number | null | undefined, majorName: string | null | undefined, majorClassNo: string | null | undefined, registrationType: RegistrationType | undefined, orderRecordState: OrderRecordState | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined, sorting: string | null | undefined, type: number | null | undefined, tenantId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderRecordRegistrationAllDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetOrderRecordRegistrationAll?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (gradeNo !== undefined && gradeNo !== null)
            url_ += "gradeNo=" + encodeURIComponent("" + gradeNo) + "&";
        if (classNo !== undefined && classNo !== null)
            url_ += "classNo=" + encodeURIComponent("" + classNo) + "&";
        if (majorName !== undefined && majorName !== null)
            url_ += "majorName=" + encodeURIComponent("" + majorName) + "&";
        if (majorClassNo !== undefined && majorClassNo !== null)
            url_ += "majorClassNo=" + encodeURIComponent("" + majorClassNo) + "&";
        if (registrationType === null)
            throw new Error("The parameter 'registrationType' cannot be null.");
        else if (registrationType !== undefined)
            url_ += "registrationType=" + encodeURIComponent("" + registrationType) + "&";
        if (orderRecordState === null)
            throw new Error("The parameter 'orderRecordState' cannot be null.");
        else if (orderRecordState !== undefined)
            url_ += "orderRecordState=" + encodeURIComponent("" + orderRecordState) + "&";
        if (startTime !== undefined && startTime !== null)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined && endTime !== null)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderRecordRegistrationAll(_response);
        });
    }

    protected processGetOrderRecordRegistrationAll(response: AxiosResponse): Promise<OrderRecordRegistrationAllDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRecordRegistrationAllDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRecordRegistrationAllDto>(<any>null);
    }

    /**
     * 办理订单
     * @param body (optional) 
     * @return Success
     */
    updateOrderRecordDeal(body: UpdateOrderRecordStateInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/UpdateOrderRecordDeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderRecordDeal(_response);
        });
    }

    protected processUpdateOrderRecordDeal(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 联通退订 和审批退订 修改状态 生成流水
     * @param body (optional) 
     * @return Success
     */
    updateOrderRecordUnsubscribe(body: OrderRecordUnsubscribeInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/UpdateOrderRecordUnsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderRecordUnsubscribe(_response);
        });
    }

    protected processUpdateOrderRecordUnsubscribe(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改会员天数
     * @param body (optional) 
     * @return Success
     */
    updateVipExpireDate(body: UpdateVipExpireDateInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/UpdateVipExpireDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVipExpireDate(_response);
        });
    }

    protected processUpdateVipExpireDate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 创建沟通记录
     * @param body (optional) 
     * @return Success
     */
    cteateCommunicationRecord(body: CommunicationRecordInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/CteateCommunicationRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCteateCommunicationRecord(_response);
        });
    }

    protected processCteateCommunicationRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取沟通记录列表
     * @param tenantId (optional) 学校ID
     * @param id (optional) 订单ID
     * @return Success
     */
    getCommunicationRecord(tenantId: number | undefined, id: string | undefined , cancelToken?: CancelToken | undefined): Promise<CommunicationRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetCommunicationRecord?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommunicationRecord(_response);
        });
    }

    protected processGetCommunicationRecord(response: AxiosResponse): Promise<CommunicationRecordDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationRecordDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunicationRecordDto[]>(<any>null);
    }

    /**
     * 获取订单详情和退订消息
     * @param id (optional) 
     * @return Success
     */
    getOrderRecordDetail(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<OrderRecordDetail> {
        let url_ = this.baseUrl + "/api/services/app/OrderRecord/GetOrderRecordDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderRecordDetail(_response);
        });
    }

    protected processGetOrderRecordDetail(response: AxiosResponse): Promise<OrderRecordDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderRecordDetail.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderRecordDetail>(<any>null);
    }
}

export class OrganizationUnitService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取所有组织
     * @return Success
     */
    getOrganizationUnits(  cancelToken?: CancelToken | undefined): Promise<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationUnits(_response);
        });
    }

    protected processGetOrganizationUnits(response: AxiosResponse): Promise<OrganizationUnitDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrganizationUnitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param displayName (optional) 显示名称
     * @param parentId (optional) 
     * @param parentDisplayName (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(displayName: string | null | undefined, parentId: number | null | undefined, parentDisplayName: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrganizationUnitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAll?";
        if (displayName !== undefined && displayName !== null)
            url_ += "displayName=" + encodeURIComponent("" + displayName) + "&";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (parentDisplayName !== undefined && parentDisplayName !== null)
            url_ += "parentDisplayName=" + encodeURIComponent("" + parentDisplayName) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<OrganizationUnitDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUnitDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrganizationUnitDto | undefined , cancelToken?: CancelToken | undefined): Promise<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OrganizationUnitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OrganizationUnitDto | undefined , cancelToken?: CancelToken | undefined): Promise<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OrganizationUnitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProductService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 添加商品
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProductDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto>(<any>null);
    }

    /**
     * 修改产品状态
     * @param body (optional) 
     * @return Success
     */
    productSwitchChange(body: ProductDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/ProductSwitchChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProductSwitchChange(_response);
        });
    }

    protected processProductSwitchChange(response: AxiosResponse): Promise<ProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto>(<any>null);
    }

    /**
     * 删除某个产品
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询产品列表
     * @param name (optional) Name
     * @param productCategoryId (optional) 
     * @param createTime (optional) 上传时间1
     * @param createTime2 (optional) 上传时间2
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, productCategoryId: string | null | undefined, createTime: moment.Moment | null | undefined, createTime2: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (productCategoryId !== undefined && productCategoryId !== null)
            url_ += "productCategoryId=" + encodeURIComponent("" + productCategoryId) + "&";
        if (createTime !== undefined && createTime !== null)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&";
        if (createTime2 !== undefined && createTime2 !== null)
            url_ += "createTime2=" + encodeURIComponent(createTime2 ? "" + createTime2.toJSON() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProductDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDtoPagedResultDto>(<any>null);
    }

    /**
     * 查询产品明细
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto>(<any>null);
    }

    /**
     * 更新产品
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProductDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ProductDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto>(<any>null);
    }

    /**
     * 商品服务类型列表
     * @return Success
     */
    getSalesServiceTypeList(  cancelToken?: CancelToken | undefined): Promise<SalesServiceTypeDtos[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetSalesServiceTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesServiceTypeList(_response);
        });
    }

    protected processGetSalesServiceTypeList(response: AxiosResponse): Promise<SalesServiceTypeDtos[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesServiceTypeDtos.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesServiceTypeDtos[]>(<any>null);
    }

    /**
     * 删除附件图片
     * @param id (optional) 
     * @return Success
     */
    deleteAttachment(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteAttachment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAttachment(_response);
        });
    }

    protected processDeleteAttachment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ProductCategoryService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 添加产品分类
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProductCategoryDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProductCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ProductCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductCategoryDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryDto>(<any>null);
    }

    /**
     * 删除产品分类
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除规格
     * @param id (optional) 
     * @return Success
     */
    deleteASpe(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/DeleteASpe?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteASpe(_response);
        });
    }

    protected processDeleteASpe(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 设置默认选中
     * @param body (optional) 
     * @return Success
     */
    defaultSelection(body: Int64EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/DefaultSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDefaultSelection(_response);
        });
    }

    protected processDefaultSelection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取键值对
     * @return Success
     */
    getAllProductCategory(  cancelToken?: CancelToken | undefined): Promise<ProductCategoryKeyVueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/GetAllProductCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllProductCategory(_response);
        });
    }

    protected processGetAllProductCategory(response: AxiosResponse): Promise<ProductCategoryKeyVueDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductCategoryKeyVueDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryKeyVueDto[]>(<any>null);
    }

    /**
     * @param name (optional) Name
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProductCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProductCategoryDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductCategoryDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryDtoPagedResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProductCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProductCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductCategoryDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryDto>(<any>null);
    }

    /**
     * 修改产品分类
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProductCategoryDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProductCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ProductCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductCategoryDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchChange(body: ProductCategoryDto | undefined , cancelToken?: CancelToken | undefined): Promise<ProductCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategory/SwitchChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchChange(_response);
        });
    }

    protected processSwitchChange(response: AxiosResponse): Promise<ProductCategoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductCategoryDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryDto>(<any>null);
    }
}

export class PromotionalOrderService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 创建订单
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePromotionalOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<PromotionalOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionalOrder/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PromotionalOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PromotionalOrderDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PromotionalOrderDto>(<any>null);
    }

    /**
     * 删除订单
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/PromotionalOrder/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取订单列表
     * @param orderNumber (optional) 订单号
     * @param orderRecordState (optional) 订单状态
     * @param companyNumber (optional) 物流单号
     * @param receName (optional) 收货人姓名
     * @param receMobile (optional) 收货人电话
     * @param createTime (optional) 下单时间
     * @param createTime2 (optional) 下单时间
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(orderNumber: string | null | undefined, orderRecordState: OrderState | undefined, companyNumber: string | null | undefined, receName: string | null | undefined, receMobile: string | null | undefined, createTime: moment.Moment | null | undefined, createTime2: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<PromotionalOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionalOrder/GetAll?";
        if (orderNumber !== undefined && orderNumber !== null)
            url_ += "orderNumber=" + encodeURIComponent("" + orderNumber) + "&";
        if (orderRecordState === null)
            throw new Error("The parameter 'orderRecordState' cannot be null.");
        else if (orderRecordState !== undefined)
            url_ += "orderRecordState=" + encodeURIComponent("" + orderRecordState) + "&";
        if (companyNumber !== undefined && companyNumber !== null)
            url_ += "companyNumber=" + encodeURIComponent("" + companyNumber) + "&";
        if (receName !== undefined && receName !== null)
            url_ += "receName=" + encodeURIComponent("" + receName) + "&";
        if (receMobile !== undefined && receMobile !== null)
            url_ += "receMobile=" + encodeURIComponent("" + receMobile) + "&";
        if (createTime !== undefined && createTime !== null)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&";
        if (createTime2 !== undefined && createTime2 !== null)
            url_ += "createTime2=" + encodeURIComponent(createTime2 ? "" + createTime2.toJSON() : "") + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PromotionalOrderDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PromotionalOrderDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PromotionalOrderDtoPagedResultDto>(<any>null);
    }

    /**
     * 获取订单明细
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<PromotionalOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionalOrder/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PromotionalOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PromotionalOrderDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PromotionalOrderDto>(<any>null);
    }

    /**
     * 订单更新（网页端用不上）
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePromotionalOrderDto | undefined , cancelToken?: CancelToken | undefined): Promise<PromotionalOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/PromotionalOrder/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<PromotionalOrderDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PromotionalOrderDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PromotionalOrderDto>(<any>null);
    }
}

export class RoleService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleListDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleListDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(  cancelToken?: CancelToken | undefined): Promise<FlatPermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<FlatPermissionDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlatPermissionDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlatPermissionDtoListResultDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleForEdit(_response);
        });
    }

    protected processGetRoleForEdit(response: AxiosResponse): Promise<GetRoleForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(<any>null);
    }

    /**
     * @param name (optional) 角色名称
     * @param displayName (optional) 显示名称
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, displayName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (displayName !== undefined && displayName !== null)
            url_ += "displayName=" + encodeURIComponent("" + displayName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<RoleDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoPagedResultDto>(<any>null);
    }
}

export class SchoolService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/School/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/School/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取所有学校
     * @return Success
     */
    getUserSchools(  cancelToken?: CancelToken | undefined): Promise<SimpleTenantDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/School/GetUserSchools";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSchools(_response);
        });
    }

    protected processGetUserSchools(response: AxiosResponse): Promise<SimpleTenantDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SimpleTenantDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleTenantDtoListResultDto>(<any>null);
    }

    /**
     * 获取学校的年级和班级
     * @param id (optional) 
     * @return Success
     */
    getTenantAllGrades(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<GradeClassesDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/School/GetTenantAllGrades?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantAllGrades(_response);
        });
    }

    protected processGetTenantAllGrades(response: AxiosResponse): Promise<GradeClassesDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GradeClassesDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GradeClassesDtoListResultDto>(<any>null);
    }

    /**
     * 修改学生工作人员是否显示
     * @param body (optional) 
     * @return Success
     */
    updateSchoolWorkerShow(body: Int32EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/School/UpdateSchoolWorkerShow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSchoolWorkerShow(_response);
        });
    }

    protected processUpdateSchoolWorkerShow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改学校报名二维码
     * @param body (optional) 
     * @return Success
     */
    updateSchoolSignCode(body: TenantDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/School/UpdateSchoolSignCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSchoolSignCode(_response);
        });
    }

    protected processUpdateSchoolSignCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 修改学校信息
     * @param body (optional) 
     * @return Success
     */
    updateSchoolTenant(body: CreateTenantDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/School/UpdateSchoolTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSchoolTenant(_response);
        });
    }

    protected processUpdateSchoolTenant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/School/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(<any>null);
    }

    /**
     * @param name (optional) Name
     * @param sorting (optional) 
     * @param isHaveSignCode (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, sorting: string | null | undefined, isHaveSignCode: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/School/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isHaveSignCode !== undefined && isHaveSignCode !== null)
            url_ += "isHaveSignCode=" + encodeURIComponent("" + isHaveSignCode) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<TenantDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDtoPagedResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTenantDto | undefined , cancelToken?: CancelToken | undefined): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/School/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TenantDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantDto>(<any>null);
    }
}

export class ScoreScanSettingService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 更新指定学校成绩查看设置
     * @param body (optional) 
     * @return Success
     */
    changeTenantScoreSetting(body: ChangScoreInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScoreScanSetting/ChangeTenantScoreSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeTenantScoreSetting(_response);
        });
    }

    protected processChangeTenantScoreSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取所有学校成绩查看设置
     * @param schoolName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTenantScoreSettings(schoolName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<ScoreSettingPageOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ScoreScanSetting/GetTenantScoreSettings?";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantScoreSettings(_response);
        });
    }

    protected processGetTenantScoreSettings(response: AxiosResponse): Promise<ScoreSettingPageOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScoreSettingPageOutDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScoreSettingPageOutDtoPagedResultDto>(<any>null);
    }
}

export class ServiceChargeConfigService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * @param tenantName (optional) 
     * @return Success
     */
    getAll(tenantName: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<ServiceChargeConfigDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceChargeConfig/GetAll?";
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ServiceChargeConfigDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceChargeConfigDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceChargeConfigDtoListResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ServiceChargeConfigDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceChargeConfig/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class SessionService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(  cancelToken?: CancelToken | undefined): Promise<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentLoginInformations(_response);
        });
    }

    protected processGetCurrentLoginInformations(response: AxiosResponse): Promise<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

export class SickLeaveVisitSettingService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取学校的晨雾晚间统计数据
     * @param province (optional) 省
     * @param city (optional) 市
     * @param district (optional) 区
     * @param tenantName (optional) 学校名称
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTenantDailyAttendanceInspectionReport(province: string | null | undefined, city: string | null | undefined, district: string[] | null | undefined, tenantName: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<DailyAttendanceInspectionReportDto> {
        let url_ = this.baseUrl + "/api/services/app/SickLeaveVisitSetting/GetTenantDailyAttendanceInspectionReport?";
        if (province !== undefined && province !== null)
            url_ += "province=" + encodeURIComponent("" + province) + "&";
        if (city !== undefined && city !== null)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (district !== undefined && district !== null)
            district && district.forEach(item => { url_ += "district=" + encodeURIComponent("" + item) + "&"; });
        if (tenantName !== undefined && tenantName !== null)
            url_ += "tenantName=" + encodeURIComponent("" + tenantName) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantDailyAttendanceInspectionReport(_response);
        });
    }

    protected processGetTenantDailyAttendanceInspectionReport(response: AxiosResponse): Promise<DailyAttendanceInspectionReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DailyAttendanceInspectionReportDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyAttendanceInspectionReportDto>(<any>null);
    }

    /**
     * 获取某一个学校的详细考勤情况
     * @param tenantId (optional) 
     * @param name (optional) 
     * @param attendanceSnapshotStatus (optional) 考勤状态
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDailyAttendanceInspectionReportSchool(tenantId: number | undefined, name: string | null | undefined, attendanceSnapshotStatus: StudentDailyAttendanceSnapshotStatus | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<DailyAttendanceInspectionReportSchoolDto> {
        let url_ = this.baseUrl + "/api/services/app/SickLeaveVisitSetting/GetDailyAttendanceInspectionReportSchool?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (attendanceSnapshotStatus === null)
            throw new Error("The parameter 'attendanceSnapshotStatus' cannot be null.");
        else if (attendanceSnapshotStatus !== undefined)
            url_ += "attendanceSnapshotStatus=" + encodeURIComponent("" + attendanceSnapshotStatus) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyAttendanceInspectionReportSchool(_response);
        });
    }

    protected processGetDailyAttendanceInspectionReportSchool(response: AxiosResponse): Promise<DailyAttendanceInspectionReportSchoolDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DailyAttendanceInspectionReportSchoolDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyAttendanceInspectionReportSchoolDto>(<any>null);
    }

    /**
     * 获取这个用户管理的所有相关地区
     * @return Success
     */
    getUserRegionLimit(  cancelToken?: CancelToken | undefined): Promise<OrganizationUnitsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SickLeaveVisitSetting/GetUserRegionLimit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRegionLimit(_response);
        });
    }

    protected processGetUserRegionLimit(response: AxiosResponse): Promise<OrganizationUnitsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitsDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitsDto[]>(<any>null);
    }

    /**
     * 获取地区统计数据
     * @return Success
     */
    getDailyAttendanceInspectionByPosition(  cancelToken?: CancelToken | undefined): Promise<DailyAttendanceInspectionByPosition> {
        let url_ = this.baseUrl + "/api/services/app/SickLeaveVisitSetting/GetDailyAttendanceInspectionByPosition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyAttendanceInspectionByPosition(_response);
        });
    }

    protected processGetDailyAttendanceInspectionByPosition(response: AxiosResponse): Promise<DailyAttendanceInspectionByPosition> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DailyAttendanceInspectionByPosition.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyAttendanceInspectionByPosition>(<any>null);
    }
}

export class UserService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取用户列表
     * @param name (optional) 姓名
     * @param userName (optional) 用户名
     * @param phoneNumber (optional) 电话号码
     * @param sorting (optional) Sorting information.
    Should include sorting field and optionally a direction (ASC or DESC)
    Can contain more than one field separated by comma (,).
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | null | undefined, userName: string | null | undefined, phoneNumber: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<UserDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDtoPagedResultDto>(<any>null);
    }

    /**
     * 创建登录用户
     * @param body (optional) 
     * @return Success
     */
    createUser(body: CreateUserInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 该用户管理的省市区
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEdcationPassion(body: CreateOrUpdateEdcationPassionInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateEdcationPassion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateEdcationPassion(_response);
        });
    }

    protected processCreateOrUpdateEdcationPassion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 查询地区
     * @return Success
     */
    getOrganizationUnits(  cancelToken?: CancelToken | undefined): Promise<OrganizationUnitsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationUnits(_response);
        });
    }

    protected processGetOrganizationUnits(response: AxiosResponse): Promise<OrganizationUnitsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitsDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationUnitsDto[]>(<any>null);
    }

    /**
     * 返回之前选择的数据
     * @param id (optional) 
     * @return Success
     */
    getSelectRegion(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserRegionLimit[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetSelectRegion?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectRegion(_response);
        });
    }

    protected processGetSelectRegion(response: AxiosResponse): Promise<UserRegionLimit[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRegionLimit.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserRegionLimit[]>(<any>null);
    }

    /**
     * 修改启用状态
     * @param body (optional) 
     * @return Success
     */
    changeActive(body: Int64EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeActive(_response);
        });
    }

    protected processChangeActive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 重置密码
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 删除用户
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 批量删除用户管理
     * @param body (optional) 
     * @return Success
     */
    batchDelete(body: number[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchDelete(_response);
        });
    }

    protected processBatchDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新所有选中学校的权限
     * @param body (optional) 
     * @return Success
     */
    addSchoolManager(body: AddSchoolManagerInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/AddSchoolManager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSchoolManager(_response);
        });
    }

    protected processAddSchoolManager(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取用户角色
     * @param id (optional) 
     * @return Success
     */
    getUserRoles(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoles(_response);
        });
    }

    protected processGetUserRoles(response: AxiosResponse): Promise<RoleDtoListResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDtoListResultDto>(<any>null);
    }

    /**
     * 更新用户角色
     * @param body (optional) 
     * @return Success
     */
    updateUserRoles(body: UpdateUserRoleInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserRoles(_response);
        });
    }

    protected processUpdateUserRoles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取所有学校
     * @param id (optional) 
     * @param schoolName (optional) 学校名称
     * @return Success
     */
    getAllSchool(id: number | undefined, schoolName: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SimpleTenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllSchool?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSchool(_response);
        });
    }

    protected processGetAllSchool(response: AxiosResponse): Promise<SimpleTenantDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SimpleTenantDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimpleTenantDtoPagedResultDto>(<any>null);
    }

    /**
     * @param name (optional) 姓名
     * @param phoneNumber (optional) 电话
     * @param tenantId (optional) 学校ID
     * @param userType (optional) 请求类型
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserByType(name: string | null | undefined, phoneNumber: string | null | undefined, tenantId: number | null | undefined, userType: UserType | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<UserByTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserByType?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userType === null)
            throw new Error("The parameter 'userType' cannot be null.");
        else if (userType !== undefined)
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserByType(_response);
        });
    }

    protected processGetUserByType(response: AxiosResponse): Promise<UserByTypeDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserByTypeDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserByTypeDtoPagedResultDto>(<any>null);
    }

    /**
     * 开启或者关闭会员可修改权限
     * @param body (optional) 
     * @return Success
     */
    createOrDeleteUserPurView(body: CreateOrDeleteUserPurViewInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrDeleteUserPurView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrDeleteUserPurView(_response);
        });
    }

    protected processCreateOrDeleteUserPurView(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class UserAnalysisService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取用户数量
     * @param platformType (optional) 登录平台
     * @return Success
     */
    getUserCount(platformType: PlatformType | undefined , cancelToken?: CancelToken | undefined): Promise<UserCountDto> {
        let url_ = this.baseUrl + "/api/services/app/UserAnalysis/GetUserCount?";
        if (platformType === null)
            throw new Error("The parameter 'platformType' cannot be null.");
        else if (platformType !== undefined)
            url_ += "platformType=" + encodeURIComponent("" + platformType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserCount(_response);
        });
    }

    protected processGetUserCount(response: AxiosResponse): Promise<UserCountDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserCountDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserCountDto>(<any>null);
    }

    /**
     * 获取用户充值数量
     * @param platformType (optional) 登录平台
     * @return Success
     */
    getUserPayment(platformType: PlatformType | undefined , cancelToken?: CancelToken | undefined): Promise<UserPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/UserAnalysis/GetUserPayment?";
        if (platformType === null)
            throw new Error("The parameter 'platformType' cannot be null.");
        else if (platformType !== undefined)
            url_ += "platformType=" + encodeURIComponent("" + platformType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPayment(_response);
        });
    }

    protected processGetUserPayment(response: AxiosResponse): Promise<UserPaymentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserPaymentDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPaymentDto>(<any>null);
    }

    /**
     * 获取用户活跃数量
     * @param platformType (optional) 登录平台
     * @return Success
     */
    getUserActive(platformType: PlatformType | undefined , cancelToken?: CancelToken | undefined): Promise<UserActiveDto> {
        let url_ = this.baseUrl + "/api/services/app/UserAnalysis/GetUserActive?";
        if (platformType === null)
            throw new Error("The parameter 'platformType' cannot be null.");
        else if (platformType !== undefined)
            url_ += "platformType=" + encodeURIComponent("" + platformType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserActive(_response);
        });
    }

    protected processGetUserActive(response: AxiosResponse): Promise<UserActiveDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserActiveDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserActiveDto>(<any>null);
    }
}

export class VipPaySettingService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 获取所有学校充值选项
     * @param schoolName (optional) 姓名
     * @param isQRCode (optional) 是否是二维码收费
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettings(schoolName: string | null | undefined, isQRCode: boolean | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OptionSettingsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/GetAllSettings?";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (isQRCode === null)
            throw new Error("The parameter 'isQRCode' cannot be null.");
        else if (isQRCode !== undefined)
            url_ += "isQRCode=" + encodeURIComponent("" + isQRCode) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSettings(_response);
        });
    }

    protected processGetAllSettings(response: AxiosResponse): Promise<OptionSettingsDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OptionSettingsDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OptionSettingsDtoPagedResultDto>(<any>null);
    }

    /**
     * 获取学校设置信息
     * @param id (optional) 
     * @return Success
     */
    getTenantVipTypeSetting(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<TenantVipTypeSetting> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/GetTenantVipTypeSetting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantVipTypeSetting(_response);
        });
    }

    protected processGetTenantVipTypeSetting(response: AxiosResponse): Promise<TenantVipTypeSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantVipTypeSetting.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantVipTypeSetting>(<any>null);
    }

    /**
     * 更新学校设置信息
     * @param body (optional) 
     * @return Success
     */
    updateTenantVipTypeSetting(body: TenantVipTypeSetting | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/UpdateTenantVipTypeSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTenantVipTypeSetting(_response);
        });
    }

    protected processUpdateTenantVipTypeSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取学校充值选项操作记录
     * @param schoolId (optional) 学校Id
     * @return Success
     */
    getOperateRecords(schoolId: number | undefined , cancelToken?: CancelToken | undefined): Promise<OptionRecordsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/GetOperateRecords?";
        if (schoolId === null)
            throw new Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOperateRecords(_response);
        });
    }

    protected processGetOperateRecords(response: AxiosResponse): Promise<OptionRecordsDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OptionRecordsDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OptionRecordsDto[]>(<any>null);
    }

    /**
     * 更新学校充值选项
     * @param body (optional) 
     * @return Success
     */
    updateVipOptions(body: OptionSettingsDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/UpdateVipOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVipOptions(_response);
        });
    }

    protected processUpdateVipOptions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 设置二维码收费填写项的必填或者是否开启
     * @param body (optional) 
     * @return Success
     */
    updateSchoolQrCodeSetting(body: QRCodeContentSetting | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/UpdateSchoolQrCodeSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSchoolQrCodeSetting(_response);
        });
    }

    protected processUpdateSchoolQrCodeSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 通过学校ID获取该学校的会员配置
     * @param id (optional) 
     * @param isQrCode (optional) 是否二维码
     * @return Success
     */
    getVipPriceSettingByTenantId(id: number | undefined, isQrCode: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<GetVipPriceSettingByTenantIdDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/GetVipPriceSettingByTenantId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isQrCode === null)
            throw new Error("The parameter 'isQrCode' cannot be null.");
        else if (isQrCode !== undefined)
            url_ += "isQrCode=" + encodeURIComponent("" + isQrCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVipPriceSettingByTenantId(_response);
        });
    }

    protected processGetVipPriceSettingByTenantId(response: AxiosResponse): Promise<GetVipPriceSettingByTenantIdDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetVipPriceSettingByTenantIdDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVipPriceSettingByTenantIdDto[]>(<any>null);
    }

    /**
     * 删除套餐
     * @param id (optional) 
     * @return Success
     */
    removeVipPriceSettingById(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/RemoveVipPriceSettingById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveVipPriceSettingById(_response);
        });
    }

    protected processRemoveVipPriceSettingById(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取联通办卡设置
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getRegistrationPackages(id: number | undefined, tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<RegistrationPackageDto> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/GetRegistrationPackages?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegistrationPackages(_response);
        });
    }

    protected processGetRegistrationPackages(response: AxiosResponse): Promise<RegistrationPackageDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegistrationPackageDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegistrationPackageDto>(<any>null);
    }

    /**
     * 更新联通办卡设置
     * @param body (optional) 
     * @return Success
     */
    updateRegistrationPackages(body: RegistrationPackageDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/UpdateRegistrationPackages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRegistrationPackages(_response);
        });
    }

    protected processUpdateRegistrationPackages(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 给这个学校新建联通套餐
     * @param body (optional) 
     * @return Success
     */
    createUnionRegistration(body: Int32EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/VipPaySetting/CreateUnionRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUnionRegistration(_response);
        });
    }

    protected processCreateUnionRegistration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class WxPushSettingService {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "/sysadmin/";
    }

    /**
     * 更新指定学校微信推送权限
     * @param body (optional) 
     * @return Success
     */
    changeTenantPushSetting(body: ChangPushInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/ChangeTenantPushSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeTenantPushSetting(_response);
        });
    }

    protected processChangeTenantPushSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新指定学校是都显示商城
     * @param body (optional) 
     * @return Success
     */
    changeTenantShowShop(body: ChangPushInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/ChangeTenantShowShop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeTenantShowShop(_response);
        });
    }

    protected processChangeTenantShowShop(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新指定学校是否在班牌上面  教师值日显示在前面
     * @param body (optional) 
     * @return Success
     */
    changeTeacherDutyBefore(body: Int32EntityDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/ChangeTeacherDutyBefore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeTeacherDutyBefore(_response);
        });
    }

    protected processChangeTeacherDutyBefore(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新学校是否允许宿管和保卫添加学生信息
     * @param body (optional) 
     * @return Success
     */
    changeIsOpenWorkerAddStudent(body: PushSettingPageOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/ChangeIsOpenWorkerAddStudent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeIsOpenWorkerAddStudent(_response);
        });
    }

    protected processChangeIsOpenWorkerAddStudent(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新学校是否允许宿管和保卫添加学生信息
     * @param body (optional) 
     * @return Success
     */
    changeIsNotVipShowFacerecord(body: PushSettingPageOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/ChangeIsNotVipShowFacerecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeIsNotVipShowFacerecord(_response);
        });
    }

    protected processChangeIsNotVipShowFacerecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更新是否允许领导审批自己的假条
     * @param body (optional) 
     * @return Success
     */
    changeIsOpenLeadeApproveSelf(body: PushSettingPageOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/ChangeIsOpenLeadeApproveSelf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeIsOpenLeadeApproveSelf(_response);
        });
    }

    protected processChangeIsOpenLeadeApproveSelf(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 发布校园拍和通知通告是否需要审批
     * @param body (optional) 
     * @return Success
     */
    changeIsReleaseNeedApproval(body: PushSettingPageOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/changeIsReleaseNeedApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeIsReleaseNeedApproval(_response);
        });
    }

    protected processChangeIsReleaseNeedApproval(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新生报名是否需要审批
     * @param body (optional) 
     * @return Success
     */
    changeIspushSignStudent(body: PushSettingPageOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/changeIspushSignStudent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeIspushSignStudent(_response);
        });
    }

    protected processChangeIspushSignStudent(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新生报名是否需要审批
     * @param body (optional) 
     * @return Success
     */
    changeIsUpdateFace(body: PushSettingPageOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/ChangeIsUpdateFace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeIsUpdateFace(_response);
        });
    }

    protected processChangeIsUpdateFace(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新生报名是否需要审批
     * @param body (optional) 
     * @return Success
     */
    changeValue(body: PushSettingPageOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/ChangeValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeValue(_response);
        });
    }

    protected processChangeValue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 登录是否需要短信验证
     * @param body (optional) 
     * @return Success
     */
    changeIsMessageLogin(body: PushSettingPageOutDto | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/changeIsMessageLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeIsMessageLogin(_response);
        });
    }

    protected processChangeIsMessageLogin(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取所有学校微信推送权限设置
     * @param schoolName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTenantPushSettings(schoolName: string | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined , cancelToken?: CancelToken | undefined): Promise<PushSettingPageOutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/GetTenantPushSettings?";
        if (schoolName !== undefined && schoolName !== null)
            url_ += "schoolName=" + encodeURIComponent("" + schoolName) + "&";
        if (sorting !== undefined && sorting !== null)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantPushSettings(_response);
        });
    }

    protected processGetTenantPushSettings(response: AxiosResponse): Promise<PushSettingPageOutDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PushSettingPageOutDtoPagedResultDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PushSettingPageOutDtoPagedResultDto>(<any>null);
    }

    /**
     * 获取定时推送未到校设置
     * @param id (optional) 
     * @return Success
     */
    getPushNotInSchoolInfo(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<PushNotInSchoolInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/GetPushNotInSchoolInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPushNotInSchoolInfo(_response);
        });
    }

    protected processGetPushNotInSchoolInfo(response: AxiosResponse): Promise<PushNotInSchoolInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PushNotInSchoolInfoDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PushNotInSchoolInfoDto>(<any>null);
    }

    /**
     * 更新定时推送未到校设置
     * @param body (optional) 
     * @return Success
     */
    updatePushNotInSchool(body: PushNotInSchoolInfoDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/UpdatePushNotInSchool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePushNotInSchool(_response);
        });
    }

    protected processUpdatePushNotInSchool(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取教师范围打卡设置编辑回显
     * @param id (optional) 
     * @return Success
     */
    getTeacherRangeChick(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<TeacherRangeClockDto> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/GetTeacherRangeChick?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeacherRangeChick(_response);
        });
    }

    protected processGetTeacherRangeChick(response: AxiosResponse): Promise<TeacherRangeClockDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeacherRangeClockDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeacherRangeClockDto>(<any>null);
    }

    /**
     * 通过姓名和电话查询教师信息
     * @param nameOrPhone (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTeacherInfoByNameOrPhone(nameOrPhone: string | null | undefined, tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<TeacherInfoByNameOrPhone[]> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/GetTeacherInfoByNameOrPhone?";
        if (nameOrPhone !== undefined && nameOrPhone !== null)
            url_ += "nameOrPhone=" + encodeURIComponent("" + nameOrPhone) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeacherInfoByNameOrPhone(_response);
        });
    }

    protected processGetTeacherInfoByNameOrPhone(response: AxiosResponse): Promise<TeacherInfoByNameOrPhone[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeacherInfoByNameOrPhone.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeacherInfoByNameOrPhone[]>(<any>null);
    }

    /**
     * 获取分组用户
     * @param tenantId (optional) 
     * @return Success
     */
    getGroupedUsers(tenantId: number | undefined , cancelToken?: CancelToken | undefined): Promise<TeacherGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/GetGroupedUsers?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupedUsers(_response);
        });
    }

    protected processGetGroupedUsers(response: AxiosResponse): Promise<TeacherGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeacherGroupDto.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeacherGroupDto[]>(<any>null);
    }

    /**
     * 更新教师范围打卡设置
     * @param body (optional) 
     * @return Success
     */
    updateTeacherRangeChick(body: TeacherRangeClockDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/UpdateTeacherRangeChick";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTeacherRangeChick(_response);
        });
    }

    protected processUpdateTeacherRangeChick(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取这个学校的推送学生信息给班主任的设置
     * @param id (optional) 
     * @return Success
     */
    getPushMasterStudentStaticTimeInterval(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<StudentStaticTimeIntervalDto> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/GetPushMasterStudentStaticTimeInterval?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPushMasterStudentStaticTimeInterval(_response);
        });
    }

    protected processGetPushMasterStudentStaticTimeInterval(response: AxiosResponse): Promise<StudentStaticTimeIntervalDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StudentStaticTimeIntervalDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StudentStaticTimeIntervalDto>(<any>null);
    }

    /**
     * 更新推送学生信息给班主任的设置
     * @param body (optional) 
     * @return Success
     */
    updatePushMasterStudentStaticTimeInterval(body: StudentStaticTimeIntervalDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/services/app/WxPushSetting/UpdatePushMasterStudentStaticTimeInterval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePushMasterStudentStaticTimeInterval(_response);
        });
    }

    protected processUpdatePushMasterStudentStaticTimeInterval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class CreateAddressDto implements ICreateAddressDto {
    /** 收货人姓名 */
    name?: string | null;
    /** 收货人电话 */
    phone?: string | null;
    /** 收货人详细地址 */
    detail?: string | null;
    /** 是否默认地址 */
    state?: boolean;
    /** 下单学生绑定码 */
    code?: string | null;
    /** 省 */
    province?: string | null;
    /** 市 */
    city?: string | null;
    /** 区 */
    area?: string | null;

    constructor(data?: ICreateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.province = _data["province"] !== undefined ? _data["province"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
        }
    }

    static fromJS(data: any): CreateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        return data; 
    }

    clone(): CreateAddressDto {
        const json = this.toJSON();
        let result = new CreateAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAddressDto {
    /** 收货人姓名 */
    name?: string | null;
    /** 收货人电话 */
    phone?: string | null;
    /** 收货人详细地址 */
    detail?: string | null;
    /** 是否默认地址 */
    state?: boolean;
    /** 下单学生绑定码 */
    code?: string | null;
    /** 省 */
    province?: string | null;
    /** 市 */
    city?: string | null;
    /** 区 */
    area?: string | null;
}

/** 产品信息 */
export class AddressDto implements IAddressDto {
    id?: number;
    /** 收货人姓名 */
    name?: string | null;
    /** 收货人电话 */
    phone?: string | null;
    /** 收货人详细地址 */
    detail?: string | null;
    /** 是否默认地址 */
    state?: boolean;
    /** 下单学生绑定码 */
    code?: string | null;
    /** 省 */
    province?: string | null;
    /** 市 */
    city?: string | null;
    /** 区 */
    area?: string | null;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.province = _data["province"] !== undefined ? _data["province"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        return data; 
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

/** 产品信息 */
export interface IAddressDto {
    id?: number;
    /** 收货人姓名 */
    name?: string | null;
    /** 收货人电话 */
    phone?: string | null;
    /** 收货人详细地址 */
    detail?: string | null;
    /** 是否默认地址 */
    state?: boolean;
    /** 下单学生绑定码 */
    code?: string | null;
    /** 省 */
    province?: string | null;
    /** 市 */
    city?: string | null;
    /** 区 */
    area?: string | null;
}

export class AddressDtoPagedResultDto implements IAddressDtoPagedResultDto {
    items?: AddressDto[] | null;
    totalCount?: number;

    constructor(data?: IAddressDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AddressDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): AddressDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): AddressDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AddressDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDtoPagedResultDto {
    items?: AddressDto[] | null;
    totalCount?: number;
}

/** 修改产品 */
export class UpdateAddressDto implements IUpdateAddressDto {
    id?: number;
    /** 收货人姓名 */
    name?: string | null;
    /** 收货人电话 */
    phone?: string | null;
    /** 收货人详细地址 */
    detail?: string | null;
    /** 是否默认地址 */
    state?: boolean;
    /** 下单学生绑定码 */
    code?: string | null;

    constructor(data?: IUpdateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data; 
    }

    clone(): UpdateAddressDto {
        const json = this.toJSON();
        let result = new UpdateAddressDto();
        result.init(json);
        return result;
    }
}

/** 修改产品 */
export interface IUpdateAddressDto {
    id?: number;
    /** 收货人姓名 */
    name?: string | null;
    /** 收货人电话 */
    phone?: string | null;
    /** 收货人详细地址 */
    detail?: string | null;
    /** 是否默认地址 */
    state?: boolean;
    /** 下单学生绑定码 */
    code?: string | null;
}

export class AuditLogDto implements IAuditLogDto {
    id?: number;
    /** 执行时间 */
    executionTime?: moment.Moment;
    /** 异常 */
    exception?: string | null;
    /** 用户名 */
    name?: string | null;
    /** 姓名 */
    userName?: string | null;
    /** 服务 */
    serviceName?: string | null;
    /** 操作 */
    methodName?: string | null;
    /** 浏览器 */
    browserInfo?: string | null;
    /** 客户端 */
    clientName?: string | null;
    /** Ip */
    clientIpAddress?: string | null;
    /** 执行时间 */
    executionDuration?: number;
    /** 返回值 */
    returnValue?: string | null;
    /** TenantId */
    tenantId?: number | null;
    /** 参数 */
    parameters?: string | null;
    /** 客户端数据 */
    customData?: string | null;

    constructor(data?: IAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.executionTime = _data["executionTime"] ? moment.parseZone(_data["executionTime"].toString()) : <any>null;
            this.exception = _data["exception"] !== undefined ? _data["exception"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.serviceName = _data["serviceName"] !== undefined ? _data["serviceName"] : <any>null;
            this.methodName = _data["methodName"] !== undefined ? _data["methodName"] : <any>null;
            this.browserInfo = _data["browserInfo"] !== undefined ? _data["browserInfo"] : <any>null;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.clientIpAddress = _data["clientIpAddress"] !== undefined ? _data["clientIpAddress"] : <any>null;
            this.executionDuration = _data["executionDuration"] !== undefined ? _data["executionDuration"] : <any>null;
            this.returnValue = _data["returnValue"] !== undefined ? _data["returnValue"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.parameters = _data["parameters"] !== undefined ? _data["parameters"] : <any>null;
            this.customData = _data["customData"] !== undefined ? _data["customData"] : <any>null;
        }
    }

    static fromJS(data: any): AuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString(true) : <any>null;
        data["exception"] = this.exception !== undefined ? this.exception : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["serviceName"] = this.serviceName !== undefined ? this.serviceName : <any>null;
        data["methodName"] = this.methodName !== undefined ? this.methodName : <any>null;
        data["browserInfo"] = this.browserInfo !== undefined ? this.browserInfo : <any>null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["clientIpAddress"] = this.clientIpAddress !== undefined ? this.clientIpAddress : <any>null;
        data["executionDuration"] = this.executionDuration !== undefined ? this.executionDuration : <any>null;
        data["returnValue"] = this.returnValue !== undefined ? this.returnValue : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["parameters"] = this.parameters !== undefined ? this.parameters : <any>null;
        data["customData"] = this.customData !== undefined ? this.customData : <any>null;
        return data; 
    }

    clone(): AuditLogDto {
        const json = this.toJSON();
        let result = new AuditLogDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogDto {
    id?: number;
    /** 执行时间 */
    executionTime?: moment.Moment;
    /** 异常 */
    exception?: string | null;
    /** 用户名 */
    name?: string | null;
    /** 姓名 */
    userName?: string | null;
    /** 服务 */
    serviceName?: string | null;
    /** 操作 */
    methodName?: string | null;
    /** 浏览器 */
    browserInfo?: string | null;
    /** 客户端 */
    clientName?: string | null;
    /** Ip */
    clientIpAddress?: string | null;
    /** 执行时间 */
    executionDuration?: number;
    /** 返回值 */
    returnValue?: string | null;
    /** TenantId */
    tenantId?: number | null;
    /** 参数 */
    parameters?: string | null;
    /** 客户端数据 */
    customData?: string | null;
}

export class AuditLogDtoPagedResultDto implements IAuditLogDtoPagedResultDto {
    items?: AuditLogDto[] | null;
    totalCount?: number;

    constructor(data?: IAuditLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): AuditLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): AuditLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AuditLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogDtoPagedResultDto {
    items?: AuditLogDto[] | null;
    totalCount?: number;
}

export class CreateCarouselDto implements ICreateCarouselDto {
    /** 标题 */
    title?: string | null;
    /** 商品ID */
    productId?: number;
    /** 商品封面图 */
    p_Path?: string | null;
    /** 排序调整 */
    orderIndex?: number;
    /** 图片类型--1,是滚动图 2是直播类型图 */
    imgType?: number;

    constructor(data?: ICreateCarouselDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.imgType = _data["imgType"] !== undefined ? _data["imgType"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCarouselDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCarouselDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["imgType"] = this.imgType !== undefined ? this.imgType : <any>null;
        return data; 
    }

    clone(): CreateCarouselDto {
        const json = this.toJSON();
        let result = new CreateCarouselDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCarouselDto {
    /** 标题 */
    title?: string | null;
    /** 商品ID */
    productId?: number;
    /** 商品封面图 */
    p_Path?: string | null;
    /** 排序调整 */
    orderIndex?: number;
    /** 图片类型--1,是滚动图 2是直播类型图 */
    imgType?: number;
}

/** 产品轮播广告 */
export class CarouselDto implements ICarouselDto {
    id?: number;
    /** 标题 */
    title?: string | null;
    /** 商品ID */
    productId?: number;
    /** 商品封面图 */
    p_Path?: string | null;
    /** 排序调整 */
    orderIndex?: number;
    creationTime?: moment.Moment | null;
    /** 课程名称 */
    productName?: string | null;
    /** 图片类型--1,是滚动图 2是直播类型图 */
    imgType?: number;

    constructor(data?: ICarouselDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
            this.imgType = _data["imgType"] !== undefined ? _data["imgType"] : <any>null;
        }
    }

    static fromJS(data: any): CarouselDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarouselDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        data["imgType"] = this.imgType !== undefined ? this.imgType : <any>null;
        return data; 
    }

    clone(): CarouselDto {
        const json = this.toJSON();
        let result = new CarouselDto();
        result.init(json);
        return result;
    }
}

/** 产品轮播广告 */
export interface ICarouselDto {
    id?: number;
    /** 标题 */
    title?: string | null;
    /** 商品ID */
    productId?: number;
    /** 商品封面图 */
    p_Path?: string | null;
    /** 排序调整 */
    orderIndex?: number;
    creationTime?: moment.Moment | null;
    /** 课程名称 */
    productName?: string | null;
    /** 图片类型--1,是滚动图 2是直播类型图 */
    imgType?: number;
}

export class CarouselDtoPagedResultDto implements ICarouselDtoPagedResultDto {
    items?: CarouselDto[] | null;
    totalCount?: number;

    constructor(data?: ICarouselDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CarouselDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): CarouselDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarouselDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): CarouselDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CarouselDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICarouselDtoPagedResultDto {
    items?: CarouselDto[] | null;
    totalCount?: number;
}

/** 产品轮播广告 */
export class UpdateCarouselDto implements IUpdateCarouselDto {
    id?: number;
    /** 标题 */
    title?: string | null;
    /** 商品ID */
    productId?: number;
    /** 商品封面图 */
    p_Path?: string | null;
    /** 排序调整 */
    orderIndex?: number;
    /** 图片类型--1,是滚动图 2是直播类型图 */
    imgType?: number;

    constructor(data?: IUpdateCarouselDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.orderIndex = _data["orderIndex"] !== undefined ? _data["orderIndex"] : <any>null;
            this.imgType = _data["imgType"] !== undefined ? _data["imgType"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCarouselDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCarouselDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["orderIndex"] = this.orderIndex !== undefined ? this.orderIndex : <any>null;
        data["imgType"] = this.imgType !== undefined ? this.imgType : <any>null;
        return data; 
    }

    clone(): UpdateCarouselDto {
        const json = this.toJSON();
        let result = new UpdateCarouselDto();
        result.init(json);
        return result;
    }
}

/** 产品轮播广告 */
export interface IUpdateCarouselDto {
    id?: number;
    /** 标题 */
    title?: string | null;
    /** 商品ID */
    productId?: number;
    /** 商品封面图 */
    p_Path?: string | null;
    /** 排序调整 */
    orderIndex?: number;
    /** 图片类型--1,是滚动图 2是直播类型图 */
    imgType?: number;
}

export class ProDto implements IProDto {
    /** 产品ID */
    productID?: number;
    /** 产品名称 */
    productName?: string | null;

    constructor(data?: IProDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"] !== undefined ? _data["productID"] : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
        }
    }

    static fromJS(data: any): ProDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID !== undefined ? this.productID : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        return data; 
    }

    clone(): ProDto {
        const json = this.toJSON();
        let result = new ProDto();
        result.init(json);
        return result;
    }
}

export interface IProDto {
    /** 产品ID */
    productID?: number;
    /** 产品名称 */
    productName?: string | null;
}

export enum MessageState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

/** 产品信息 */
export class ChartMessageDto implements IChartMessageDto {
    id?: number;
    /** 聊天内容 */
    content?: string | null;
    /** 当前用户的ID */
    currentUserId?: string | null;
    /** 接收人的ID */
    receiveUserId?: string | null;
    messageType?: MessageState;
    /** 学生名字 */
    studentName?: string | null;
    /** 家长与学生的关系 */
    relation?: string | null;
    /** 学校名称 */
    schoolName?: string | null;
    readonly showName?: string | null;
    /** 添加时间 */
    creationTime?: moment.Moment | null;
    readonly creationTimeStr?: string | null;
    /** 会话ID */
    sessionID?: string | null;
    tenantId?: number;
    /** 是否已读 */
    isRead?: boolean;
    /** 这个消息是学生发的 还是老师发的  为true 代表老师 */
    isTeacherApplay?: boolean;
    /** 未读条数 */
    notReadCount?: number;
    /** 学生ID */
    faceTempleteId?: number | null;
    /** 学生家长ID */
    parentUserId?: number | null;
    /** 头像 */
    faceImg?: string | null;
    /** 是否已经撤回 */
    isWithDraw?: boolean;
    /** 回复者姓名 */
    replyUserName?: string | null;

    constructor(data?: IChartMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.currentUserId = _data["currentUserId"] !== undefined ? _data["currentUserId"] : <any>null;
            this.receiveUserId = _data["receiveUserId"] !== undefined ? _data["receiveUserId"] : <any>null;
            this.messageType = _data["messageType"] !== undefined ? _data["messageType"] : <any>null;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : <any>null;
            this.relation = _data["relation"] !== undefined ? _data["relation"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            (<any>this).showName = _data["showName"] !== undefined ? _data["showName"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            (<any>this).creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : <any>null;
            this.sessionID = _data["sessionID"] !== undefined ? _data["sessionID"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.isRead = _data["isRead"] !== undefined ? _data["isRead"] : <any>null;
            this.isTeacherApplay = _data["isTeacherApplay"] !== undefined ? _data["isTeacherApplay"] : <any>null;
            this.notReadCount = _data["notReadCount"] !== undefined ? _data["notReadCount"] : <any>null;
            this.faceTempleteId = _data["faceTempleteId"] !== undefined ? _data["faceTempleteId"] : <any>null;
            this.parentUserId = _data["parentUserId"] !== undefined ? _data["parentUserId"] : <any>null;
            this.faceImg = _data["faceImg"] !== undefined ? _data["faceImg"] : <any>null;
            this.isWithDraw = _data["isWithDraw"] !== undefined ? _data["isWithDraw"] : <any>null;
            this.replyUserName = _data["replyUserName"] !== undefined ? _data["replyUserName"] : <any>null;
        }
    }

    static fromJS(data: any): ChartMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["currentUserId"] = this.currentUserId !== undefined ? this.currentUserId : <any>null;
        data["receiveUserId"] = this.receiveUserId !== undefined ? this.receiveUserId : <any>null;
        data["messageType"] = this.messageType !== undefined ? this.messageType : <any>null;
        data["studentName"] = this.studentName !== undefined ? this.studentName : <any>null;
        data["relation"] = this.relation !== undefined ? this.relation : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        data["showName"] = this.showName !== undefined ? this.showName : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : <any>null;
        data["sessionID"] = this.sessionID !== undefined ? this.sessionID : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["isRead"] = this.isRead !== undefined ? this.isRead : <any>null;
        data["isTeacherApplay"] = this.isTeacherApplay !== undefined ? this.isTeacherApplay : <any>null;
        data["notReadCount"] = this.notReadCount !== undefined ? this.notReadCount : <any>null;
        data["faceTempleteId"] = this.faceTempleteId !== undefined ? this.faceTempleteId : <any>null;
        data["parentUserId"] = this.parentUserId !== undefined ? this.parentUserId : <any>null;
        data["faceImg"] = this.faceImg !== undefined ? this.faceImg : <any>null;
        data["isWithDraw"] = this.isWithDraw !== undefined ? this.isWithDraw : <any>null;
        data["replyUserName"] = this.replyUserName !== undefined ? this.replyUserName : <any>null;
        return data; 
    }

    clone(): ChartMessageDto {
        const json = this.toJSON();
        let result = new ChartMessageDto();
        result.init(json);
        return result;
    }
}

/** 产品信息 */
export interface IChartMessageDto {
    id?: number;
    /** 聊天内容 */
    content?: string | null;
    /** 当前用户的ID */
    currentUserId?: string | null;
    /** 接收人的ID */
    receiveUserId?: string | null;
    messageType?: MessageState;
    /** 学生名字 */
    studentName?: string | null;
    /** 家长与学生的关系 */
    relation?: string | null;
    /** 学校名称 */
    schoolName?: string | null;
    showName?: string | null;
    /** 添加时间 */
    creationTime?: moment.Moment | null;
    creationTimeStr?: string | null;
    /** 会话ID */
    sessionID?: string | null;
    tenantId?: number;
    /** 是否已读 */
    isRead?: boolean;
    /** 这个消息是学生发的 还是老师发的  为true 代表老师 */
    isTeacherApplay?: boolean;
    /** 未读条数 */
    notReadCount?: number;
    /** 学生ID */
    faceTempleteId?: number | null;
    /** 学生家长ID */
    parentUserId?: number | null;
    /** 头像 */
    faceImg?: string | null;
    /** 是否已经撤回 */
    isWithDraw?: boolean;
    /** 回复者姓名 */
    replyUserName?: string | null;
}

export class CharMessageStatisticsDto implements ICharMessageStatisticsDto {
    items?: ChartMessageDto[] | null;
    totalCount?: number;
    /** 全部聊天 */
    totalMessage?: number;
    /** 当天家长互动人数（人） */
    parentInteraction?: number;
    /** 当天未答复（人） */
    notAppaly?: number;

    constructor(data?: ICharMessageStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChartMessageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.totalMessage = _data["totalMessage"] !== undefined ? _data["totalMessage"] : <any>null;
            this.parentInteraction = _data["parentInteraction"] !== undefined ? _data["parentInteraction"] : <any>null;
            this.notAppaly = _data["notAppaly"] !== undefined ? _data["notAppaly"] : <any>null;
        }
    }

    static fromJS(data: any): CharMessageStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharMessageStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["totalMessage"] = this.totalMessage !== undefined ? this.totalMessage : <any>null;
        data["parentInteraction"] = this.parentInteraction !== undefined ? this.parentInteraction : <any>null;
        data["notAppaly"] = this.notAppaly !== undefined ? this.notAppaly : <any>null;
        return data; 
    }

    clone(): CharMessageStatisticsDto {
        const json = this.toJSON();
        let result = new CharMessageStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ICharMessageStatisticsDto {
    items?: ChartMessageDto[] | null;
    totalCount?: number;
    /** 全部聊天 */
    totalMessage?: number;
    /** 当天家长互动人数（人） */
    parentInteraction?: number;
    /** 当天未答复（人） */
    notAppaly?: number;
}

export class CurrentUserMessageDto implements ICurrentUserMessageDto {
    chartMessageDtos?: ChartMessageDto[] | null;
    faceTempleteId?: number | null;
    className?: string | null;

    constructor(data?: ICurrentUserMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["chartMessageDtos"])) {
                this.chartMessageDtos = [] as any;
                for (let item of _data["chartMessageDtos"])
                    this.chartMessageDtos!.push(ChartMessageDto.fromJS(item));
            }
            this.faceTempleteId = _data["faceTempleteId"] !== undefined ? _data["faceTempleteId"] : <any>null;
            this.className = _data["className"] !== undefined ? _data["className"] : <any>null;
        }
    }

    static fromJS(data: any): CurrentUserMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chartMessageDtos)) {
            data["chartMessageDtos"] = [];
            for (let item of this.chartMessageDtos)
                data["chartMessageDtos"].push(item.toJSON());
        }
        data["faceTempleteId"] = this.faceTempleteId !== undefined ? this.faceTempleteId : <any>null;
        data["className"] = this.className !== undefined ? this.className : <any>null;
        return data; 
    }

    clone(): CurrentUserMessageDto {
        const json = this.toJSON();
        let result = new CurrentUserMessageDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentUserMessageDto {
    chartMessageDtos?: ChartMessageDto[] | null;
    faceTempleteId?: number | null;
    className?: string | null;
}

export class MessageAnalysisItem implements IMessageAnalysisItem {
    id?: number;
    name?: string | null;
    /** 近七天家长互动 */
    messageParent_7Day?: number;
    /** 近七天为答复 */
    notAppaly_7Day?: number;
    /** 当天家长互动 */
    messageParent_Day?: number;
    /** 当天未答复 */
    notAppaly_Day?: number;

    constructor(data?: IMessageAnalysisItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.messageParent_7Day = _data["messageParent_7Day"] !== undefined ? _data["messageParent_7Day"] : <any>null;
            this.notAppaly_7Day = _data["notAppaly_7Day"] !== undefined ? _data["notAppaly_7Day"] : <any>null;
            this.messageParent_Day = _data["messageParent_Day"] !== undefined ? _data["messageParent_Day"] : <any>null;
            this.notAppaly_Day = _data["notAppaly_Day"] !== undefined ? _data["notAppaly_Day"] : <any>null;
        }
    }

    static fromJS(data: any): MessageAnalysisItem {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAnalysisItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["messageParent_7Day"] = this.messageParent_7Day !== undefined ? this.messageParent_7Day : <any>null;
        data["notAppaly_7Day"] = this.notAppaly_7Day !== undefined ? this.notAppaly_7Day : <any>null;
        data["messageParent_Day"] = this.messageParent_Day !== undefined ? this.messageParent_Day : <any>null;
        data["notAppaly_Day"] = this.notAppaly_Day !== undefined ? this.notAppaly_Day : <any>null;
        return data; 
    }

    clone(): MessageAnalysisItem {
        const json = this.toJSON();
        let result = new MessageAnalysisItem();
        result.init(json);
        return result;
    }
}

export interface IMessageAnalysisItem {
    id?: number;
    name?: string | null;
    /** 近七天家长互动 */
    messageParent_7Day?: number;
    /** 近七天为答复 */
    notAppaly_7Day?: number;
    /** 当天家长互动 */
    messageParent_Day?: number;
    /** 当天未答复 */
    notAppaly_Day?: number;
}

export class StudentMessageAnalysisDto implements IStudentMessageAnalysisDto {
    /** 近七天聊天学校 */
    messageTenant_7Day?: number;
    /** 近七天家长互动 */
    messageParent_7Day?: number;
    /** 近七天为答复 */
    notAppaly_7Day?: number;
    /** 当天家长互动 */
    messageParent_Day?: number;
    /** 当天未答复 */
    notAppaly_Day?: number;
    messageAnalysisItems?: MessageAnalysisItem[] | null;

    constructor(data?: IStudentMessageAnalysisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageTenant_7Day = _data["messageTenant_7Day"] !== undefined ? _data["messageTenant_7Day"] : <any>null;
            this.messageParent_7Day = _data["messageParent_7Day"] !== undefined ? _data["messageParent_7Day"] : <any>null;
            this.notAppaly_7Day = _data["notAppaly_7Day"] !== undefined ? _data["notAppaly_7Day"] : <any>null;
            this.messageParent_Day = _data["messageParent_Day"] !== undefined ? _data["messageParent_Day"] : <any>null;
            this.notAppaly_Day = _data["notAppaly_Day"] !== undefined ? _data["notAppaly_Day"] : <any>null;
            if (Array.isArray(_data["messageAnalysisItems"])) {
                this.messageAnalysisItems = [] as any;
                for (let item of _data["messageAnalysisItems"])
                    this.messageAnalysisItems!.push(MessageAnalysisItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentMessageAnalysisDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentMessageAnalysisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageTenant_7Day"] = this.messageTenant_7Day !== undefined ? this.messageTenant_7Day : <any>null;
        data["messageParent_7Day"] = this.messageParent_7Day !== undefined ? this.messageParent_7Day : <any>null;
        data["notAppaly_7Day"] = this.notAppaly_7Day !== undefined ? this.notAppaly_7Day : <any>null;
        data["messageParent_Day"] = this.messageParent_Day !== undefined ? this.messageParent_Day : <any>null;
        data["notAppaly_Day"] = this.notAppaly_Day !== undefined ? this.notAppaly_Day : <any>null;
        if (Array.isArray(this.messageAnalysisItems)) {
            data["messageAnalysisItems"] = [];
            for (let item of this.messageAnalysisItems)
                data["messageAnalysisItems"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StudentMessageAnalysisDto {
        const json = this.toJSON();
        let result = new StudentMessageAnalysisDto();
        result.init(json);
        return result;
    }
}

export interface IStudentMessageAnalysisDto {
    /** 近七天聊天学校 */
    messageTenant_7Day?: number;
    /** 近七天家长互动 */
    messageParent_7Day?: number;
    /** 近七天为答复 */
    notAppaly_7Day?: number;
    /** 当天家长互动 */
    messageParent_Day?: number;
    /** 当天未答复 */
    notAppaly_Day?: number;
    messageAnalysisItems?: MessageAnalysisItem[] | null;
}

/** 促销管理 */
export class CreateCouponDto implements ICreateCouponDto {
    /** 商品ID */
    productId?: number;
    /** 促销活动的标题 */
    title?: string | null;
    /** 预定价格 */
    reservePrice?: number;
    /** 抵扣价格 */
    deductionPrice?: number;
    /** 库存数量 */
    inventoryNum?: number;
    /** 是否选中 */
    isSelect?: boolean;

    constructor(data?: ICreateCouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.reservePrice = _data["reservePrice"] !== undefined ? _data["reservePrice"] : <any>null;
            this.deductionPrice = _data["deductionPrice"] !== undefined ? _data["deductionPrice"] : <any>null;
            this.inventoryNum = _data["inventoryNum"] !== undefined ? _data["inventoryNum"] : <any>null;
            this.isSelect = _data["isSelect"] !== undefined ? _data["isSelect"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCouponDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["reservePrice"] = this.reservePrice !== undefined ? this.reservePrice : <any>null;
        data["deductionPrice"] = this.deductionPrice !== undefined ? this.deductionPrice : <any>null;
        data["inventoryNum"] = this.inventoryNum !== undefined ? this.inventoryNum : <any>null;
        data["isSelect"] = this.isSelect !== undefined ? this.isSelect : <any>null;
        return data; 
    }

    clone(): CreateCouponDto {
        const json = this.toJSON();
        let result = new CreateCouponDto();
        result.init(json);
        return result;
    }
}

/** 促销管理 */
export interface ICreateCouponDto {
    /** 商品ID */
    productId?: number;
    /** 促销活动的标题 */
    title?: string | null;
    /** 预定价格 */
    reservePrice?: number;
    /** 抵扣价格 */
    deductionPrice?: number;
    /** 库存数量 */
    inventoryNum?: number;
    /** 是否选中 */
    isSelect?: boolean;
}

/** 促销管理 */
export class CouponDto implements ICouponDto {
    id?: number;
    /** 商品ID */
    productId?: number;
    /** 促销活动的标题 */
    title?: string | null;
    /** 预定价格 */
    reservePrice?: number;
    /** 抵扣价格 */
    deductionPrice?: number;
    /** 库存数量 */
    inventoryNum?: number;
    /** 是否选中 */
    isSelect?: boolean;
    /** 添加时间 */
    creationTime?: moment.Moment | null;
    /** 课程名称 */
    productName?: string | null;

    constructor(data?: ICouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.reservePrice = _data["reservePrice"] !== undefined ? _data["reservePrice"] : <any>null;
            this.deductionPrice = _data["deductionPrice"] !== undefined ? _data["deductionPrice"] : <any>null;
            this.inventoryNum = _data["inventoryNum"] !== undefined ? _data["inventoryNum"] : <any>null;
            this.isSelect = _data["isSelect"] !== undefined ? _data["isSelect"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.productName = _data["productName"] !== undefined ? _data["productName"] : <any>null;
        }
    }

    static fromJS(data: any): CouponDto {
        data = typeof data === 'object' ? data : {};
        let result = new CouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["reservePrice"] = this.reservePrice !== undefined ? this.reservePrice : <any>null;
        data["deductionPrice"] = this.deductionPrice !== undefined ? this.deductionPrice : <any>null;
        data["inventoryNum"] = this.inventoryNum !== undefined ? this.inventoryNum : <any>null;
        data["isSelect"] = this.isSelect !== undefined ? this.isSelect : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["productName"] = this.productName !== undefined ? this.productName : <any>null;
        return data; 
    }

    clone(): CouponDto {
        const json = this.toJSON();
        let result = new CouponDto();
        result.init(json);
        return result;
    }
}

/** 促销管理 */
export interface ICouponDto {
    id?: number;
    /** 商品ID */
    productId?: number;
    /** 促销活动的标题 */
    title?: string | null;
    /** 预定价格 */
    reservePrice?: number;
    /** 抵扣价格 */
    deductionPrice?: number;
    /** 库存数量 */
    inventoryNum?: number;
    /** 是否选中 */
    isSelect?: boolean;
    /** 添加时间 */
    creationTime?: moment.Moment | null;
    /** 课程名称 */
    productName?: string | null;
}

export class CouponDtoPagedResultDto implements ICouponDtoPagedResultDto {
    items?: CouponDto[] | null;
    totalCount?: number;

    constructor(data?: ICouponDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CouponDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): CouponDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CouponDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): CouponDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CouponDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICouponDtoPagedResultDto {
    items?: CouponDto[] | null;
    totalCount?: number;
}

/** 促销管理 */
export class UpdateCouponDto implements IUpdateCouponDto {
    id?: number;
    /** 商品ID */
    productId?: number;
    /** 促销活动的标题 */
    title?: string | null;
    /** 预定价格 */
    reservePrice?: number;
    /** 抵扣价格 */
    deductionPrice?: number;
    /** 库存数量 */
    inventoryNum?: number;
    /** 是否选中 */
    isSelect?: boolean;

    constructor(data?: IUpdateCouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.reservePrice = _data["reservePrice"] !== undefined ? _data["reservePrice"] : <any>null;
            this.deductionPrice = _data["deductionPrice"] !== undefined ? _data["deductionPrice"] : <any>null;
            this.inventoryNum = _data["inventoryNum"] !== undefined ? _data["inventoryNum"] : <any>null;
            this.isSelect = _data["isSelect"] !== undefined ? _data["isSelect"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateCouponDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["reservePrice"] = this.reservePrice !== undefined ? this.reservePrice : <any>null;
        data["deductionPrice"] = this.deductionPrice !== undefined ? this.deductionPrice : <any>null;
        data["inventoryNum"] = this.inventoryNum !== undefined ? this.inventoryNum : <any>null;
        data["isSelect"] = this.isSelect !== undefined ? this.isSelect : <any>null;
        return data; 
    }

    clone(): UpdateCouponDto {
        const json = this.toJSON();
        let result = new UpdateCouponDto();
        result.init(json);
        return result;
    }
}

/** 促销管理 */
export interface IUpdateCouponDto {
    id?: number;
    /** 商品ID */
    productId?: number;
    /** 促销活动的标题 */
    title?: string | null;
    /** 预定价格 */
    reservePrice?: number;
    /** 抵扣价格 */
    deductionPrice?: number;
    /** 库存数量 */
    inventoryNum?: number;
    /** 是否选中 */
    isSelect?: boolean;
}

export enum CustomizedPush {
    _0 = 0,
    _1 = 1,
}

export class CustomizedPushNotificationPageDto implements ICustomizedPushNotificationPageDto {
    createTime?: moment.Moment;
    tenantName?: string | null;
    /** 年级用‘，’相隔 */
    gradeNoArrayStr?: string | null;
    id?: number;
    tenantId?: number;
    /** 推送内容 */
    content?: string | null;
    /** 需要跳转的数据名字 */
    relevantName?: string | null;
    readCount?: number;
    allCount?: number;

    constructor(data?: ICustomizedPushNotificationPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createTime = _data["createTime"] ? moment.parseZone(_data["createTime"].toString()) : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.gradeNoArrayStr = _data["gradeNoArrayStr"] !== undefined ? _data["gradeNoArrayStr"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.relevantName = _data["relevantName"] !== undefined ? _data["relevantName"] : <any>null;
            this.readCount = _data["readCount"] !== undefined ? _data["readCount"] : <any>null;
            this.allCount = _data["allCount"] !== undefined ? _data["allCount"] : <any>null;
        }
    }

    static fromJS(data: any): CustomizedPushNotificationPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizedPushNotificationPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString(true) : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["gradeNoArrayStr"] = this.gradeNoArrayStr !== undefined ? this.gradeNoArrayStr : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["relevantName"] = this.relevantName !== undefined ? this.relevantName : <any>null;
        data["readCount"] = this.readCount !== undefined ? this.readCount : <any>null;
        data["allCount"] = this.allCount !== undefined ? this.allCount : <any>null;
        return data; 
    }

    clone(): CustomizedPushNotificationPageDto {
        const json = this.toJSON();
        let result = new CustomizedPushNotificationPageDto();
        result.init(json);
        return result;
    }
}

export interface ICustomizedPushNotificationPageDto {
    createTime?: moment.Moment;
    tenantName?: string | null;
    /** 年级用‘，’相隔 */
    gradeNoArrayStr?: string | null;
    id?: number;
    tenantId?: number;
    /** 推送内容 */
    content?: string | null;
    /** 需要跳转的数据名字 */
    relevantName?: string | null;
    readCount?: number;
    allCount?: number;
}

export class CustomizedPushNotificationPageDtoPagedResultDto implements ICustomizedPushNotificationPageDtoPagedResultDto {
    items?: CustomizedPushNotificationPageDto[] | null;
    totalCount?: number;

    constructor(data?: ICustomizedPushNotificationPageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomizedPushNotificationPageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): CustomizedPushNotificationPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizedPushNotificationPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): CustomizedPushNotificationPageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomizedPushNotificationPageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomizedPushNotificationPageDtoPagedResultDto {
    items?: CustomizedPushNotificationPageDto[] | null;
    totalCount?: number;
}

export class CreateCustomizedPushNotificationDto implements ICreateCustomizedPushNotificationDto {
    tenantName?: string | null;
    /** 年级用‘，’相隔 */
    gradeNoArrayStr?: string | null;
    /** 推送内容 */
    content?: string | null;
    customizedPush?: CustomizedPush;
    /** 需要跳转的数据ID */
    relevantId?: number | null;
    /** 需要跳转的数据名字 */
    relevantName?: string | null;
    tenantId?: number;

    constructor(data?: ICreateCustomizedPushNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.gradeNoArrayStr = _data["gradeNoArrayStr"] !== undefined ? _data["gradeNoArrayStr"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
            this.customizedPush = _data["customizedPush"] !== undefined ? _data["customizedPush"] : <any>null;
            this.relevantId = _data["relevantId"] !== undefined ? _data["relevantId"] : <any>null;
            this.relevantName = _data["relevantName"] !== undefined ? _data["relevantName"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCustomizedPushNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomizedPushNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["gradeNoArrayStr"] = this.gradeNoArrayStr !== undefined ? this.gradeNoArrayStr : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        data["customizedPush"] = this.customizedPush !== undefined ? this.customizedPush : <any>null;
        data["relevantId"] = this.relevantId !== undefined ? this.relevantId : <any>null;
        data["relevantName"] = this.relevantName !== undefined ? this.relevantName : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): CreateCustomizedPushNotificationDto {
        const json = this.toJSON();
        let result = new CreateCustomizedPushNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomizedPushNotificationDto {
    tenantName?: string | null;
    /** 年级用‘，’相隔 */
    gradeNoArrayStr?: string | null;
    /** 推送内容 */
    content?: string | null;
    customizedPush?: CustomizedPush;
    /** 需要跳转的数据ID */
    relevantId?: number | null;
    /** 需要跳转的数据名字 */
    relevantName?: string | null;
    tenantId?: number;
}

export class GradeInfoListDto implements IGradeInfoListDto {
    gradeNo?: number;
    readonly className?: string | null;

    constructor(data?: IGradeInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            (<any>this).className = _data["className"] !== undefined ? _data["className"] : <any>null;
        }
    }

    static fromJS(data: any): GradeInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GradeInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["className"] = this.className !== undefined ? this.className : <any>null;
        return data; 
    }

    clone(): GradeInfoListDto {
        const json = this.toJSON();
        let result = new GradeInfoListDto();
        result.init(json);
        return result;
    }
}

export interface IGradeInfoListDto {
    gradeNo?: number;
    className?: string | null;
}

export enum RegistrationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum OrderRecordState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class ExportUnicomRegistrationInput implements IExportUnicomRegistrationInput {
    /** 名称 */
    name?: string | null;
    /** 学校名称 */
    schoolName?: string | null;
    /** 年级 */
    gradeNo?: number | null;
    /** 班级 */
    classNo?: number | null;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    registrationType?: RegistrationType;
    orderRecordState?: OrderRecordState;
    /** 开始时间 */
    startTime?: moment.Moment | null;
    /** 结束时间 */
    endTime?: moment.Moment | null;

    constructor(data?: IExportUnicomRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            this.classNo = _data["classNo"] !== undefined ? _data["classNo"] : <any>null;
            this.majorName = _data["majorName"] !== undefined ? _data["majorName"] : <any>null;
            this.majorClassNo = _data["majorClassNo"] !== undefined ? _data["majorClassNo"] : <any>null;
            this.registrationType = _data["registrationType"] !== undefined ? _data["registrationType"] : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.startTime = _data["startTime"] ? moment.parseZone(_data["startTime"].toString()) : <any>null;
            this.endTime = _data["endTime"] ? moment.parseZone(_data["endTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ExportUnicomRegistrationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportUnicomRegistrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["classNo"] = this.classNo !== undefined ? this.classNo : <any>null;
        data["majorName"] = this.majorName !== undefined ? this.majorName : <any>null;
        data["majorClassNo"] = this.majorClassNo !== undefined ? this.majorClassNo : <any>null;
        data["registrationType"] = this.registrationType !== undefined ? this.registrationType : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString(true) : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString(true) : <any>null;
        return data; 
    }

    clone(): ExportUnicomRegistrationInput {
        const json = this.toJSON();
        let result = new ExportUnicomRegistrationInput();
        result.init(json);
        return result;
    }
}

export interface IExportUnicomRegistrationInput {
    /** 名称 */
    name?: string | null;
    /** 学校名称 */
    schoolName?: string | null;
    /** 年级 */
    gradeNo?: number | null;
    /** 班级 */
    classNo?: number | null;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    registrationType?: RegistrationType;
    orderRecordState?: OrderRecordState;
    /** 开始时间 */
    startTime?: moment.Moment | null;
    /** 结束时间 */
    endTime?: moment.Moment | null;
}

export class ExportWxParentInput implements IExportWxParentInput {
    /** 学校Id */
    tenantId?: number | null;
    /** 姓名 */
    studentName?: string | null;
    /** 年级 */
    gradeNo?: number | null;
    /** 班级 */
    classNo?: number | null;
    bangdingY?: boolean | null;

    constructor(data?: IExportWxParentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : <any>null;
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            this.classNo = _data["classNo"] !== undefined ? _data["classNo"] : <any>null;
            this.bangdingY = _data["bangdingY"] !== undefined ? _data["bangdingY"] : <any>null;
        }
    }

    static fromJS(data: any): ExportWxParentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportWxParentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["studentName"] = this.studentName !== undefined ? this.studentName : <any>null;
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["classNo"] = this.classNo !== undefined ? this.classNo : <any>null;
        data["bangdingY"] = this.bangdingY !== undefined ? this.bangdingY : <any>null;
        return data; 
    }

    clone(): ExportWxParentInput {
        const json = this.toJSON();
        let result = new ExportWxParentInput();
        result.init(json);
        return result;
    }
}

export interface IExportWxParentInput {
    /** 学校Id */
    tenantId?: number | null;
    /** 姓名 */
    studentName?: string | null;
    /** 年级 */
    gradeNo?: number | null;
    /** 班级 */
    classNo?: number | null;
    bangdingY?: boolean | null;
}

export class WxPhoneParentDto implements IWxPhoneParentDto {
    identityId?: number;
    studentId?: number;
    /** 学校用户名称 */
    schoolUserName?: string | null;
    /** 绑定码 */
    code?: string | null;
    /** 学校名称 */
    schoolName?: string | null;
    /** 家长电话 */
    phoneNumber?: string | null;
    /** 关系：爸爸、妈妈 etc. */
    relation?: string | null;
    /** Y：订阅操作，N 取消订阅 */
    bindingFlag?: string | null;
    gradeNo?: number;
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    /** 班级名称 */
    readonly className?: string | null;

    constructor(data?: IWxPhoneParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityId = _data["identityId"] !== undefined ? _data["identityId"] : <any>null;
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : <any>null;
            this.schoolUserName = _data["schoolUserName"] !== undefined ? _data["schoolUserName"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.relation = _data["relation"] !== undefined ? _data["relation"] : <any>null;
            this.bindingFlag = _data["bindingFlag"] !== undefined ? _data["bindingFlag"] : <any>null;
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            this.classNo = _data["classNo"] !== undefined ? _data["classNo"] : <any>null;
            this.majorName = _data["majorName"] !== undefined ? _data["majorName"] : <any>null;
            this.majorClassNo = _data["majorClassNo"] !== undefined ? _data["majorClassNo"] : <any>null;
            (<any>this).className = _data["className"] !== undefined ? _data["className"] : <any>null;
        }
    }

    static fromJS(data: any): WxPhoneParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new WxPhoneParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId !== undefined ? this.identityId : <any>null;
        data["studentId"] = this.studentId !== undefined ? this.studentId : <any>null;
        data["schoolUserName"] = this.schoolUserName !== undefined ? this.schoolUserName : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["relation"] = this.relation !== undefined ? this.relation : <any>null;
        data["bindingFlag"] = this.bindingFlag !== undefined ? this.bindingFlag : <any>null;
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["classNo"] = this.classNo !== undefined ? this.classNo : <any>null;
        data["majorName"] = this.majorName !== undefined ? this.majorName : <any>null;
        data["majorClassNo"] = this.majorClassNo !== undefined ? this.majorClassNo : <any>null;
        data["className"] = this.className !== undefined ? this.className : <any>null;
        return data; 
    }

    clone(): WxPhoneParentDto {
        const json = this.toJSON();
        let result = new WxPhoneParentDto();
        result.init(json);
        return result;
    }
}

export interface IWxPhoneParentDto {
    identityId?: number;
    studentId?: number;
    /** 学校用户名称 */
    schoolUserName?: string | null;
    /** 绑定码 */
    code?: string | null;
    /** 学校名称 */
    schoolName?: string | null;
    /** 家长电话 */
    phoneNumber?: string | null;
    /** 关系：爸爸、妈妈 etc. */
    relation?: string | null;
    /** Y：订阅操作，N 取消订阅 */
    bindingFlag?: string | null;
    gradeNo?: number;
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    /** 班级名称 */
    className?: string | null;
}

export class PagedResultDto implements IPagedResultDto {
    /** 学校编号 */
    tenantId?: number;
    /** 学校名称 */
    schoolName?: string | null;
    /** 已同步人脸特征 */
    syncedFeatures?: number;
    /** 可以同步人脸特征 */
    canSyncFeatures?: number;
    /** 已同步人脸特征（教师） */
    syncedTeacherFeatures?: number;
    /** 可以同步人脸特征（教师） */
    canSyncTeacherFeatures?: number;

    constructor(data?: IPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            this.syncedFeatures = _data["syncedFeatures"] !== undefined ? _data["syncedFeatures"] : <any>null;
            this.canSyncFeatures = _data["canSyncFeatures"] !== undefined ? _data["canSyncFeatures"] : <any>null;
            this.syncedTeacherFeatures = _data["syncedTeacherFeatures"] !== undefined ? _data["syncedTeacherFeatures"] : <any>null;
            this.canSyncTeacherFeatures = _data["canSyncTeacherFeatures"] !== undefined ? _data["canSyncTeacherFeatures"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        data["syncedFeatures"] = this.syncedFeatures !== undefined ? this.syncedFeatures : <any>null;
        data["canSyncFeatures"] = this.canSyncFeatures !== undefined ? this.canSyncFeatures : <any>null;
        data["syncedTeacherFeatures"] = this.syncedTeacherFeatures !== undefined ? this.syncedTeacherFeatures : <any>null;
        data["canSyncTeacherFeatures"] = this.canSyncTeacherFeatures !== undefined ? this.canSyncTeacherFeatures : <any>null;
        return data; 
    }

    clone(): PagedResultDto {
        const json = this.toJSON();
        let result = new PagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDto {
    /** 学校编号 */
    tenantId?: number;
    /** 学校名称 */
    schoolName?: string | null;
    /** 已同步人脸特征 */
    syncedFeatures?: number;
    /** 可以同步人脸特征 */
    canSyncFeatures?: number;
    /** 已同步人脸特征（教师） */
    syncedTeacherFeatures?: number;
    /** 可以同步人脸特征（教师） */
    canSyncTeacherFeatures?: number;
}

export class PagedResultDtoPagedResultDto implements IPagedResultDtoPagedResultDto {
    items?: PagedResultDto[] | null;
    totalCount?: number;

    constructor(data?: IPagedResultDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PagedResultDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): PagedResultDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PagedResultDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoPagedResultDto {
    items?: PagedResultDto[] | null;
    totalCount?: number;
}

export enum PaidStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum VipType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class FaceTempleteDto implements IFaceTempleteDto {
    id?: number;
    /** 姓名 */
    name?: string | null;
    tenantId?: number;
    /** 头像 */
    imgUrl?: string | null;
    gradeNo?: number;
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    readonly currentClassDisplayName?: string | null;
    /** 学校名称 */
    tenantName?: string | null;
    /** 学号 */
    studentId?: string | null;
    /** 班主任 */
    masterTeacherName?: string | null;
    masterTeacherPhoneNumber?: string | null;
    vipType?: VipType;
    /** 会员到期时间 */
    expireDate?: moment.Moment | null;
    /** 生日 */
    birthDay?: moment.Moment;
    /** 身份证号 */
    faceTempleteIDCard?: string | null;
    /** 籍贯 */
    nativePlace?: string | null;
    /** 家庭住址 */
    familyAddress?: string | null;
    /** 民族 */
    nation?: string | null;

    constructor(data?: IFaceTempleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.imgUrl = _data["imgUrl"] !== undefined ? _data["imgUrl"] : <any>null;
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            this.classNo = _data["classNo"] !== undefined ? _data["classNo"] : <any>null;
            this.majorName = _data["majorName"] !== undefined ? _data["majorName"] : <any>null;
            this.majorClassNo = _data["majorClassNo"] !== undefined ? _data["majorClassNo"] : <any>null;
            (<any>this).currentClassDisplayName = _data["currentClassDisplayName"] !== undefined ? _data["currentClassDisplayName"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : <any>null;
            this.masterTeacherName = _data["masterTeacherName"] !== undefined ? _data["masterTeacherName"] : <any>null;
            this.masterTeacherPhoneNumber = _data["masterTeacherPhoneNumber"] !== undefined ? _data["masterTeacherPhoneNumber"] : <any>null;
            this.vipType = _data["vipType"] !== undefined ? _data["vipType"] : <any>null;
            this.expireDate = _data["expireDate"] ? moment.parseZone(_data["expireDate"].toString()) : <any>null;
            this.birthDay = _data["birthDay"] ? moment.parseZone(_data["birthDay"].toString()) : <any>null;
            this.faceTempleteIDCard = _data["faceTempleteIDCard"] !== undefined ? _data["faceTempleteIDCard"] : <any>null;
            this.nativePlace = _data["nativePlace"] !== undefined ? _data["nativePlace"] : <any>null;
            this.familyAddress = _data["familyAddress"] !== undefined ? _data["familyAddress"] : <any>null;
            this.nation = _data["nation"] !== undefined ? _data["nation"] : <any>null;
        }
    }

    static fromJS(data: any): FaceTempleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaceTempleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["imgUrl"] = this.imgUrl !== undefined ? this.imgUrl : <any>null;
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["classNo"] = this.classNo !== undefined ? this.classNo : <any>null;
        data["majorName"] = this.majorName !== undefined ? this.majorName : <any>null;
        data["majorClassNo"] = this.majorClassNo !== undefined ? this.majorClassNo : <any>null;
        data["currentClassDisplayName"] = this.currentClassDisplayName !== undefined ? this.currentClassDisplayName : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["studentId"] = this.studentId !== undefined ? this.studentId : <any>null;
        data["masterTeacherName"] = this.masterTeacherName !== undefined ? this.masterTeacherName : <any>null;
        data["masterTeacherPhoneNumber"] = this.masterTeacherPhoneNumber !== undefined ? this.masterTeacherPhoneNumber : <any>null;
        data["vipType"] = this.vipType !== undefined ? this.vipType : <any>null;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString(true) : <any>null;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString(true) : <any>null;
        data["faceTempleteIDCard"] = this.faceTempleteIDCard !== undefined ? this.faceTempleteIDCard : <any>null;
        data["nativePlace"] = this.nativePlace !== undefined ? this.nativePlace : <any>null;
        data["familyAddress"] = this.familyAddress !== undefined ? this.familyAddress : <any>null;
        data["nation"] = this.nation !== undefined ? this.nation : <any>null;
        return data; 
    }

    clone(): FaceTempleteDto {
        const json = this.toJSON();
        let result = new FaceTempleteDto();
        result.init(json);
        return result;
    }
}

export interface IFaceTempleteDto {
    id?: number;
    /** 姓名 */
    name?: string | null;
    tenantId?: number;
    /** 头像 */
    imgUrl?: string | null;
    gradeNo?: number;
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    currentClassDisplayName?: string | null;
    /** 学校名称 */
    tenantName?: string | null;
    /** 学号 */
    studentId?: string | null;
    /** 班主任 */
    masterTeacherName?: string | null;
    masterTeacherPhoneNumber?: string | null;
    vipType?: VipType;
    /** 会员到期时间 */
    expireDate?: moment.Moment | null;
    /** 生日 */
    birthDay?: moment.Moment;
    /** 身份证号 */
    faceTempleteIDCard?: string | null;
    /** 籍贯 */
    nativePlace?: string | null;
    /** 家庭住址 */
    familyAddress?: string | null;
    /** 民族 */
    nation?: string | null;
}

export enum OrderRecordForType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum OrderRecordWayType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

/** 订单Dto */
export class OrderRecordDto implements IOrderRecordDto {
    id?: string;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    /** 付款金额 */
    amount?: number;
    orderRecordForType?: OrderRecordForType;
    /** 付款标题 */
    title?: string | null;
    /** 付款描述 */
    body?: string | null;
    orderRecordWayType?: OrderRecordWayType;
    readonly orderRecordWayTypeDes?: string | null;
    /** 订单号 */
    orderNo?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderRecordState;
    /** 支付用户Id */
    orderUserId?: number;
    faceTempleteId?: number;
    /** 学校Id */
    tenantId?: number;
    /** 学校名称 */
    tenantName?: string | null;
    studentName?: string | null;
    parentName?: string | null;
    className?: string | null;

    constructor(data?: IOrderRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.orderRecordForType = _data["orderRecordForType"] !== undefined ? _data["orderRecordForType"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.orderRecordWayType = _data["orderRecordWayType"] !== undefined ? _data["orderRecordWayType"] : <any>null;
            (<any>this).orderRecordWayTypeDes = _data["orderRecordWayTypeDes"] !== undefined ? _data["orderRecordWayTypeDes"] : <any>null;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : <any>null;
            this.paidTime = _data["paidTime"] ? moment.parseZone(_data["paidTime"].toString()) : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.orderUserId = _data["orderUserId"] !== undefined ? _data["orderUserId"] : <any>null;
            this.faceTempleteId = _data["faceTempleteId"] !== undefined ? _data["faceTempleteId"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : <any>null;
            this.parentName = _data["parentName"] !== undefined ? _data["parentName"] : <any>null;
            this.className = _data["className"] !== undefined ? _data["className"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["orderRecordForType"] = this.orderRecordForType !== undefined ? this.orderRecordForType : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["orderRecordWayType"] = this.orderRecordWayType !== undefined ? this.orderRecordWayType : <any>null;
        data["orderRecordWayTypeDes"] = this.orderRecordWayTypeDes !== undefined ? this.orderRecordWayTypeDes : <any>null;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : <any>null;
        data["paidTime"] = this.paidTime ? this.paidTime.toISOString(true) : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["orderUserId"] = this.orderUserId !== undefined ? this.orderUserId : <any>null;
        data["faceTempleteId"] = this.faceTempleteId !== undefined ? this.faceTempleteId : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["studentName"] = this.studentName !== undefined ? this.studentName : <any>null;
        data["parentName"] = this.parentName !== undefined ? this.parentName : <any>null;
        data["className"] = this.className !== undefined ? this.className : <any>null;
        return data; 
    }

    clone(): OrderRecordDto {
        const json = this.toJSON();
        let result = new OrderRecordDto();
        result.init(json);
        return result;
    }
}

/** 订单Dto */
export interface IOrderRecordDto {
    id?: string;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    /** 付款金额 */
    amount?: number;
    orderRecordForType?: OrderRecordForType;
    /** 付款标题 */
    title?: string | null;
    /** 付款描述 */
    body?: string | null;
    orderRecordWayType?: OrderRecordWayType;
    orderRecordWayTypeDes?: string | null;
    /** 订单号 */
    orderNo?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderRecordState;
    /** 支付用户Id */
    orderUserId?: number;
    faceTempleteId?: number;
    /** 学校Id */
    tenantId?: number;
    /** 学校名称 */
    tenantName?: string | null;
    studentName?: string | null;
    parentName?: string | null;
    className?: string | null;
}

export enum UserType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
}

export class UserSimpleDto implements IUserSimpleDto {
    id?: number;
    userType?: UserType;
    /** 姓名 */
    name?: string | null;
    /** 用户名 */
    userName?: string | null;
    /** 电话号码. */
    phoneNumber?: string | null;
    /** 学校IdVickn.IdServer.MultiTenancy.Tenant */
    tenantId?: number | null;
    /** 头像 */
    profilePictureId?: string | null;
    /** Creation time of this entity. */
    creationTime?: moment.Moment;
    /** Id of the creator user of this entity. */
    creatorUserId?: number | null;
    isActive?: boolean;
    lastLoginTime?: moment.Moment | null;

    constructor(data?: IUserSimpleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.profilePictureId = _data["profilePictureId"] !== undefined ? _data["profilePictureId"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.lastLoginTime = _data["lastLoginTime"] ? moment.parseZone(_data["lastLoginTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserSimpleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSimpleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userType"] = this.userType !== undefined ? this.userType : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["profilePictureId"] = this.profilePictureId !== undefined ? this.profilePictureId : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString(true) : <any>null;
        return data; 
    }

    clone(): UserSimpleDto {
        const json = this.toJSON();
        let result = new UserSimpleDto();
        result.init(json);
        return result;
    }
}

export interface IUserSimpleDto {
    id?: number;
    userType?: UserType;
    /** 姓名 */
    name?: string | null;
    /** 用户名 */
    userName?: string | null;
    /** 电话号码. */
    phoneNumber?: string | null;
    /** 学校IdVickn.IdServer.MultiTenancy.Tenant */
    tenantId?: number | null;
    /** 头像 */
    profilePictureId?: string | null;
    /** Creation time of this entity. */
    creationTime?: moment.Moment;
    /** Id of the creator user of this entity. */
    creatorUserId?: number | null;
    isActive?: boolean;
    lastLoginTime?: moment.Moment | null;
}

/** 学生基本信息和支付信息Dto */
export class FaceTempletePaidDto implements IFaceTempletePaidDto {
    faceTemplete?: FaceTempleteDto;
    orderRecord?: OrderRecordDto;
    lastPaidUser?: UserSimpleDto;
    paidStatus?: PaidStatus;

    constructor(data?: IFaceTempletePaidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faceTemplete = _data["faceTemplete"] ? FaceTempleteDto.fromJS(_data["faceTemplete"]) : <any>null;
            this.orderRecord = _data["orderRecord"] ? OrderRecordDto.fromJS(_data["orderRecord"]) : <any>null;
            this.lastPaidUser = _data["lastPaidUser"] ? UserSimpleDto.fromJS(_data["lastPaidUser"]) : <any>null;
            this.paidStatus = _data["paidStatus"] !== undefined ? _data["paidStatus"] : <any>null;
        }
    }

    static fromJS(data: any): FaceTempletePaidDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaceTempletePaidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faceTemplete"] = this.faceTemplete ? this.faceTemplete.toJSON() : <any>null;
        data["orderRecord"] = this.orderRecord ? this.orderRecord.toJSON() : <any>null;
        data["lastPaidUser"] = this.lastPaidUser ? this.lastPaidUser.toJSON() : <any>null;
        data["paidStatus"] = this.paidStatus !== undefined ? this.paidStatus : <any>null;
        return data; 
    }

    clone(): FaceTempletePaidDto {
        const json = this.toJSON();
        let result = new FaceTempletePaidDto();
        result.init(json);
        return result;
    }
}

/** 学生基本信息和支付信息Dto */
export interface IFaceTempletePaidDto {
    faceTemplete?: FaceTempleteDto;
    orderRecord?: OrderRecordDto;
    lastPaidUser?: UserSimpleDto;
    paidStatus?: PaidStatus;
}

export class FaceTempletePaidDtoPagedResultDto implements IFaceTempletePaidDtoPagedResultDto {
    items?: FaceTempletePaidDto[] | null;
    totalCount?: number;

    constructor(data?: IFaceTempletePaidDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FaceTempletePaidDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): FaceTempletePaidDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaceTempletePaidDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): FaceTempletePaidDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FaceTempletePaidDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFaceTempletePaidDtoPagedResultDto {
    items?: FaceTempletePaidDto[] | null;
    totalCount?: number;
}

export class SchoolIdentityUserDto implements ISchoolIdentityUserDto {
    relation?: string | null;
    user?: UserSimpleDto;

    constructor(data?: ISchoolIdentityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relation = _data["relation"] !== undefined ? _data["relation"] : <any>null;
            this.user = _data["user"] ? UserSimpleDto.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): SchoolIdentityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolIdentityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relation"] = this.relation !== undefined ? this.relation : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }

    clone(): SchoolIdentityUserDto {
        const json = this.toJSON();
        let result = new SchoolIdentityUserDto();
        result.init(json);
        return result;
    }
}

export interface ISchoolIdentityUserDto {
    relation?: string | null;
    user?: UserSimpleDto;
}

/** 学生详细信息 */
export class FaceTempletePaidDetailDto implements IFaceTempletePaidDetailDto {
    faceTemplete?: FaceTempleteDto;
    /** 家长列表 */
    parentUsers?: SchoolIdentityUserDto[] | null;

    constructor(data?: IFaceTempletePaidDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faceTemplete = _data["faceTemplete"] ? FaceTempleteDto.fromJS(_data["faceTemplete"]) : <any>null;
            if (Array.isArray(_data["parentUsers"])) {
                this.parentUsers = [] as any;
                for (let item of _data["parentUsers"])
                    this.parentUsers!.push(SchoolIdentityUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FaceTempletePaidDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaceTempletePaidDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faceTemplete"] = this.faceTemplete ? this.faceTemplete.toJSON() : <any>null;
        if (Array.isArray(this.parentUsers)) {
            data["parentUsers"] = [];
            for (let item of this.parentUsers)
                data["parentUsers"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FaceTempletePaidDetailDto {
        const json = this.toJSON();
        let result = new FaceTempletePaidDetailDto();
        result.init(json);
        return result;
    }
}

/** 学生详细信息 */
export interface IFaceTempletePaidDetailDto {
    faceTemplete?: FaceTempleteDto;
    /** 家长列表 */
    parentUsers?: SchoolIdentityUserDto[] | null;
}

/** 学生订单详细信息 */
export class FaceTempletePaidOrderDetailDto implements IFaceTempletePaidOrderDetailDto {
    faceTemplete?: FaceTempleteDto;
    /** 最后付费订单信息 */
    orderRecords?: OrderRecordDto[] | null;
    lastPaidUser?: SchoolIdentityUserDto;
    lastOrderRecord?: OrderRecordDto;

    constructor(data?: IFaceTempletePaidOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faceTemplete = _data["faceTemplete"] ? FaceTempleteDto.fromJS(_data["faceTemplete"]) : <any>null;
            if (Array.isArray(_data["orderRecords"])) {
                this.orderRecords = [] as any;
                for (let item of _data["orderRecords"])
                    this.orderRecords!.push(OrderRecordDto.fromJS(item));
            }
            this.lastPaidUser = _data["lastPaidUser"] ? SchoolIdentityUserDto.fromJS(_data["lastPaidUser"]) : <any>null;
            this.lastOrderRecord = _data["lastOrderRecord"] ? OrderRecordDto.fromJS(_data["lastOrderRecord"]) : <any>null;
        }
    }

    static fromJS(data: any): FaceTempletePaidOrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaceTempletePaidOrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faceTemplete"] = this.faceTemplete ? this.faceTemplete.toJSON() : <any>null;
        if (Array.isArray(this.orderRecords)) {
            data["orderRecords"] = [];
            for (let item of this.orderRecords)
                data["orderRecords"].push(item.toJSON());
        }
        data["lastPaidUser"] = this.lastPaidUser ? this.lastPaidUser.toJSON() : <any>null;
        data["lastOrderRecord"] = this.lastOrderRecord ? this.lastOrderRecord.toJSON() : <any>null;
        return data; 
    }

    clone(): FaceTempletePaidOrderDetailDto {
        const json = this.toJSON();
        let result = new FaceTempletePaidOrderDetailDto();
        result.init(json);
        return result;
    }
}

/** 学生订单详细信息 */
export interface IFaceTempletePaidOrderDetailDto {
    faceTemplete?: FaceTempleteDto;
    /** 最后付费订单信息 */
    orderRecords?: OrderRecordDto[] | null;
    lastPaidUser?: SchoolIdentityUserDto;
    lastOrderRecord?: OrderRecordDto;
}

/** Vip更新更新 */
export enum VipUpdateType {
    _0 = 0,
    _1 = 1,
}

/** 修改学生会员 */
export class UpdateFaceTempleteVipTypeInput implements IUpdateFaceTempleteVipTypeInput {
    /** 人脸Id列表 */
    faceTempleteIds!: number[];
    vipType?: VipType;
    /** 到期时间 */
    expireDate?: moment.Moment;
    vipUpdateType?: VipUpdateType;
    tenantId?: number;

    constructor(data?: IUpdateFaceTempleteVipTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.faceTempleteIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["faceTempleteIds"])) {
                this.faceTempleteIds = [] as any;
                for (let item of _data["faceTempleteIds"])
                    this.faceTempleteIds!.push(item);
            }
            this.vipType = _data["vipType"] !== undefined ? _data["vipType"] : <any>null;
            this.expireDate = _data["expireDate"] ? moment.parseZone(_data["expireDate"].toString()) : <any>null;
            this.vipUpdateType = _data["vipUpdateType"] !== undefined ? _data["vipUpdateType"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateFaceTempleteVipTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFaceTempleteVipTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.faceTempleteIds)) {
            data["faceTempleteIds"] = [];
            for (let item of this.faceTempleteIds)
                data["faceTempleteIds"].push(item);
        }
        data["vipType"] = this.vipType !== undefined ? this.vipType : <any>null;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString(true) : <any>null;
        data["vipUpdateType"] = this.vipUpdateType !== undefined ? this.vipUpdateType : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): UpdateFaceTempleteVipTypeInput {
        const json = this.toJSON();
        let result = new UpdateFaceTempleteVipTypeInput();
        result.init(json);
        return result;
    }
}

/** 修改学生会员 */
export interface IUpdateFaceTempleteVipTypeInput {
    /** 人脸Id列表 */
    faceTempleteIds: number[];
    vipType?: VipType;
    /** 到期时间 */
    expireDate?: moment.Moment;
    vipUpdateType?: VipUpdateType;
    tenantId?: number;
}

export enum VipPaymentType {
    _0 = 0,
    _1 = 1,
}

export class UserDto implements IUserDto {
    id?: number;
    userName!: string;
    name!: string;
    phoneNumber!: string;
    isActive?: boolean;
    fullName?: string | null;
    lastLoginTime?: moment.Moment | null;
    creationTime?: moment.Moment;
    roleNames?: string[] | null;
    isPhoneNumberConfirmed?: boolean;
    /** 用户版本 */
    appVersion?: string | null;
    userType?: UserType;
    readonly userTypeDes?: string | null;
    /** 是否是教育局账号 */
    isEdcationUser?: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.lastLoginTime = _data["lastLoginTime"] ? moment.parseZone(_data["lastLoginTime"].toString()) : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"] !== undefined ? _data["isPhoneNumberConfirmed"] : <any>null;
            this.appVersion = _data["appVersion"] !== undefined ? _data["appVersion"] : <any>null;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : <any>null;
            (<any>this).userTypeDes = _data["userTypeDes"] !== undefined ? _data["userTypeDes"] : <any>null;
            this.isEdcationUser = _data["isEdcationUser"] !== undefined ? _data["isEdcationUser"] : <any>null;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString(true) : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed !== undefined ? this.isPhoneNumberConfirmed : <any>null;
        data["appVersion"] = this.appVersion !== undefined ? this.appVersion : <any>null;
        data["userType"] = this.userType !== undefined ? this.userType : <any>null;
        data["userTypeDes"] = this.userTypeDes !== undefined ? this.userTypeDes : <any>null;
        data["isEdcationUser"] = this.isEdcationUser !== undefined ? this.isEdcationUser : <any>null;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id?: number;
    userName: string;
    name: string;
    phoneNumber: string;
    isActive?: boolean;
    fullName?: string | null;
    lastLoginTime?: moment.Moment | null;
    creationTime?: moment.Moment;
    roleNames?: string[] | null;
    isPhoneNumberConfirmed?: boolean;
    /** 用户版本 */
    appVersion?: string | null;
    userType?: UserType;
    userTypeDes?: string | null;
    /** 是否是教育局账号 */
    isEdcationUser?: boolean;
}

export class VipPaymentRecordDto implements IVipPaymentRecordDto {
    id?: string;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    /** 充值时长 */
    month?: number;
    /** 充值日期 */
    paidDate?: moment.Moment | null;
    isSuccess?: boolean;
    vipType?: VipType;
    /** 充值会员类型 */
    readonly vipTypeDes?: string | null;
    vipPaymentType?: VipPaymentType;
    /** 充值类型 */
    readonly vipPaymentTypeDes?: string | null;
    /** 人脸记录Id */
    faceTempleteId?: number;
    /** 充值人Id */
    orderUserId?: number;
    orderUser?: UserDto;

    constructor(data?: IVipPaymentRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.month = _data["month"] !== undefined ? _data["month"] : <any>null;
            this.paidDate = _data["paidDate"] ? moment.parseZone(_data["paidDate"].toString()) : <any>null;
            this.isSuccess = _data["isSuccess"] !== undefined ? _data["isSuccess"] : <any>null;
            this.vipType = _data["vipType"] !== undefined ? _data["vipType"] : <any>null;
            (<any>this).vipTypeDes = _data["vipTypeDes"] !== undefined ? _data["vipTypeDes"] : <any>null;
            this.vipPaymentType = _data["vipPaymentType"] !== undefined ? _data["vipPaymentType"] : <any>null;
            (<any>this).vipPaymentTypeDes = _data["vipPaymentTypeDes"] !== undefined ? _data["vipPaymentTypeDes"] : <any>null;
            this.faceTempleteId = _data["faceTempleteId"] !== undefined ? _data["faceTempleteId"] : <any>null;
            this.orderUserId = _data["orderUserId"] !== undefined ? _data["orderUserId"] : <any>null;
            this.orderUser = _data["orderUser"] ? UserDto.fromJS(_data["orderUser"]) : <any>null;
        }
    }

    static fromJS(data: any): VipPaymentRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new VipPaymentRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["month"] = this.month !== undefined ? this.month : <any>null;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString(true) : <any>null;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : <any>null;
        data["vipType"] = this.vipType !== undefined ? this.vipType : <any>null;
        data["vipTypeDes"] = this.vipTypeDes !== undefined ? this.vipTypeDes : <any>null;
        data["vipPaymentType"] = this.vipPaymentType !== undefined ? this.vipPaymentType : <any>null;
        data["vipPaymentTypeDes"] = this.vipPaymentTypeDes !== undefined ? this.vipPaymentTypeDes : <any>null;
        data["faceTempleteId"] = this.faceTempleteId !== undefined ? this.faceTempleteId : <any>null;
        data["orderUserId"] = this.orderUserId !== undefined ? this.orderUserId : <any>null;
        data["orderUser"] = this.orderUser ? this.orderUser.toJSON() : <any>null;
        return data; 
    }

    clone(): VipPaymentRecordDto {
        const json = this.toJSON();
        let result = new VipPaymentRecordDto();
        result.init(json);
        return result;
    }
}

export interface IVipPaymentRecordDto {
    id?: string;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    /** 充值时长 */
    month?: number;
    /** 充值日期 */
    paidDate?: moment.Moment | null;
    isSuccess?: boolean;
    vipType?: VipType;
    /** 充值会员类型 */
    vipTypeDes?: string | null;
    vipPaymentType?: VipPaymentType;
    /** 充值类型 */
    vipPaymentTypeDes?: string | null;
    /** 人脸记录Id */
    faceTempleteId?: number;
    /** 充值人Id */
    orderUserId?: number;
    orderUser?: UserDto;
}

export class VipPaymentRecordDtoPagedResultDto implements IVipPaymentRecordDtoPagedResultDto {
    items?: VipPaymentRecordDto[] | null;
    totalCount?: number;

    constructor(data?: IVipPaymentRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VipPaymentRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): VipPaymentRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VipPaymentRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): VipPaymentRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VipPaymentRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVipPaymentRecordDtoPagedResultDto {
    items?: VipPaymentRecordDto[] | null;
    totalCount?: number;
}

export class WxPhoneParentDtoPagedResultDto implements IWxPhoneParentDtoPagedResultDto {
    items?: WxPhoneParentDto[] | null;
    totalCount?: number;

    constructor(data?: IWxPhoneParentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WxPhoneParentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): WxPhoneParentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WxPhoneParentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): WxPhoneParentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WxPhoneParentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWxPhoneParentDtoPagedResultDto {
    items?: WxPhoneParentDto[] | null;
    totalCount?: number;
}

export class WxPhoneParentStatic implements IWxPhoneParentStatic {
    wxPhoneParentY?: number;
    wxPhoneParentN?: number;

    constructor(data?: IWxPhoneParentStatic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wxPhoneParentY = _data["wxPhoneParentY"] !== undefined ? _data["wxPhoneParentY"] : <any>null;
            this.wxPhoneParentN = _data["wxPhoneParentN"] !== undefined ? _data["wxPhoneParentN"] : <any>null;
        }
    }

    static fromJS(data: any): WxPhoneParentStatic {
        data = typeof data === 'object' ? data : {};
        let result = new WxPhoneParentStatic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wxPhoneParentY"] = this.wxPhoneParentY !== undefined ? this.wxPhoneParentY : <any>null;
        data["wxPhoneParentN"] = this.wxPhoneParentN !== undefined ? this.wxPhoneParentN : <any>null;
        return data; 
    }

    clone(): WxPhoneParentStatic {
        const json = this.toJSON();
        let result = new WxPhoneParentStatic();
        result.init(json);
        return result;
    }
}

export interface IWxPhoneParentStatic {
    wxPhoneParentY?: number;
    wxPhoneParentN?: number;
}

export class MemberPushSettingDto implements IMemberPushSettingDto {
    id?: number;
    /** 学校ID */
    tenantId?: number;
    /** 学校名称 */
    tenantName?: string | null;
    /** 是否开启 */
    settingIsOpen?: boolean;
    /** 提前推送的天数 */
    daysInAdvance?: number;
    /** 多少天1次 */
    intervalDays?: number;
    /** 会员到期前，推送时间 */
    beforePushTime?: string | null;
    /** 是否开启会员 结束后推送提醒 */
    isOpentAfterPush?: boolean;
    /** 会员结束后三天每天推送一次，推送时间 */
    afterPushTime?: string | null;

    constructor(data?: IMemberPushSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.settingIsOpen = _data["settingIsOpen"] !== undefined ? _data["settingIsOpen"] : <any>null;
            this.daysInAdvance = _data["daysInAdvance"] !== undefined ? _data["daysInAdvance"] : <any>null;
            this.intervalDays = _data["intervalDays"] !== undefined ? _data["intervalDays"] : <any>null;
            this.beforePushTime = _data["beforePushTime"] !== undefined ? _data["beforePushTime"] : <any>null;
            this.isOpentAfterPush = _data["isOpentAfterPush"] !== undefined ? _data["isOpentAfterPush"] : <any>null;
            this.afterPushTime = _data["afterPushTime"] !== undefined ? _data["afterPushTime"] : <any>null;
        }
    }

    static fromJS(data: any): MemberPushSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberPushSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["settingIsOpen"] = this.settingIsOpen !== undefined ? this.settingIsOpen : <any>null;
        data["daysInAdvance"] = this.daysInAdvance !== undefined ? this.daysInAdvance : <any>null;
        data["intervalDays"] = this.intervalDays !== undefined ? this.intervalDays : <any>null;
        data["beforePushTime"] = this.beforePushTime !== undefined ? this.beforePushTime : <any>null;
        data["isOpentAfterPush"] = this.isOpentAfterPush !== undefined ? this.isOpentAfterPush : <any>null;
        data["afterPushTime"] = this.afterPushTime !== undefined ? this.afterPushTime : <any>null;
        return data; 
    }

    clone(): MemberPushSettingDto {
        const json = this.toJSON();
        let result = new MemberPushSettingDto();
        result.init(json);
        return result;
    }
}

export interface IMemberPushSettingDto {
    id?: number;
    /** 学校ID */
    tenantId?: number;
    /** 学校名称 */
    tenantName?: string | null;
    /** 是否开启 */
    settingIsOpen?: boolean;
    /** 提前推送的天数 */
    daysInAdvance?: number;
    /** 多少天1次 */
    intervalDays?: number;
    /** 会员到期前，推送时间 */
    beforePushTime?: string | null;
    /** 是否开启会员 结束后推送提醒 */
    isOpentAfterPush?: boolean;
    /** 会员结束后三天每天推送一次，推送时间 */
    afterPushTime?: string | null;
}

export class MemberPushSettingDtoPagedResultDto implements IMemberPushSettingDtoPagedResultDto {
    items?: MemberPushSettingDto[] | null;
    totalCount?: number;

    constructor(data?: IMemberPushSettingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MemberPushSettingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): MemberPushSettingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberPushSettingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): MemberPushSettingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MemberPushSettingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMemberPushSettingDtoPagedResultDto {
    items?: MemberPushSettingDto[] | null;
    totalCount?: number;
}

export class Int32EntityDto implements IInt32EntityDto {
    id?: number;

    constructor(data?: IInt32EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): Int32EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data; 
    }

    clone(): Int32EntityDto {
        const json = this.toJSON();
        let result = new Int32EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt32EntityDto {
    id?: number;
}

export class Address implements IAddress {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    name?: string | null;
    phone?: string | null;
    province?: string | null;
    city?: string | null;
    area?: string | null;
    detail?: string | null;
    isSelect?: boolean;
    code?: string | null;
    readonly getAdreesDetail?: string | null;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.lastModificationTime = _data["lastModificationTime"] ? moment.parseZone(_data["lastModificationTime"].toString()) : <any>null;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : <any>null;
            this.deletionTime = _data["deletionTime"] ? moment.parseZone(_data["deletionTime"].toString()) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.province = _data["province"] !== undefined ? _data["province"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.isSelect = _data["isSelect"] !== undefined ? _data["isSelect"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            (<any>this).getAdreesDetail = _data["getAdreesDetail"] !== undefined ? _data["getAdreesDetail"] : <any>null;
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString(true) : <any>null;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : <any>null;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString(true) : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["isSelect"] = this.isSelect !== undefined ? this.isSelect : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["getAdreesDetail"] = this.getAdreesDetail !== undefined ? this.getAdreesDetail : <any>null;
        return data; 
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    name?: string | null;
    phone?: string | null;
    province?: string | null;
    city?: string | null;
    area?: string | null;
    detail?: string | null;
    isSelect?: boolean;
    code?: string | null;
    getAdreesDetail?: string | null;
}

export enum OrderWayType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum OrderForType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum OrderState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

export class ProductCategory implements IProductCategory {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    name?: string | null;
    describe?: string | null;
    subtitle?: string | null;
    unitType?: number;
    isShow?: boolean;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.lastModificationTime = _data["lastModificationTime"] ? moment.parseZone(_data["lastModificationTime"].toString()) : <any>null;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : <any>null;
            this.deletionTime = _data["deletionTime"] ? moment.parseZone(_data["deletionTime"].toString()) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : <any>null;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : <any>null;
            this.unitType = _data["unitType"] !== undefined ? _data["unitType"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
        }
    }

    static fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString(true) : <any>null;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : <any>null;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString(true) : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["describe"] = this.describe !== undefined ? this.describe : <any>null;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : <any>null;
        data["unitType"] = this.unitType !== undefined ? this.unitType : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        return data; 
    }

    clone(): ProductCategory {
        const json = this.toJSON();
        let result = new ProductCategory();
        result.init(json);
        return result;
    }
}

export interface IProductCategory {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    name?: string | null;
    describe?: string | null;
    subtitle?: string | null;
    unitType?: number;
    isShow?: boolean;
}

export class ProductAttachment implements IProductAttachment {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    productId?: number;
    p_Path?: string | null;
    attachmentType?: string | null;

    constructor(data?: IProductAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.lastModificationTime = _data["lastModificationTime"] ? moment.parseZone(_data["lastModificationTime"].toString()) : <any>null;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : <any>null;
            this.deletionTime = _data["deletionTime"] ? moment.parseZone(_data["deletionTime"].toString()) : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.attachmentType = _data["attachmentType"] !== undefined ? _data["attachmentType"] : <any>null;
        }
    }

    static fromJS(data: any): ProductAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString(true) : <any>null;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : <any>null;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString(true) : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["attachmentType"] = this.attachmentType !== undefined ? this.attachmentType : <any>null;
        return data; 
    }

    clone(): ProductAttachment {
        const json = this.toJSON();
        let result = new ProductAttachment();
        result.init(json);
        return result;
    }
}

export interface IProductAttachment {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    productId?: number;
    p_Path?: string | null;
    attachmentType?: string | null;
}

export class ProductSpecification implements IProductSpecification {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    specName?: string | null;
    productId?: number;
    integral?: number;
    inventoryNum?: number;
    beforePrice?: number;
    afterPrice?: number;
    isSelect?: boolean;

    constructor(data?: IProductSpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.lastModificationTime = _data["lastModificationTime"] ? moment.parseZone(_data["lastModificationTime"].toString()) : <any>null;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : <any>null;
            this.deletionTime = _data["deletionTime"] ? moment.parseZone(_data["deletionTime"].toString()) : <any>null;
            this.specName = _data["specName"] !== undefined ? _data["specName"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.integral = _data["integral"] !== undefined ? _data["integral"] : <any>null;
            this.inventoryNum = _data["inventoryNum"] !== undefined ? _data["inventoryNum"] : <any>null;
            this.beforePrice = _data["beforePrice"] !== undefined ? _data["beforePrice"] : <any>null;
            this.afterPrice = _data["afterPrice"] !== undefined ? _data["afterPrice"] : <any>null;
            this.isSelect = _data["isSelect"] !== undefined ? _data["isSelect"] : <any>null;
        }
    }

    static fromJS(data: any): ProductSpecification {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSpecification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString(true) : <any>null;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : <any>null;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString(true) : <any>null;
        data["specName"] = this.specName !== undefined ? this.specName : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["integral"] = this.integral !== undefined ? this.integral : <any>null;
        data["inventoryNum"] = this.inventoryNum !== undefined ? this.inventoryNum : <any>null;
        data["beforePrice"] = this.beforePrice !== undefined ? this.beforePrice : <any>null;
        data["afterPrice"] = this.afterPrice !== undefined ? this.afterPrice : <any>null;
        data["isSelect"] = this.isSelect !== undefined ? this.isSelect : <any>null;
        return data; 
    }

    clone(): ProductSpecification {
        const json = this.toJSON();
        let result = new ProductSpecification();
        result.init(json);
        return result;
    }
}

export interface IProductSpecification {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    specName?: string | null;
    productId?: number;
    integral?: number;
    inventoryNum?: number;
    beforePrice?: number;
    afterPrice?: number;
    isSelect?: boolean;
}

export class Product implements IProduct {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    name?: string | null;
    subtitle?: string | null;
    productCategoryId?: number;
    productCategory?: ProductCategory;
    p_Path?: string | null;
    describe?: string | null;
    state?: number;
    isShow?: boolean;
    isFree?: boolean;
    isStartGroupBuying?: boolean;
    groupBuyingName?: string | null;
    groupBuyingAmount?: number;
    beforePrice?: number;
    price?: number;
    integral?: number;
    salesType?: string | null;
    imageList?: ProductAttachment[] | null;
    specificationList?: ProductSpecification[] | null;
    readCount?: number;
    saleNum?: number;
    isShowHot?: boolean;
    isShowEndTimeAndDiscount?: boolean;
    endTimeOfPromotion?: moment.Moment | null;
    promotionRemark?: string | null;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.lastModificationTime = _data["lastModificationTime"] ? moment.parseZone(_data["lastModificationTime"].toString()) : <any>null;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : <any>null;
            this.deletionTime = _data["deletionTime"] ? moment.parseZone(_data["deletionTime"].toString()) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : <any>null;
            this.productCategoryId = _data["productCategoryId"] !== undefined ? _data["productCategoryId"] : <any>null;
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
            this.isFree = _data["isFree"] !== undefined ? _data["isFree"] : <any>null;
            this.isStartGroupBuying = _data["isStartGroupBuying"] !== undefined ? _data["isStartGroupBuying"] : <any>null;
            this.groupBuyingName = _data["groupBuyingName"] !== undefined ? _data["groupBuyingName"] : <any>null;
            this.groupBuyingAmount = _data["groupBuyingAmount"] !== undefined ? _data["groupBuyingAmount"] : <any>null;
            this.beforePrice = _data["beforePrice"] !== undefined ? _data["beforePrice"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.integral = _data["integral"] !== undefined ? _data["integral"] : <any>null;
            this.salesType = _data["salesType"] !== undefined ? _data["salesType"] : <any>null;
            if (Array.isArray(_data["imageList"])) {
                this.imageList = [] as any;
                for (let item of _data["imageList"])
                    this.imageList!.push(ProductAttachment.fromJS(item));
            }
            if (Array.isArray(_data["specificationList"])) {
                this.specificationList = [] as any;
                for (let item of _data["specificationList"])
                    this.specificationList!.push(ProductSpecification.fromJS(item));
            }
            this.readCount = _data["readCount"] !== undefined ? _data["readCount"] : <any>null;
            this.saleNum = _data["saleNum"] !== undefined ? _data["saleNum"] : <any>null;
            this.isShowHot = _data["isShowHot"] !== undefined ? _data["isShowHot"] : <any>null;
            this.isShowEndTimeAndDiscount = _data["isShowEndTimeAndDiscount"] !== undefined ? _data["isShowEndTimeAndDiscount"] : <any>null;
            this.endTimeOfPromotion = _data["endTimeOfPromotion"] ? moment.parseZone(_data["endTimeOfPromotion"].toString()) : <any>null;
            this.promotionRemark = _data["promotionRemark"] !== undefined ? _data["promotionRemark"] : <any>null;
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString(true) : <any>null;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : <any>null;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString(true) : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : <any>null;
        data["productCategoryId"] = this.productCategoryId !== undefined ? this.productCategoryId : <any>null;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["describe"] = this.describe !== undefined ? this.describe : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        data["isFree"] = this.isFree !== undefined ? this.isFree : <any>null;
        data["isStartGroupBuying"] = this.isStartGroupBuying !== undefined ? this.isStartGroupBuying : <any>null;
        data["groupBuyingName"] = this.groupBuyingName !== undefined ? this.groupBuyingName : <any>null;
        data["groupBuyingAmount"] = this.groupBuyingAmount !== undefined ? this.groupBuyingAmount : <any>null;
        data["beforePrice"] = this.beforePrice !== undefined ? this.beforePrice : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["integral"] = this.integral !== undefined ? this.integral : <any>null;
        data["salesType"] = this.salesType !== undefined ? this.salesType : <any>null;
        if (Array.isArray(this.imageList)) {
            data["imageList"] = [];
            for (let item of this.imageList)
                data["imageList"].push(item.toJSON());
        }
        if (Array.isArray(this.specificationList)) {
            data["specificationList"] = [];
            for (let item of this.specificationList)
                data["specificationList"].push(item.toJSON());
        }
        data["readCount"] = this.readCount !== undefined ? this.readCount : <any>null;
        data["saleNum"] = this.saleNum !== undefined ? this.saleNum : <any>null;
        data["isShowHot"] = this.isShowHot !== undefined ? this.isShowHot : <any>null;
        data["isShowEndTimeAndDiscount"] = this.isShowEndTimeAndDiscount !== undefined ? this.isShowEndTimeAndDiscount : <any>null;
        data["endTimeOfPromotion"] = this.endTimeOfPromotion ? this.endTimeOfPromotion.toISOString(true) : <any>null;
        data["promotionRemark"] = this.promotionRemark !== undefined ? this.promotionRemark : <any>null;
        return data; 
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    name?: string | null;
    subtitle?: string | null;
    productCategoryId?: number;
    productCategory?: ProductCategory;
    p_Path?: string | null;
    describe?: string | null;
    state?: number;
    isShow?: boolean;
    isFree?: boolean;
    isStartGroupBuying?: boolean;
    groupBuyingName?: string | null;
    groupBuyingAmount?: number;
    beforePrice?: number;
    price?: number;
    integral?: number;
    salesType?: string | null;
    imageList?: ProductAttachment[] | null;
    specificationList?: ProductSpecification[] | null;
    readCount?: number;
    saleNum?: number;
    isShowHot?: boolean;
    isShowEndTimeAndDiscount?: boolean;
    endTimeOfPromotion?: moment.Moment | null;
    promotionRemark?: string | null;
}

export class OrderDetail implements IOrderDetail {
    id?: string;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    orderId?: string;
    productId?: number;
    product?: Product;
    num?: number;
    price?: number;
    toTalMoney?: number;
    specificationID?: number;
    productSpecifications?: ProductSpecification;

    constructor(data?: IOrderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.lastModificationTime = _data["lastModificationTime"] ? moment.parseZone(_data["lastModificationTime"].toString()) : <any>null;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : <any>null;
            this.deletionTime = _data["deletionTime"] ? moment.parseZone(_data["deletionTime"].toString()) : <any>null;
            this.orderId = _data["orderId"] !== undefined ? _data["orderId"] : <any>null;
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>null;
            this.num = _data["num"] !== undefined ? _data["num"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
            this.specificationID = _data["specificationID"] !== undefined ? _data["specificationID"] : <any>null;
            this.productSpecifications = _data["productSpecifications"] ? ProductSpecification.fromJS(_data["productSpecifications"]) : <any>null;
        }
    }

    static fromJS(data: any): OrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString(true) : <any>null;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : <any>null;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString(true) : <any>null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["num"] = this.num !== undefined ? this.num : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        data["specificationID"] = this.specificationID !== undefined ? this.specificationID : <any>null;
        data["productSpecifications"] = this.productSpecifications ? this.productSpecifications.toJSON() : <any>null;
        return data; 
    }

    clone(): OrderDetail {
        const json = this.toJSON();
        let result = new OrderDetail();
        result.init(json);
        return result;
    }
}

export interface IOrderDetail {
    id?: string;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    orderId?: string;
    productId?: number;
    product?: Product;
    num?: number;
    price?: number;
    toTalMoney?: number;
    specificationID?: number;
    productSpecifications?: ProductSpecification;
}

export class Order implements IOrder {
    id?: string;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    orderNumber?: string | null;
    serialNo?: string | null;
    code?: string | null;
    address_ID?: number | null;
    address?: Address;
    toTalMoney?: number;
    orderRecordWayType?: OrderWayType;
    orderRecordForType?: OrderForType;
    orderAmount?: number;
    amount?: number;
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    companyName?: string | null;
    companyCode?: string | null;
    companyNumber?: string | null;
    orderDetails?: OrderDetail[] | null;
    description?: string | null;
    deliveryTime?: moment.Moment | null;
    contactName?: string | null;
    contactPhone?: string | null;
    deductionPoint?: number;
    deductionAmount?: number;
    liviePoint?: number;
    returnsTime?: moment.Moment | null;
    returnsReason?: string | null;
    returnType?: string | null;
    returnDescribe?: string | null;
    refuseUnsubscribeReason?: string | null;
    attachment?: string | null;
    promotionalAmount?: number;
    promotionalDeduction?: number;
    promotionalOrderID?: string | null;
    studentNameAndCode?: string | null;
    studentTenantName?: string | null;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.lastModificationTime = _data["lastModificationTime"] ? moment.parseZone(_data["lastModificationTime"].toString()) : <any>null;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : <any>null;
            this.deletionTime = _data["deletionTime"] ? moment.parseZone(_data["deletionTime"].toString()) : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.address_ID = _data["address_ID"] !== undefined ? _data["address_ID"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
            this.orderRecordWayType = _data["orderRecordWayType"] !== undefined ? _data["orderRecordWayType"] : <any>null;
            this.orderRecordForType = _data["orderRecordForType"] !== undefined ? _data["orderRecordForType"] : <any>null;
            this.orderAmount = _data["orderAmount"] !== undefined ? _data["orderAmount"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.paidTime = _data["paidTime"] ? moment.parseZone(_data["paidTime"].toString()) : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : <any>null;
            this.companyNumber = _data["companyNumber"] !== undefined ? _data["companyNumber"] : <any>null;
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.deliveryTime = _data["deliveryTime"] ? moment.parseZone(_data["deliveryTime"].toString()) : <any>null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
            this.deductionPoint = _data["deductionPoint"] !== undefined ? _data["deductionPoint"] : <any>null;
            this.deductionAmount = _data["deductionAmount"] !== undefined ? _data["deductionAmount"] : <any>null;
            this.liviePoint = _data["liviePoint"] !== undefined ? _data["liviePoint"] : <any>null;
            this.returnsTime = _data["returnsTime"] ? moment.parseZone(_data["returnsTime"].toString()) : <any>null;
            this.returnsReason = _data["returnsReason"] !== undefined ? _data["returnsReason"] : <any>null;
            this.returnType = _data["returnType"] !== undefined ? _data["returnType"] : <any>null;
            this.returnDescribe = _data["returnDescribe"] !== undefined ? _data["returnDescribe"] : <any>null;
            this.refuseUnsubscribeReason = _data["refuseUnsubscribeReason"] !== undefined ? _data["refuseUnsubscribeReason"] : <any>null;
            this.attachment = _data["attachment"] !== undefined ? _data["attachment"] : <any>null;
            this.promotionalAmount = _data["promotionalAmount"] !== undefined ? _data["promotionalAmount"] : <any>null;
            this.promotionalDeduction = _data["promotionalDeduction"] !== undefined ? _data["promotionalDeduction"] : <any>null;
            this.promotionalOrderID = _data["promotionalOrderID"] !== undefined ? _data["promotionalOrderID"] : <any>null;
            this.studentNameAndCode = _data["studentNameAndCode"] !== undefined ? _data["studentNameAndCode"] : <any>null;
            this.studentTenantName = _data["studentTenantName"] !== undefined ? _data["studentTenantName"] : <any>null;
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString(true) : <any>null;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : <any>null;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString(true) : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["address_ID"] = this.address_ID !== undefined ? this.address_ID : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        data["orderRecordWayType"] = this.orderRecordWayType !== undefined ? this.orderRecordWayType : <any>null;
        data["orderRecordForType"] = this.orderRecordForType !== undefined ? this.orderRecordForType : <any>null;
        data["orderAmount"] = this.orderAmount !== undefined ? this.orderAmount : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["paidTime"] = this.paidTime ? this.paidTime.toISOString(true) : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : <any>null;
        data["companyNumber"] = this.companyNumber !== undefined ? this.companyNumber : <any>null;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString(true) : <any>null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        data["deductionPoint"] = this.deductionPoint !== undefined ? this.deductionPoint : <any>null;
        data["deductionAmount"] = this.deductionAmount !== undefined ? this.deductionAmount : <any>null;
        data["liviePoint"] = this.liviePoint !== undefined ? this.liviePoint : <any>null;
        data["returnsTime"] = this.returnsTime ? this.returnsTime.toISOString(true) : <any>null;
        data["returnsReason"] = this.returnsReason !== undefined ? this.returnsReason : <any>null;
        data["returnType"] = this.returnType !== undefined ? this.returnType : <any>null;
        data["returnDescribe"] = this.returnDescribe !== undefined ? this.returnDescribe : <any>null;
        data["refuseUnsubscribeReason"] = this.refuseUnsubscribeReason !== undefined ? this.refuseUnsubscribeReason : <any>null;
        data["attachment"] = this.attachment !== undefined ? this.attachment : <any>null;
        data["promotionalAmount"] = this.promotionalAmount !== undefined ? this.promotionalAmount : <any>null;
        data["promotionalDeduction"] = this.promotionalDeduction !== undefined ? this.promotionalDeduction : <any>null;
        data["promotionalOrderID"] = this.promotionalOrderID !== undefined ? this.promotionalOrderID : <any>null;
        data["studentNameAndCode"] = this.studentNameAndCode !== undefined ? this.studentNameAndCode : <any>null;
        data["studentTenantName"] = this.studentTenantName !== undefined ? this.studentTenantName : <any>null;
        return data; 
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    id?: string;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    orderNumber?: string | null;
    serialNo?: string | null;
    code?: string | null;
    address_ID?: number | null;
    address?: Address;
    toTalMoney?: number;
    orderRecordWayType?: OrderWayType;
    orderRecordForType?: OrderForType;
    orderAmount?: number;
    amount?: number;
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    companyName?: string | null;
    companyCode?: string | null;
    companyNumber?: string | null;
    orderDetails?: OrderDetail[] | null;
    description?: string | null;
    deliveryTime?: moment.Moment | null;
    contactName?: string | null;
    contactPhone?: string | null;
    deductionPoint?: number;
    deductionAmount?: number;
    liviePoint?: number;
    returnsTime?: moment.Moment | null;
    returnsReason?: string | null;
    returnType?: string | null;
    returnDescribe?: string | null;
    refuseUnsubscribeReason?: string | null;
    attachment?: string | null;
    promotionalAmount?: number;
    promotionalDeduction?: number;
    promotionalOrderID?: string | null;
    studentNameAndCode?: string | null;
    studentTenantName?: string | null;
}

export class CreateOrderDto implements ICreateOrderDto {
    /** 订单ID */
    order_ID?: number;
    order?: Order;
    /** 商品ID */
    product_ID?: number;
    product?: Product;
    /** 数量 */
    num?: number;
    /** 总价格 */
    toTalMoney?: number;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;

    constructor(data?: ICreateOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order_ID = _data["order_ID"] !== undefined ? _data["order_ID"] : <any>null;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>null;
            this.product_ID = _data["product_ID"] !== undefined ? _data["product_ID"] : <any>null;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>null;
            this.num = _data["num"] !== undefined ? _data["num"] : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order_ID"] = this.order_ID !== undefined ? this.order_ID : <any>null;
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        data["product_ID"] = this.product_ID !== undefined ? this.product_ID : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["num"] = this.num !== undefined ? this.num : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        return data; 
    }

    clone(): CreateOrderDto {
        const json = this.toJSON();
        let result = new CreateOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderDto {
    /** 订单ID */
    order_ID?: number;
    order?: Order;
    /** 商品ID */
    product_ID?: number;
    product?: Product;
    /** 数量 */
    num?: number;
    /** 总价格 */
    toTalMoney?: number;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
}

/** 产品信息 */
export class OrderDto implements IOrderDto {
    id?: string;
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 地址ID,关联地址列表 */
    address_ID?: number;
    address?: Address;
    /** 订单总价格 */
    toTalMoney?: number;
    /** 支付状态 */
    paymentState?: number;
    /** 付款标题 */
    title?: string | null;
    /** 付款描述 */
    body?: string | null;
    orderRecordWayType?: OrderWayType;
    readonly orderRecordWayTypeDes?: string | null;
    orderRecordForType?: OrderForType;
    /** 订单金额 */
    orderAmount?: number;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 订单状态显示名称 */
    readonly orderStateWayTypeDes?: string | null;
    /** 快递名称 */
    companyName?: string | null;
    /** 快递编码 */
    companyCode?: string | null;
    /** 物流单号 */
    companyNumber?: string | null;
    /** 订单明细表 */
    orderDetails?: OrderDetail[] | null;
    /** 下单时间 */
    creationTime?: moment.Moment | null;
    /** 备注描述 */
    description?: string | null;
    /** 发货时间 */
    deliveryTime?: moment.Moment | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
    /** 退货时间 */
    returnsTime?: moment.Moment | null;
    /** 退货原因 */
    returnsReason?: string | null;
    /** 退款类型 */
    returnType?: string | null;
    /** 退款描述 */
    returnDescribe?: string | null;
    /** 学生姓名和绑定码 */
    studentNameAndCode?: string | null;
    /** 学校姓名 */
    studentTenantName?: string | null;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.address_ID = _data["address_ID"] !== undefined ? _data["address_ID"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
            this.paymentState = _data["paymentState"] !== undefined ? _data["paymentState"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.orderRecordWayType = _data["orderRecordWayType"] !== undefined ? _data["orderRecordWayType"] : <any>null;
            (<any>this).orderRecordWayTypeDes = _data["orderRecordWayTypeDes"] !== undefined ? _data["orderRecordWayTypeDes"] : <any>null;
            this.orderRecordForType = _data["orderRecordForType"] !== undefined ? _data["orderRecordForType"] : <any>null;
            this.orderAmount = _data["orderAmount"] !== undefined ? _data["orderAmount"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.paidTime = _data["paidTime"] ? moment.parseZone(_data["paidTime"].toString()) : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            (<any>this).orderStateWayTypeDes = _data["orderStateWayTypeDes"] !== undefined ? _data["orderStateWayTypeDes"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : <any>null;
            this.companyNumber = _data["companyNumber"] !== undefined ? _data["companyNumber"] : <any>null;
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.deliveryTime = _data["deliveryTime"] ? moment.parseZone(_data["deliveryTime"].toString()) : <any>null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
            this.returnsTime = _data["returnsTime"] ? moment.parseZone(_data["returnsTime"].toString()) : <any>null;
            this.returnsReason = _data["returnsReason"] !== undefined ? _data["returnsReason"] : <any>null;
            this.returnType = _data["returnType"] !== undefined ? _data["returnType"] : <any>null;
            this.returnDescribe = _data["returnDescribe"] !== undefined ? _data["returnDescribe"] : <any>null;
            this.studentNameAndCode = _data["studentNameAndCode"] !== undefined ? _data["studentNameAndCode"] : <any>null;
            this.studentTenantName = _data["studentTenantName"] !== undefined ? _data["studentTenantName"] : <any>null;
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["address_ID"] = this.address_ID !== undefined ? this.address_ID : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        data["paymentState"] = this.paymentState !== undefined ? this.paymentState : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["orderRecordWayType"] = this.orderRecordWayType !== undefined ? this.orderRecordWayType : <any>null;
        data["orderRecordWayTypeDes"] = this.orderRecordWayTypeDes !== undefined ? this.orderRecordWayTypeDes : <any>null;
        data["orderRecordForType"] = this.orderRecordForType !== undefined ? this.orderRecordForType : <any>null;
        data["orderAmount"] = this.orderAmount !== undefined ? this.orderAmount : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["paidTime"] = this.paidTime ? this.paidTime.toISOString(true) : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["orderStateWayTypeDes"] = this.orderStateWayTypeDes !== undefined ? this.orderStateWayTypeDes : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : <any>null;
        data["companyNumber"] = this.companyNumber !== undefined ? this.companyNumber : <any>null;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString(true) : <any>null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        data["returnsTime"] = this.returnsTime ? this.returnsTime.toISOString(true) : <any>null;
        data["returnsReason"] = this.returnsReason !== undefined ? this.returnsReason : <any>null;
        data["returnType"] = this.returnType !== undefined ? this.returnType : <any>null;
        data["returnDescribe"] = this.returnDescribe !== undefined ? this.returnDescribe : <any>null;
        data["studentNameAndCode"] = this.studentNameAndCode !== undefined ? this.studentNameAndCode : <any>null;
        data["studentTenantName"] = this.studentTenantName !== undefined ? this.studentTenantName : <any>null;
        return data; 
    }

    clone(): OrderDto {
        const json = this.toJSON();
        let result = new OrderDto();
        result.init(json);
        return result;
    }
}

/** 产品信息 */
export interface IOrderDto {
    id?: string;
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 地址ID,关联地址列表 */
    address_ID?: number;
    address?: Address;
    /** 订单总价格 */
    toTalMoney?: number;
    /** 支付状态 */
    paymentState?: number;
    /** 付款标题 */
    title?: string | null;
    /** 付款描述 */
    body?: string | null;
    orderRecordWayType?: OrderWayType;
    orderRecordWayTypeDes?: string | null;
    orderRecordForType?: OrderForType;
    /** 订单金额 */
    orderAmount?: number;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 订单状态显示名称 */
    orderStateWayTypeDes?: string | null;
    /** 快递名称 */
    companyName?: string | null;
    /** 快递编码 */
    companyCode?: string | null;
    /** 物流单号 */
    companyNumber?: string | null;
    /** 订单明细表 */
    orderDetails?: OrderDetail[] | null;
    /** 下单时间 */
    creationTime?: moment.Moment | null;
    /** 备注描述 */
    description?: string | null;
    /** 发货时间 */
    deliveryTime?: moment.Moment | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
    /** 退货时间 */
    returnsTime?: moment.Moment | null;
    /** 退货原因 */
    returnsReason?: string | null;
    /** 退款类型 */
    returnType?: string | null;
    /** 退款描述 */
    returnDescribe?: string | null;
    /** 学生姓名和绑定码 */
    studentNameAndCode?: string | null;
    /** 学校姓名 */
    studentTenantName?: string | null;
}

export class OrderDtoPagedResultDto implements IOrderDtoPagedResultDto {
    items?: OrderDto[] | null;
    totalCount?: number;

    constructor(data?: IOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): OrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDtoPagedResultDto {
    items?: OrderDto[] | null;
    totalCount?: number;
}

/** 修改产品 */
export class UpdateOrderDto implements IUpdateOrderDto {
    id?: string;
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 地址ID,关联地址列表 */
    address_ID?: number;
    address?: Address;
    /** 订单总价格 */
    toTalMoney?: number;
    /** 支付状态 */
    paymentState?: number;
    /** 付款标题 */
    title?: string | null;
    /** 付款描述 */
    body?: string | null;
    orderRecordWayType?: OrderWayType;
    readonly orderRecordWayTypeDes?: string | null;
    orderRecordForType?: OrderForType;
    /** 订单金额 */
    orderAmount?: number;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 订单状态显示名称 */
    readonly orderStateWayTypeDes?: string | null;
    /** 快递名称 */
    companyName?: string | null;
    /** 快递编码 */
    companyCode?: string | null;
    /** 物流单号 */
    companyNumber?: string | null;
    /** 订单明细表 */
    orderDetails?: OrderDetail[] | null;
    /** 下单时间 */
    creationTime?: moment.Moment | null;
    /** 备注描述 */
    description?: string | null;
    /** 发货时间 */
    deliveryTime?: moment.Moment | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;

    constructor(data?: IUpdateOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.address_ID = _data["address_ID"] !== undefined ? _data["address_ID"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
            this.paymentState = _data["paymentState"] !== undefined ? _data["paymentState"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.orderRecordWayType = _data["orderRecordWayType"] !== undefined ? _data["orderRecordWayType"] : <any>null;
            (<any>this).orderRecordWayTypeDes = _data["orderRecordWayTypeDes"] !== undefined ? _data["orderRecordWayTypeDes"] : <any>null;
            this.orderRecordForType = _data["orderRecordForType"] !== undefined ? _data["orderRecordForType"] : <any>null;
            this.orderAmount = _data["orderAmount"] !== undefined ? _data["orderAmount"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.paidTime = _data["paidTime"] ? moment.parseZone(_data["paidTime"].toString()) : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            (<any>this).orderStateWayTypeDes = _data["orderStateWayTypeDes"] !== undefined ? _data["orderStateWayTypeDes"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : <any>null;
            this.companyNumber = _data["companyNumber"] !== undefined ? _data["companyNumber"] : <any>null;
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.deliveryTime = _data["deliveryTime"] ? moment.parseZone(_data["deliveryTime"].toString()) : <any>null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["address_ID"] = this.address_ID !== undefined ? this.address_ID : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        data["paymentState"] = this.paymentState !== undefined ? this.paymentState : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["orderRecordWayType"] = this.orderRecordWayType !== undefined ? this.orderRecordWayType : <any>null;
        data["orderRecordWayTypeDes"] = this.orderRecordWayTypeDes !== undefined ? this.orderRecordWayTypeDes : <any>null;
        data["orderRecordForType"] = this.orderRecordForType !== undefined ? this.orderRecordForType : <any>null;
        data["orderAmount"] = this.orderAmount !== undefined ? this.orderAmount : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["paidTime"] = this.paidTime ? this.paidTime.toISOString(true) : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["orderStateWayTypeDes"] = this.orderStateWayTypeDes !== undefined ? this.orderStateWayTypeDes : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : <any>null;
        data["companyNumber"] = this.companyNumber !== undefined ? this.companyNumber : <any>null;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString(true) : <any>null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        return data; 
    }

    clone(): UpdateOrderDto {
        const json = this.toJSON();
        let result = new UpdateOrderDto();
        result.init(json);
        return result;
    }
}

/** 修改产品 */
export interface IUpdateOrderDto {
    id?: string;
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 地址ID,关联地址列表 */
    address_ID?: number;
    address?: Address;
    /** 订单总价格 */
    toTalMoney?: number;
    /** 支付状态 */
    paymentState?: number;
    /** 付款标题 */
    title?: string | null;
    /** 付款描述 */
    body?: string | null;
    orderRecordWayType?: OrderWayType;
    orderRecordWayTypeDes?: string | null;
    orderRecordForType?: OrderForType;
    /** 订单金额 */
    orderAmount?: number;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 订单状态显示名称 */
    orderStateWayTypeDes?: string | null;
    /** 快递名称 */
    companyName?: string | null;
    /** 快递编码 */
    companyCode?: string | null;
    /** 物流单号 */
    companyNumber?: string | null;
    /** 订单明细表 */
    orderDetails?: OrderDetail[] | null;
    /** 下单时间 */
    creationTime?: moment.Moment | null;
    /** 备注描述 */
    description?: string | null;
    /** 发货时间 */
    deliveryTime?: moment.Moment | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
}

/** 产品信息 */
export class TransportDto implements ITransportDto {
    id?: number;
    /** 物流名称 */
    name?: string | null;
    /** 物流编码 */
    companyCode?: string | null;

    constructor(data?: ITransportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : <any>null;
        }
    }

    static fromJS(data: any): TransportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : <any>null;
        return data; 
    }

    clone(): TransportDto {
        const json = this.toJSON();
        let result = new TransportDto();
        result.init(json);
        return result;
    }
}

/** 产品信息 */
export interface ITransportDto {
    id?: number;
    /** 物流名称 */
    name?: string | null;
    /** 物流编码 */
    companyCode?: string | null;
}

export class OrderDeliveryInput implements IOrderDeliveryInput {
    /** 订单号 */
    orderNumer?: string | null;
    /** 快递名称 */
    companyName?: string | null;
    /** 快递编码 */
    companyCode?: string | null;
    /** 物流单号 */
    companyNumber?: string | null;

    constructor(data?: IOrderDeliveryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumer = _data["orderNumer"] !== undefined ? _data["orderNumer"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : <any>null;
            this.companyNumber = _data["companyNumber"] !== undefined ? _data["companyNumber"] : <any>null;
        }
    }

    static fromJS(data: any): OrderDeliveryInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDeliveryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumer"] = this.orderNumer !== undefined ? this.orderNumer : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : <any>null;
        data["companyNumber"] = this.companyNumber !== undefined ? this.companyNumber : <any>null;
        return data; 
    }

    clone(): OrderDeliveryInput {
        const json = this.toJSON();
        let result = new OrderDeliveryInput();
        result.init(json);
        return result;
    }
}

export interface IOrderDeliveryInput {
    /** 订单号 */
    orderNumer?: string | null;
    /** 快递名称 */
    companyName?: string | null;
    /** 快递编码 */
    companyCode?: string | null;
    /** 物流单号 */
    companyNumber?: string | null;
}

export class OrderStatisticDto implements IOrderStatisticDto {
    /** 待支付的数量 */
    toBePaidConut?: number;
    /** 已支付的数量 */
    paidConut?: number;
    /** 待发货的数量 */
    toBeShippedConut?: number;
    /** 已发货的数量 */
    deliveryConut?: number;
    /** 已退货数量 */
    refundedConut?: number;
    /** 已完成的数量 */
    completeConut?: number;
    /** 已取消的数量 */
    cancelConut?: number;

    constructor(data?: IOrderStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toBePaidConut = _data["toBePaidConut"] !== undefined ? _data["toBePaidConut"] : <any>null;
            this.paidConut = _data["paidConut"] !== undefined ? _data["paidConut"] : <any>null;
            this.toBeShippedConut = _data["toBeShippedConut"] !== undefined ? _data["toBeShippedConut"] : <any>null;
            this.deliveryConut = _data["deliveryConut"] !== undefined ? _data["deliveryConut"] : <any>null;
            this.refundedConut = _data["refundedConut"] !== undefined ? _data["refundedConut"] : <any>null;
            this.completeConut = _data["completeConut"] !== undefined ? _data["completeConut"] : <any>null;
            this.cancelConut = _data["cancelConut"] !== undefined ? _data["cancelConut"] : <any>null;
        }
    }

    static fromJS(data: any): OrderStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toBePaidConut"] = this.toBePaidConut !== undefined ? this.toBePaidConut : <any>null;
        data["paidConut"] = this.paidConut !== undefined ? this.paidConut : <any>null;
        data["toBeShippedConut"] = this.toBeShippedConut !== undefined ? this.toBeShippedConut : <any>null;
        data["deliveryConut"] = this.deliveryConut !== undefined ? this.deliveryConut : <any>null;
        data["refundedConut"] = this.refundedConut !== undefined ? this.refundedConut : <any>null;
        data["completeConut"] = this.completeConut !== undefined ? this.completeConut : <any>null;
        data["cancelConut"] = this.cancelConut !== undefined ? this.cancelConut : <any>null;
        return data; 
    }

    clone(): OrderStatisticDto {
        const json = this.toJSON();
        let result = new OrderStatisticDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStatisticDto {
    /** 待支付的数量 */
    toBePaidConut?: number;
    /** 已支付的数量 */
    paidConut?: number;
    /** 待发货的数量 */
    toBeShippedConut?: number;
    /** 已发货的数量 */
    deliveryConut?: number;
    /** 已退货数量 */
    refundedConut?: number;
    /** 已完成的数量 */
    completeConut?: number;
    /** 已取消的数量 */
    cancelConut?: number;
}

/** 文件附件列表 */
export class FileAttachment implements IFileAttachment {
    /** 文件附件 */
    attachment?: string | null;

    constructor(data?: IFileAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachment = _data["attachment"] !== undefined ? _data["attachment"] : <any>null;
        }
    }

    static fromJS(data: any): FileAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment !== undefined ? this.attachment : <any>null;
        return data; 
    }

    clone(): FileAttachment {
        const json = this.toJSON();
        let result = new FileAttachment();
        result.init(json);
        return result;
    }
}

/** 文件附件列表 */
export interface IFileAttachment {
    /** 文件附件 */
    attachment?: string | null;
}

/** 退货信息 */
export class OrderReturnDto implements IOrderReturnDto {
    /** 退货时间 */
    returnsTime?: moment.Moment | null;
    /** 退货原因 */
    returnsReason?: string | null;
    /** 退款类型 */
    returnType?: string | null;
    /** 退款描述 */
    returnDescribe?: string | null;
    /** 退款金额 */
    amount?: number;
    orderDetails?: OrderDetail[] | null;
    /** 文件附件 */
    attachment?: string | null;
    /** 附件返回一个list */
    readonly fileAttachments?: FileAttachment[] | null;

    constructor(data?: IOrderReturnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnsTime = _data["returnsTime"] ? moment.parseZone(_data["returnsTime"].toString()) : <any>null;
            this.returnsReason = _data["returnsReason"] !== undefined ? _data["returnsReason"] : <any>null;
            this.returnType = _data["returnType"] !== undefined ? _data["returnType"] : <any>null;
            this.returnDescribe = _data["returnDescribe"] !== undefined ? _data["returnDescribe"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
            this.attachment = _data["attachment"] !== undefined ? _data["attachment"] : <any>null;
            if (Array.isArray(_data["fileAttachments"])) {
                (<any>this).fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    (<any>this).fileAttachments!.push(FileAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderReturnDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReturnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnsTime"] = this.returnsTime ? this.returnsTime.toISOString(true) : <any>null;
        data["returnsReason"] = this.returnsReason !== undefined ? this.returnsReason : <any>null;
        data["returnType"] = this.returnType !== undefined ? this.returnType : <any>null;
        data["returnDescribe"] = this.returnDescribe !== undefined ? this.returnDescribe : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        data["attachment"] = this.attachment !== undefined ? this.attachment : <any>null;
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderReturnDto {
        const json = this.toJSON();
        let result = new OrderReturnDto();
        result.init(json);
        return result;
    }
}

/** 退货信息 */
export interface IOrderReturnDto {
    /** 退货时间 */
    returnsTime?: moment.Moment | null;
    /** 退货原因 */
    returnsReason?: string | null;
    /** 退款类型 */
    returnType?: string | null;
    /** 退款描述 */
    returnDescribe?: string | null;
    /** 退款金额 */
    amount?: number;
    orderDetails?: OrderDetail[] | null;
    /** 文件附件 */
    attachment?: string | null;
    /** 附件返回一个list */
    fileAttachments?: FileAttachment[] | null;
}

export class OrderCancelInput implements IOrderCancelInput {
    /** 订单号 */
    orderNumer?: string | null;
    orderRecordState?: OrderState;

    constructor(data?: IOrderCancelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumer = _data["orderNumer"] !== undefined ? _data["orderNumer"] : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
        }
    }

    static fromJS(data: any): OrderCancelInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCancelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumer"] = this.orderNumer !== undefined ? this.orderNumer : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        return data; 
    }

    clone(): OrderCancelInput {
        const json = this.toJSON();
        let result = new OrderCancelInput();
        result.init(json);
        return result;
    }
}

export interface IOrderCancelInput {
    /** 订单号 */
    orderNumer?: string | null;
    orderRecordState?: OrderState;
}

export class OrderRefuseInput implements IOrderRefuseInput {
    /** 订单号 */
    orderNumer?: string | null;
    /** 拒绝退订的内容 */
    refuseUnsubscribeReason?: string | null;

    constructor(data?: IOrderRefuseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumer = _data["orderNumer"] !== undefined ? _data["orderNumer"] : <any>null;
            this.refuseUnsubscribeReason = _data["refuseUnsubscribeReason"] !== undefined ? _data["refuseUnsubscribeReason"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRefuseInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRefuseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumer"] = this.orderNumer !== undefined ? this.orderNumer : <any>null;
        data["refuseUnsubscribeReason"] = this.refuseUnsubscribeReason !== undefined ? this.refuseUnsubscribeReason : <any>null;
        return data; 
    }

    clone(): OrderRefuseInput {
        const json = this.toJSON();
        let result = new OrderRefuseInput();
        result.init(json);
        return result;
    }
}

export interface IOrderRefuseInput {
    /** 订单号 */
    orderNumer?: string | null;
    /** 拒绝退订的内容 */
    refuseUnsubscribeReason?: string | null;
}

export class StringStringTuple implements IStringStringTuple {
    readonly item1?: string | null;
    readonly item2?: string | null;

    constructor(data?: IStringStringTuple) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item1 = _data["item1"] !== undefined ? _data["item1"] : <any>null;
            (<any>this).item2 = _data["item2"] !== undefined ? _data["item2"] : <any>null;
        }
    }

    static fromJS(data: any): StringStringTuple {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringTuple();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 !== undefined ? this.item1 : <any>null;
        data["item2"] = this.item2 !== undefined ? this.item2 : <any>null;
        return data; 
    }

    clone(): StringStringTuple {
        const json = this.toJSON();
        let result = new StringStringTuple();
        result.init(json);
        return result;
    }
}

export interface IStringStringTuple {
    item1?: string | null;
    item2?: string | null;
}

export class TrackInput implements ITrackInput {
    /** 快递编码 */
    companyCode?: string | null;
    /** 物流单号 */
    companyNumber?: string | null;

    constructor(data?: ITrackInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"] !== undefined ? _data["companyCode"] : <any>null;
            this.companyNumber = _data["companyNumber"] !== undefined ? _data["companyNumber"] : <any>null;
        }
    }

    static fromJS(data: any): TrackInput {
        data = typeof data === 'object' ? data : {};
        let result = new TrackInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode !== undefined ? this.companyCode : <any>null;
        data["companyNumber"] = this.companyNumber !== undefined ? this.companyNumber : <any>null;
        return data; 
    }

    clone(): TrackInput {
        const json = this.toJSON();
        let result = new TrackInput();
        result.init(json);
        return result;
    }
}

export interface ITrackInput {
    /** 快递编码 */
    companyCode?: string | null;
    /** 物流单号 */
    companyNumber?: string | null;
}

export class OperationPointsItem implements IOperationPointsItem {
    tenantId?: number;
    tenantName?: string | null;
    /** 排名 */
    orderNum?: number;
    /** 积分数 */
    points?: number;
    /** 教师ID */
    userId?: number;
    /** 电话 */
    phoneNumber?: string | null;
    /** 姓名 */
    name?: string | null;

    constructor(data?: IOperationPointsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.orderNum = _data["orderNum"] !== undefined ? _data["orderNum"] : <any>null;
            this.points = _data["points"] !== undefined ? _data["points"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): OperationPointsItem {
        data = typeof data === 'object' ? data : {};
        let result = new OperationPointsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["orderNum"] = this.orderNum !== undefined ? this.orderNum : <any>null;
        data["points"] = this.points !== undefined ? this.points : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }

    clone(): OperationPointsItem {
        const json = this.toJSON();
        let result = new OperationPointsItem();
        result.init(json);
        return result;
    }
}

export interface IOperationPointsItem {
    tenantId?: number;
    tenantName?: string | null;
    /** 排名 */
    orderNum?: number;
    /** 积分数 */
    points?: number;
    /** 教师ID */
    userId?: number;
    /** 电话 */
    phoneNumber?: string | null;
    /** 姓名 */
    name?: string | null;
}

/** 手机端获取积分实体 */
export class OperationPointsDto implements IOperationPointsDto {
    items?: OperationPointsItem[] | null;
    totalCount?: number;
    /** 积分总数 */
    pointSum?: number;

    constructor(data?: IOperationPointsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperationPointsItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.pointSum = _data["pointSum"] !== undefined ? _data["pointSum"] : <any>null;
        }
    }

    static fromJS(data: any): OperationPointsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationPointsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["pointSum"] = this.pointSum !== undefined ? this.pointSum : <any>null;
        return data; 
    }

    clone(): OperationPointsDto {
        const json = this.toJSON();
        let result = new OperationPointsDto();
        result.init(json);
        return result;
    }
}

/** 手机端获取积分实体 */
export interface IOperationPointsDto {
    items?: OperationPointsItem[] | null;
    totalCount?: number;
    /** 积分总数 */
    pointSum?: number;
}

export enum OperationPointType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
}

/** 个人详情实体 */
export class OperationPointsDetailItem implements IOperationPointsDetailItem {
    tenantId?: number;
    tenantName?: string | null;
    /** 姓名 */
    name?: string | null;
    type?: OperationPointType;
    /** 来源类型描述 */
    readonly typeStr?: string | null;
    /** 积分数 */
    points?: number;
    creationTime?: moment.Moment;
    /** 获得积分时间描述 */
    readonly creationTimeStr?: string | null;

    constructor(data?: IOperationPointsDetailItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            (<any>this).typeStr = _data["typeStr"] !== undefined ? _data["typeStr"] : <any>null;
            this.points = _data["points"] !== undefined ? _data["points"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            (<any>this).creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : <any>null;
        }
    }

    static fromJS(data: any): OperationPointsDetailItem {
        data = typeof data === 'object' ? data : {};
        let result = new OperationPointsDetailItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["typeStr"] = this.typeStr !== undefined ? this.typeStr : <any>null;
        data["points"] = this.points !== undefined ? this.points : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : <any>null;
        return data; 
    }

    clone(): OperationPointsDetailItem {
        const json = this.toJSON();
        let result = new OperationPointsDetailItem();
        result.init(json);
        return result;
    }
}

/** 个人详情实体 */
export interface IOperationPointsDetailItem {
    tenantId?: number;
    tenantName?: string | null;
    /** 姓名 */
    name?: string | null;
    type?: OperationPointType;
    /** 来源类型描述 */
    typeStr?: string | null;
    /** 积分数 */
    points?: number;
    creationTime?: moment.Moment;
    /** 获得积分时间描述 */
    creationTimeStr?: string | null;
}

export class OperationPointsDetailItemPagedResultDto implements IOperationPointsDetailItemPagedResultDto {
    items?: OperationPointsDetailItem[] | null;
    totalCount?: number;

    constructor(data?: IOperationPointsDetailItemPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OperationPointsDetailItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): OperationPointsDetailItemPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperationPointsDetailItemPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): OperationPointsDetailItemPagedResultDto {
        const json = this.toJSON();
        let result = new OperationPointsDetailItemPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOperationPointsDetailItemPagedResultDto {
    items?: OperationPointsDetailItem[] | null;
    totalCount?: number;
}

export class RuleUserReamarkDto implements IRuleUserReamarkDto {
    /** 跳转按钮描述 */
    ruleUseRemarks?: string | null;
    id?: number;

    constructor(data?: IRuleUserReamarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleUseRemarks = _data["ruleUseRemarks"] !== undefined ? _data["ruleUseRemarks"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): RuleUserReamarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleUserReamarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleUseRemarks"] = this.ruleUseRemarks !== undefined ? this.ruleUseRemarks : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data; 
    }

    clone(): RuleUserReamarkDto {
        const json = this.toJSON();
        let result = new RuleUserReamarkDto();
        result.init(json);
        return result;
    }
}

export interface IRuleUserReamarkDto {
    /** 跳转按钮描述 */
    ruleUseRemarks?: string | null;
    id?: number;
}

/** 创建学校负责人 */
export class CreateOperationsInput implements ICreateOperationsInput {
    name?: string | null;
    phone?: string | null;
    tenantIds?: number[] | null;

    constructor(data?: ICreateOperationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOperationsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOperationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        return data; 
    }

    clone(): CreateOperationsInput {
        const json = this.toJSON();
        let result = new CreateOperationsInput();
        result.init(json);
        return result;
    }
}

/** 创建学校负责人 */
export interface ICreateOperationsInput {
    name?: string | null;
    phone?: string | null;
    tenantIds?: number[] | null;
}

/** 创建运维人员信息ID */
export class CreateTenantWorkUserRelationshipInput implements ICreateTenantWorkUserRelationshipInput {
    /** 运维人员记录ID */
    tenantWorkUserId?: number;
    name?: string | null;
    phone?: string | null;
    /** 运维的学校ID */
    tenantIds?: number[] | null;

    constructor(data?: ICreateTenantWorkUserRelationshipInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantWorkUserId = _data["tenantWorkUserId"] !== undefined ? _data["tenantWorkUserId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTenantWorkUserRelationshipInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantWorkUserRelationshipInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantWorkUserId"] = this.tenantWorkUserId !== undefined ? this.tenantWorkUserId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        return data; 
    }

    clone(): CreateTenantWorkUserRelationshipInput {
        const json = this.toJSON();
        let result = new CreateTenantWorkUserRelationshipInput();
        result.init(json);
        return result;
    }
}

/** 创建运维人员信息ID */
export interface ICreateTenantWorkUserRelationshipInput {
    /** 运维人员记录ID */
    tenantWorkUserId?: number;
    name?: string | null;
    phone?: string | null;
    /** 运维的学校ID */
    tenantIds?: number[] | null;
}

export class UserRelationshipDto implements IUserRelationshipDto {
    /** 学校ID */
    tenantId?: number;
    /** 学校名称 */
    tenantName?: string | null;
    isChick?: boolean;

    constructor(data?: IUserRelationshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.isChick = _data["isChick"] !== undefined ? _data["isChick"] : <any>null;
        }
    }

    static fromJS(data: any): UserRelationshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRelationshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["isChick"] = this.isChick !== undefined ? this.isChick : <any>null;
        return data; 
    }

    clone(): UserRelationshipDto {
        const json = this.toJSON();
        let result = new UserRelationshipDto();
        result.init(json);
        return result;
    }
}

export interface IUserRelationshipDto {
    /** 学校ID */
    tenantId?: number;
    /** 学校名称 */
    tenantName?: string | null;
    isChick?: boolean;
}

export class TenantWorkUserRelationshipDto implements ITenantWorkUserRelationshipDto {
    tenantWorkUserId?: number;
    /** 用户姓名 */
    userName?: string | null;
    /** 用户电话 */
    phoneNumber?: string | null;
    relationships?: UserRelationshipDto[] | null;

    constructor(data?: ITenantWorkUserRelationshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantWorkUserId = _data["tenantWorkUserId"] !== undefined ? _data["tenantWorkUserId"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            if (Array.isArray(_data["relationships"])) {
                this.relationships = [] as any;
                for (let item of _data["relationships"])
                    this.relationships!.push(UserRelationshipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantWorkUserRelationshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantWorkUserRelationshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantWorkUserId"] = this.tenantWorkUserId !== undefined ? this.tenantWorkUserId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        if (Array.isArray(this.relationships)) {
            data["relationships"] = [];
            for (let item of this.relationships)
                data["relationships"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TenantWorkUserRelationshipDto {
        const json = this.toJSON();
        let result = new TenantWorkUserRelationshipDto();
        result.init(json);
        return result;
    }
}

export interface ITenantWorkUserRelationshipDto {
    tenantWorkUserId?: number;
    /** 用户姓名 */
    userName?: string | null;
    /** 用户电话 */
    phoneNumber?: string | null;
    relationships?: UserRelationshipDto[] | null;
}

/** 获取运维人员主界面列表实体 */
export class TenantWorkUserRelationshipPageDto implements ITenantWorkUserRelationshipPageDto {
    tenantWorkUserId?: number;
    /** 姓名 */
    userName?: string | null;
    /** 用户电话 */
    phoneNumber?: string | null;
    /** 创建时间 */
    creationTime?: moment.Moment;
    /** 相关联的学校数量 */
    relationTenantCount?: number;

    constructor(data?: ITenantWorkUserRelationshipPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantWorkUserId = _data["tenantWorkUserId"] !== undefined ? _data["tenantWorkUserId"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.relationTenantCount = _data["relationTenantCount"] !== undefined ? _data["relationTenantCount"] : <any>null;
        }
    }

    static fromJS(data: any): TenantWorkUserRelationshipPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantWorkUserRelationshipPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantWorkUserId"] = this.tenantWorkUserId !== undefined ? this.tenantWorkUserId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["relationTenantCount"] = this.relationTenantCount !== undefined ? this.relationTenantCount : <any>null;
        return data; 
    }

    clone(): TenantWorkUserRelationshipPageDto {
        const json = this.toJSON();
        let result = new TenantWorkUserRelationshipPageDto();
        result.init(json);
        return result;
    }
}

/** 获取运维人员主界面列表实体 */
export interface ITenantWorkUserRelationshipPageDto {
    tenantWorkUserId?: number;
    /** 姓名 */
    userName?: string | null;
    /** 用户电话 */
    phoneNumber?: string | null;
    /** 创建时间 */
    creationTime?: moment.Moment;
    /** 相关联的学校数量 */
    relationTenantCount?: number;
}

export class TenantWorkUserRelationshipPageDtoPagedResultDto implements ITenantWorkUserRelationshipPageDtoPagedResultDto {
    items?: TenantWorkUserRelationshipPageDto[] | null;
    totalCount?: number;

    constructor(data?: ITenantWorkUserRelationshipPageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantWorkUserRelationshipPageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): TenantWorkUserRelationshipPageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantWorkUserRelationshipPageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): TenantWorkUserRelationshipPageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantWorkUserRelationshipPageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantWorkUserRelationshipPageDtoPagedResultDto {
    items?: TenantWorkUserRelationshipPageDto[] | null;
    totalCount?: number;
}

/** 学校Dto */
export class SimpleTenantDto implements ISimpleTenantDto {
    id?: number;
    /** TenancyName */
    tenancyName?: string | null;
    /** Name */
    name?: string | null;
    position?: string | null;
    /** 是否为关联学校 */
    isRelationSchool?: boolean;
    /** 是否为运维人员 */
    isMaintainPerson?: boolean;
    /** 是否为三方服务提供商 */
    isServiceProvider?: boolean;
    /** 经营类型：自营、代理、重点保障 */
    billingType?: number;
    /** 收费类型：C端、B端、C端B端 */
    businessType?: number;
    isChecked?: boolean;

    constructor(data?: ISimpleTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenancyName = _data["tenancyName"] !== undefined ? _data["tenancyName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.isRelationSchool = _data["isRelationSchool"] !== undefined ? _data["isRelationSchool"] : <any>null;
            this.isMaintainPerson = _data["isMaintainPerson"] !== undefined ? _data["isMaintainPerson"] : <any>null;
            this.isServiceProvider = _data["isServiceProvider"] !== undefined ? _data["isServiceProvider"] : <any>null;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : <any>null;
            this.businessType = _data["businessType"] !== undefined ? _data["businessType"] : <any>null;
            this.isChecked = _data["isChecked"] !== undefined ? _data["isChecked"] : <any>null;
        }
    }

    static fromJS(data: any): SimpleTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenancyName"] = this.tenancyName !== undefined ? this.tenancyName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["isRelationSchool"] = this.isRelationSchool !== undefined ? this.isRelationSchool : <any>null;
        data["isMaintainPerson"] = this.isMaintainPerson !== undefined ? this.isMaintainPerson : <any>null;
        data["isServiceProvider"] = this.isServiceProvider !== undefined ? this.isServiceProvider : <any>null;
        data["billingType"] = this.billingType !== undefined ? this.billingType : <any>null;
        data["businessType"] = this.businessType !== undefined ? this.businessType : <any>null;
        data["isChecked"] = this.isChecked !== undefined ? this.isChecked : <any>null;
        return data; 
    }

    clone(): SimpleTenantDto {
        const json = this.toJSON();
        let result = new SimpleTenantDto();
        result.init(json);
        return result;
    }
}

/** 学校Dto */
export interface ISimpleTenantDto {
    id?: number;
    /** TenancyName */
    tenancyName?: string | null;
    /** Name */
    name?: string | null;
    position?: string | null;
    /** 是否为关联学校 */
    isRelationSchool?: boolean;
    /** 是否为运维人员 */
    isMaintainPerson?: boolean;
    /** 是否为三方服务提供商 */
    isServiceProvider?: boolean;
    /** 经营类型：自营、代理、重点保障 */
    billingType?: number;
    /** 收费类型：C端、B端、C端B端 */
    businessType?: number;
    isChecked?: boolean;
}

export class SimpleTenantDtoListResultDto implements ISimpleTenantDtoListResultDto {
    items?: SimpleTenantDto[] | null;

    constructor(data?: ISimpleTenantDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleTenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleTenantDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTenantDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SimpleTenantDtoListResultDto {
        const json = this.toJSON();
        let result = new SimpleTenantDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface ISimpleTenantDtoListResultDto {
    items?: SimpleTenantDto[] | null;
}

/** 查找运维人员实体 */
export class GetWorkUserDto implements IGetWorkUserDto {
    userId?: number;
    userName?: string | null;

    constructor(data?: IGetWorkUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
        }
    }

    static fromJS(data: any): GetWorkUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        return data; 
    }

    clone(): GetWorkUserDto {
        const json = this.toJSON();
        let result = new GetWorkUserDto();
        result.init(json);
        return result;
    }
}

/** 查找运维人员实体 */
export interface IGetWorkUserDto {
    userId?: number;
    userName?: string | null;
}

export class StudentDailyAttendanceStaticEveryDay implements IStudentDailyAttendanceStaticEveryDay {
    id?: number;
    tenantId?: number;
    tenantName?: string | null;
    tenantRegion?: string | null;
    creationTime?: moment.Moment;
    shouldArriveNum?: number;
    responsibleName?: string | null;
    schoolName?: string | null;
    actualArriveNum?: number;
    notInSchoolNum?: number;
    leaveNum?: number;
    wxPhoneOnLineCount?: number;
    wxPhoneOffLineCount?: number;
    onLineDeviceCount?: number;
    deviceOffLineCount?: number;
    parentNotBindWxCallNum?: number;
    studentCount?: number;
    notFaceImgNum?: number;
    noBindParentNum?: number;
    rate?: string | null;
    wxCallServenDay?: number;
    billingType?: number;
    businessType?: number;
    noVipCount?: number;
    moneySevenDay?: number;
    schoolType?: string | null;

    constructor(data?: IStudentDailyAttendanceStaticEveryDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.tenantRegion = _data["tenantRegion"] !== undefined ? _data["tenantRegion"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.shouldArriveNum = _data["shouldArriveNum"] !== undefined ? _data["shouldArriveNum"] : <any>null;
            this.responsibleName = _data["responsibleName"] !== undefined ? _data["responsibleName"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            this.actualArriveNum = _data["actualArriveNum"] !== undefined ? _data["actualArriveNum"] : <any>null;
            this.notInSchoolNum = _data["notInSchoolNum"] !== undefined ? _data["notInSchoolNum"] : <any>null;
            this.leaveNum = _data["leaveNum"] !== undefined ? _data["leaveNum"] : <any>null;
            this.wxPhoneOnLineCount = _data["wxPhoneOnLineCount"] !== undefined ? _data["wxPhoneOnLineCount"] : <any>null;
            this.wxPhoneOffLineCount = _data["wxPhoneOffLineCount"] !== undefined ? _data["wxPhoneOffLineCount"] : <any>null;
            this.onLineDeviceCount = _data["onLineDeviceCount"] !== undefined ? _data["onLineDeviceCount"] : <any>null;
            this.deviceOffLineCount = _data["deviceOffLineCount"] !== undefined ? _data["deviceOffLineCount"] : <any>null;
            this.parentNotBindWxCallNum = _data["parentNotBindWxCallNum"] !== undefined ? _data["parentNotBindWxCallNum"] : <any>null;
            this.studentCount = _data["studentCount"] !== undefined ? _data["studentCount"] : <any>null;
            this.notFaceImgNum = _data["notFaceImgNum"] !== undefined ? _data["notFaceImgNum"] : <any>null;
            this.noBindParentNum = _data["noBindParentNum"] !== undefined ? _data["noBindParentNum"] : <any>null;
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
            this.wxCallServenDay = _data["wxCallServenDay"] !== undefined ? _data["wxCallServenDay"] : <any>null;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : <any>null;
            this.businessType = _data["businessType"] !== undefined ? _data["businessType"] : <any>null;
            this.noVipCount = _data["noVipCount"] !== undefined ? _data["noVipCount"] : <any>null;
            this.moneySevenDay = _data["moneySevenDay"] !== undefined ? _data["moneySevenDay"] : <any>null;
            this.schoolType = _data["schoolType"] !== undefined ? _data["schoolType"] : <any>null;
        }
    }

    static fromJS(data: any): StudentDailyAttendanceStaticEveryDay {
        data = typeof data === 'object' ? data : {};
        let result = new StudentDailyAttendanceStaticEveryDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["tenantRegion"] = this.tenantRegion !== undefined ? this.tenantRegion : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["shouldArriveNum"] = this.shouldArriveNum !== undefined ? this.shouldArriveNum : <any>null;
        data["responsibleName"] = this.responsibleName !== undefined ? this.responsibleName : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        data["actualArriveNum"] = this.actualArriveNum !== undefined ? this.actualArriveNum : <any>null;
        data["notInSchoolNum"] = this.notInSchoolNum !== undefined ? this.notInSchoolNum : <any>null;
        data["leaveNum"] = this.leaveNum !== undefined ? this.leaveNum : <any>null;
        data["wxPhoneOnLineCount"] = this.wxPhoneOnLineCount !== undefined ? this.wxPhoneOnLineCount : <any>null;
        data["wxPhoneOffLineCount"] = this.wxPhoneOffLineCount !== undefined ? this.wxPhoneOffLineCount : <any>null;
        data["onLineDeviceCount"] = this.onLineDeviceCount !== undefined ? this.onLineDeviceCount : <any>null;
        data["deviceOffLineCount"] = this.deviceOffLineCount !== undefined ? this.deviceOffLineCount : <any>null;
        data["parentNotBindWxCallNum"] = this.parentNotBindWxCallNum !== undefined ? this.parentNotBindWxCallNum : <any>null;
        data["studentCount"] = this.studentCount !== undefined ? this.studentCount : <any>null;
        data["notFaceImgNum"] = this.notFaceImgNum !== undefined ? this.notFaceImgNum : <any>null;
        data["noBindParentNum"] = this.noBindParentNum !== undefined ? this.noBindParentNum : <any>null;
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        data["wxCallServenDay"] = this.wxCallServenDay !== undefined ? this.wxCallServenDay : <any>null;
        data["billingType"] = this.billingType !== undefined ? this.billingType : <any>null;
        data["businessType"] = this.businessType !== undefined ? this.businessType : <any>null;
        data["noVipCount"] = this.noVipCount !== undefined ? this.noVipCount : <any>null;
        data["moneySevenDay"] = this.moneySevenDay !== undefined ? this.moneySevenDay : <any>null;
        data["schoolType"] = this.schoolType !== undefined ? this.schoolType : <any>null;
        return data; 
    }

    clone(): StudentDailyAttendanceStaticEveryDay {
        const json = this.toJSON();
        let result = new StudentDailyAttendanceStaticEveryDay();
        result.init(json);
        return result;
    }
}

export interface IStudentDailyAttendanceStaticEveryDay {
    id?: number;
    tenantId?: number;
    tenantName?: string | null;
    tenantRegion?: string | null;
    creationTime?: moment.Moment;
    shouldArriveNum?: number;
    responsibleName?: string | null;
    schoolName?: string | null;
    actualArriveNum?: number;
    notInSchoolNum?: number;
    leaveNum?: number;
    wxPhoneOnLineCount?: number;
    wxPhoneOffLineCount?: number;
    onLineDeviceCount?: number;
    deviceOffLineCount?: number;
    parentNotBindWxCallNum?: number;
    studentCount?: number;
    notFaceImgNum?: number;
    noBindParentNum?: number;
    rate?: string | null;
    wxCallServenDay?: number;
    billingType?: number;
    businessType?: number;
    noVipCount?: number;
    moneySevenDay?: number;
    schoolType?: string | null;
}

export class CreateOrderDetailDto implements ICreateOrderDetailDto {
    /** 订单ID */
    order_ID?: number;
    order?: Order;
    /** 商品ID */
    product_ID?: number;
    product?: Product;
    /** 数量 */
    num?: number;
    /** 总价格 */
    toTalMoney?: number;

    constructor(data?: ICreateOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order_ID = _data["order_ID"] !== undefined ? _data["order_ID"] : <any>null;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>null;
            this.product_ID = _data["product_ID"] !== undefined ? _data["product_ID"] : <any>null;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>null;
            this.num = _data["num"] !== undefined ? _data["num"] : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order_ID"] = this.order_ID !== undefined ? this.order_ID : <any>null;
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        data["product_ID"] = this.product_ID !== undefined ? this.product_ID : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["num"] = this.num !== undefined ? this.num : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        return data; 
    }

    clone(): CreateOrderDetailDto {
        const json = this.toJSON();
        let result = new CreateOrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderDetailDto {
    /** 订单ID */
    order_ID?: number;
    order?: Order;
    /** 商品ID */
    product_ID?: number;
    product?: Product;
    /** 数量 */
    num?: number;
    /** 总价格 */
    toTalMoney?: number;
}

/** 产品信息 */
export class OrderDetailDto implements IOrderDetailDto {
    id?: number;
    /** 订单ID */
    order_ID?: number;
    order?: Order;
    /** 商品ID */
    product_ID?: number;
    product?: Product;
    /** 数量 */
    num?: number;
    /** 总价格 */
    toTalMoney?: number;

    constructor(data?: IOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order_ID = _data["order_ID"] !== undefined ? _data["order_ID"] : <any>null;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>null;
            this.product_ID = _data["product_ID"] !== undefined ? _data["product_ID"] : <any>null;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>null;
            this.num = _data["num"] !== undefined ? _data["num"] : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
        }
    }

    static fromJS(data: any): OrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order_ID"] = this.order_ID !== undefined ? this.order_ID : <any>null;
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        data["product_ID"] = this.product_ID !== undefined ? this.product_ID : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["num"] = this.num !== undefined ? this.num : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        return data; 
    }

    clone(): OrderDetailDto {
        const json = this.toJSON();
        let result = new OrderDetailDto();
        result.init(json);
        return result;
    }
}

/** 产品信息 */
export interface IOrderDetailDto {
    id?: number;
    /** 订单ID */
    order_ID?: number;
    order?: Order;
    /** 商品ID */
    product_ID?: number;
    product?: Product;
    /** 数量 */
    num?: number;
    /** 总价格 */
    toTalMoney?: number;
}

export class OrderDetailDtoPagedResultDto implements IOrderDetailDtoPagedResultDto {
    items?: OrderDetailDto[] | null;
    totalCount?: number;

    constructor(data?: IOrderDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderDetailDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): OrderDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailDtoPagedResultDto {
    items?: OrderDetailDto[] | null;
    totalCount?: number;
}

/** 修改产品 */
export class UpdateOrderDetailDto implements IUpdateOrderDetailDto {
    id?: number;
    /** 订单ID */
    order_ID?: number;
    order?: Order;
    /** 商品ID */
    product_ID?: number;
    product?: Product;
    /** 数量 */
    num?: number;
    /** 总价格 */
    toTalMoney?: number;

    constructor(data?: IUpdateOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order_ID = _data["order_ID"] !== undefined ? _data["order_ID"] : <any>null;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>null;
            this.product_ID = _data["product_ID"] !== undefined ? _data["product_ID"] : <any>null;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>null;
            this.num = _data["num"] !== undefined ? _data["num"] : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateOrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order_ID"] = this.order_ID !== undefined ? this.order_ID : <any>null;
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        data["product_ID"] = this.product_ID !== undefined ? this.product_ID : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["num"] = this.num !== undefined ? this.num : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        return data; 
    }

    clone(): UpdateOrderDetailDto {
        const json = this.toJSON();
        let result = new UpdateOrderDetailDto();
        result.init(json);
        return result;
    }
}

/** 修改产品 */
export interface IUpdateOrderDetailDto {
    id?: number;
    /** 订单ID */
    order_ID?: number;
    order?: Order;
    /** 商品ID */
    product_ID?: number;
    product?: Product;
    /** 数量 */
    num?: number;
    /** 总价格 */
    toTalMoney?: number;
}

/** 订单汇总数据详细Dto */
export class OrderRecordSummaryDetailDto implements IOrderRecordSummaryDetailDto {
    /** 付款单数 */
    paidCount?: number;
    /** 付款人数 */
    paidUserCount?: number;
    /** 今日交易总额 */
    todayTotalAmount?: number;
    /** 退款单数 */
    refundedCount?: number;
    /** 交易总额 */
    totalAmount?: number;

    constructor(data?: IOrderRecordSummaryDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paidCount = _data["paidCount"] !== undefined ? _data["paidCount"] : <any>null;
            this.paidUserCount = _data["paidUserCount"] !== undefined ? _data["paidUserCount"] : <any>null;
            this.todayTotalAmount = _data["todayTotalAmount"] !== undefined ? _data["todayTotalAmount"] : <any>null;
            this.refundedCount = _data["refundedCount"] !== undefined ? _data["refundedCount"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordSummaryDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordSummaryDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidCount"] = this.paidCount !== undefined ? this.paidCount : <any>null;
        data["paidUserCount"] = this.paidUserCount !== undefined ? this.paidUserCount : <any>null;
        data["todayTotalAmount"] = this.todayTotalAmount !== undefined ? this.todayTotalAmount : <any>null;
        data["refundedCount"] = this.refundedCount !== undefined ? this.refundedCount : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        return data; 
    }

    clone(): OrderRecordSummaryDetailDto {
        const json = this.toJSON();
        let result = new OrderRecordSummaryDetailDto();
        result.init(json);
        return result;
    }
}

/** 订单汇总数据详细Dto */
export interface IOrderRecordSummaryDetailDto {
    /** 付款单数 */
    paidCount?: number;
    /** 付款人数 */
    paidUserCount?: number;
    /** 今日交易总额 */
    todayTotalAmount?: number;
    /** 退款单数 */
    refundedCount?: number;
    /** 交易总额 */
    totalAmount?: number;
}

/** 订单汇总数据Dto */
export class OrderRecordSummaryDto implements IOrderRecordSummaryDto {
    orderRecordSummaryDetail?: OrderRecordSummaryDetailDto;
    yestodayOrderRecordSummaryDetail?: OrderRecordSummaryDetailDto;

    constructor(data?: IOrderRecordSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderRecordSummaryDetail = _data["orderRecordSummaryDetail"] ? OrderRecordSummaryDetailDto.fromJS(_data["orderRecordSummaryDetail"]) : <any>null;
            this.yestodayOrderRecordSummaryDetail = _data["yestodayOrderRecordSummaryDetail"] ? OrderRecordSummaryDetailDto.fromJS(_data["yestodayOrderRecordSummaryDetail"]) : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderRecordSummaryDetail"] = this.orderRecordSummaryDetail ? this.orderRecordSummaryDetail.toJSON() : <any>null;
        data["yestodayOrderRecordSummaryDetail"] = this.yestodayOrderRecordSummaryDetail ? this.yestodayOrderRecordSummaryDetail.toJSON() : <any>null;
        return data; 
    }

    clone(): OrderRecordSummaryDto {
        const json = this.toJSON();
        let result = new OrderRecordSummaryDto();
        result.init(json);
        return result;
    }
}

/** 订单汇总数据Dto */
export interface IOrderRecordSummaryDto {
    orderRecordSummaryDetail?: OrderRecordSummaryDetailDto;
    yestodayOrderRecordSummaryDetail?: OrderRecordSummaryDetailDto;
}

export class SchoolRankDto implements ISchoolRankDto {
    /** 排名 */
    rank?: number;
    /** 学校名称 */
    name?: string | null;
    /** 今日营业额 */
    todayAmount?: number;
    /** 有效订单数 */
    orderRecordCount?: number;
    /** 付款人数 */
    paidUserCount?: number;
    /** 退款数 */
    refundedCount?: number;
    /** 总营业额 */
    totalAmount?: number;

    constructor(data?: ISchoolRankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"] !== undefined ? _data["rank"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.todayAmount = _data["todayAmount"] !== undefined ? _data["todayAmount"] : <any>null;
            this.orderRecordCount = _data["orderRecordCount"] !== undefined ? _data["orderRecordCount"] : <any>null;
            this.paidUserCount = _data["paidUserCount"] !== undefined ? _data["paidUserCount"] : <any>null;
            this.refundedCount = _data["refundedCount"] !== undefined ? _data["refundedCount"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
        }
    }

    static fromJS(data: any): SchoolRankDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolRankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank !== undefined ? this.rank : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["todayAmount"] = this.todayAmount !== undefined ? this.todayAmount : <any>null;
        data["orderRecordCount"] = this.orderRecordCount !== undefined ? this.orderRecordCount : <any>null;
        data["paidUserCount"] = this.paidUserCount !== undefined ? this.paidUserCount : <any>null;
        data["refundedCount"] = this.refundedCount !== undefined ? this.refundedCount : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        return data; 
    }

    clone(): SchoolRankDto {
        const json = this.toJSON();
        let result = new SchoolRankDto();
        result.init(json);
        return result;
    }
}

export interface ISchoolRankDto {
    /** 排名 */
    rank?: number;
    /** 学校名称 */
    name?: string | null;
    /** 今日营业额 */
    todayAmount?: number;
    /** 有效订单数 */
    orderRecordCount?: number;
    /** 付款人数 */
    paidUserCount?: number;
    /** 退款数 */
    refundedCount?: number;
    /** 总营业额 */
    totalAmount?: number;
}

export class SchoolRankDtoListResultDto implements ISchoolRankDtoListResultDto {
    items?: SchoolRankDto[] | null;

    constructor(data?: ISchoolRankDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SchoolRankDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchoolRankDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolRankDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SchoolRankDtoListResultDto {
        const json = this.toJSON();
        let result = new SchoolRankDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface ISchoolRankDtoListResultDto {
    items?: SchoolRankDto[] | null;
}

export class OrderRecordFaceTempleteDto implements IOrderRecordFaceTempleteDto {
    faceTemplete?: FaceTempleteDto;
    orderRecord?: OrderRecordDto;
    paidUser?: UserSimpleDto;

    constructor(data?: IOrderRecordFaceTempleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faceTemplete = _data["faceTemplete"] ? FaceTempleteDto.fromJS(_data["faceTemplete"]) : <any>null;
            this.orderRecord = _data["orderRecord"] ? OrderRecordDto.fromJS(_data["orderRecord"]) : <any>null;
            this.paidUser = _data["paidUser"] ? UserSimpleDto.fromJS(_data["paidUser"]) : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordFaceTempleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordFaceTempleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faceTemplete"] = this.faceTemplete ? this.faceTemplete.toJSON() : <any>null;
        data["orderRecord"] = this.orderRecord ? this.orderRecord.toJSON() : <any>null;
        data["paidUser"] = this.paidUser ? this.paidUser.toJSON() : <any>null;
        return data; 
    }

    clone(): OrderRecordFaceTempleteDto {
        const json = this.toJSON();
        let result = new OrderRecordFaceTempleteDto();
        result.init(json);
        return result;
    }
}

export interface IOrderRecordFaceTempleteDto {
    faceTemplete?: FaceTempleteDto;
    orderRecord?: OrderRecordDto;
    paidUser?: UserSimpleDto;
}

export class OrderRecordFaceTempleteDtoPagedResultDto implements IOrderRecordFaceTempleteDtoPagedResultDto {
    items?: OrderRecordFaceTempleteDto[] | null;
    totalCount?: number;

    constructor(data?: IOrderRecordFaceTempleteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderRecordFaceTempleteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordFaceTempleteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordFaceTempleteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): OrderRecordFaceTempleteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderRecordFaceTempleteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderRecordFaceTempleteDtoPagedResultDto {
    items?: OrderRecordFaceTempleteDto[] | null;
    totalCount?: number;
}

export class ExportOrderRecordFaceTemplateDto implements IExportOrderRecordFaceTemplateDto {
    /** 付款金额 */
    amount?: number;
    /** 标题 */
    title?: string | null;
    /** 付款描述 */
    body?: string | null;
    /** 支付方式 */
    orderRecordWayType?: string | null;
    /** 订单号 */
    orderNo?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    creationTime?: moment.Moment;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: string | null;
    /** 支付用户 */
    orderUserName?: string | null;
    /** 支付用户 */
    orderUserPhoneNumber?: string | null;
    /** 支付学生 */
    studentName?: string | null;
    /** 班级名称 */
    className?: string | null;
    schoolName?: string | null;

    constructor(data?: IExportOrderRecordFaceTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
            this.orderRecordWayType = _data["orderRecordWayType"] !== undefined ? _data["orderRecordWayType"] : <any>null;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.paidTime = _data["paidTime"] ? moment.parseZone(_data["paidTime"].toString()) : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.orderUserName = _data["orderUserName"] !== undefined ? _data["orderUserName"] : <any>null;
            this.orderUserPhoneNumber = _data["orderUserPhoneNumber"] !== undefined ? _data["orderUserPhoneNumber"] : <any>null;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : <any>null;
            this.className = _data["className"] !== undefined ? _data["className"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
        }
    }

    static fromJS(data: any): ExportOrderRecordFaceTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderRecordFaceTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["body"] = this.body !== undefined ? this.body : <any>null;
        data["orderRecordWayType"] = this.orderRecordWayType !== undefined ? this.orderRecordWayType : <any>null;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["paidTime"] = this.paidTime ? this.paidTime.toISOString(true) : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["orderUserName"] = this.orderUserName !== undefined ? this.orderUserName : <any>null;
        data["orderUserPhoneNumber"] = this.orderUserPhoneNumber !== undefined ? this.orderUserPhoneNumber : <any>null;
        data["studentName"] = this.studentName !== undefined ? this.studentName : <any>null;
        data["className"] = this.className !== undefined ? this.className : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        return data; 
    }

    clone(): ExportOrderRecordFaceTemplateDto {
        const json = this.toJSON();
        let result = new ExportOrderRecordFaceTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IExportOrderRecordFaceTemplateDto {
    /** 付款金额 */
    amount?: number;
    /** 标题 */
    title?: string | null;
    /** 付款描述 */
    body?: string | null;
    /** 支付方式 */
    orderRecordWayType?: string | null;
    /** 订单号 */
    orderNo?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    creationTime?: moment.Moment;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: string | null;
    /** 支付用户 */
    orderUserName?: string | null;
    /** 支付用户 */
    orderUserPhoneNumber?: string | null;
    /** 支付学生 */
    studentName?: string | null;
    /** 班级名称 */
    className?: string | null;
    schoolName?: string | null;
}

export class ExportOrderRecordFaceTemplateDtoListResultDto implements IExportOrderRecordFaceTemplateDtoListResultDto {
    items?: ExportOrderRecordFaceTemplateDto[] | null;

    constructor(data?: IExportOrderRecordFaceTemplateDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExportOrderRecordFaceTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportOrderRecordFaceTemplateDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOrderRecordFaceTemplateDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ExportOrderRecordFaceTemplateDtoListResultDto {
        const json = this.toJSON();
        let result = new ExportOrderRecordFaceTemplateDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IExportOrderRecordFaceTemplateDtoListResultDto {
    items?: ExportOrderRecordFaceTemplateDto[] | null;
}

export class OrderRecordStateCountDto implements IOrderRecordStateCountDto {
    /** 全部数量 */
    totalCount?: number;
    /** 待支付数量 */
    toBePaidCount?: number;
    /** 已支付数量 */
    paidCount?: number;
    /** 已退款数量 */
    refundedCount?: number;
    /** 失败数量 */
    failCount?: number;

    constructor(data?: IOrderRecordStateCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.toBePaidCount = _data["toBePaidCount"] !== undefined ? _data["toBePaidCount"] : <any>null;
            this.paidCount = _data["paidCount"] !== undefined ? _data["paidCount"] : <any>null;
            this.refundedCount = _data["refundedCount"] !== undefined ? _data["refundedCount"] : <any>null;
            this.failCount = _data["failCount"] !== undefined ? _data["failCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordStateCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordStateCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["toBePaidCount"] = this.toBePaidCount !== undefined ? this.toBePaidCount : <any>null;
        data["paidCount"] = this.paidCount !== undefined ? this.paidCount : <any>null;
        data["refundedCount"] = this.refundedCount !== undefined ? this.refundedCount : <any>null;
        data["failCount"] = this.failCount !== undefined ? this.failCount : <any>null;
        return data; 
    }

    clone(): OrderRecordStateCountDto {
        const json = this.toJSON();
        let result = new OrderRecordStateCountDto();
        result.init(json);
        return result;
    }
}

export interface IOrderRecordStateCountDto {
    /** 全部数量 */
    totalCount?: number;
    /** 待支付数量 */
    toBePaidCount?: number;
    /** 已支付数量 */
    paidCount?: number;
    /** 已退款数量 */
    refundedCount?: number;
    /** 失败数量 */
    failCount?: number;
}

export class AdvertisingSpace implements IAdvertisingSpace {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    jumpAddress?: string | null;
    createUserName?: string | null;
    coverUrl?: string | null;
    pageview?: number;
    tenantId?: number;
    orderNumber?: number;

    constructor(data?: IAdvertisingSpace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creatorUserId = _data["creatorUserId"] !== undefined ? _data["creatorUserId"] : <any>null;
            this.lastModificationTime = _data["lastModificationTime"] ? moment.parseZone(_data["lastModificationTime"].toString()) : <any>null;
            this.lastModifierUserId = _data["lastModifierUserId"] !== undefined ? _data["lastModifierUserId"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.deleterUserId = _data["deleterUserId"] !== undefined ? _data["deleterUserId"] : <any>null;
            this.deletionTime = _data["deletionTime"] ? moment.parseZone(_data["deletionTime"].toString()) : <any>null;
            this.jumpAddress = _data["jumpAddress"] !== undefined ? _data["jumpAddress"] : <any>null;
            this.createUserName = _data["createUserName"] !== undefined ? _data["createUserName"] : <any>null;
            this.coverUrl = _data["coverUrl"] !== undefined ? _data["coverUrl"] : <any>null;
            this.pageview = _data["pageview"] !== undefined ? _data["pageview"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisingSpace {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisingSpace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creatorUserId"] = this.creatorUserId !== undefined ? this.creatorUserId : <any>null;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString(true) : <any>null;
        data["lastModifierUserId"] = this.lastModifierUserId !== undefined ? this.lastModifierUserId : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["deleterUserId"] = this.deleterUserId !== undefined ? this.deleterUserId : <any>null;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString(true) : <any>null;
        data["jumpAddress"] = this.jumpAddress !== undefined ? this.jumpAddress : <any>null;
        data["createUserName"] = this.createUserName !== undefined ? this.createUserName : <any>null;
        data["coverUrl"] = this.coverUrl !== undefined ? this.coverUrl : <any>null;
        data["pageview"] = this.pageview !== undefined ? this.pageview : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        return data; 
    }

    clone(): AdvertisingSpace {
        const json = this.toJSON();
        let result = new AdvertisingSpace();
        result.init(json);
        return result;
    }
}

export interface IAdvertisingSpace {
    id?: number;
    creationTime?: moment.Moment;
    creatorUserId?: number | null;
    lastModificationTime?: moment.Moment | null;
    lastModifierUserId?: number | null;
    isDeleted?: boolean;
    deleterUserId?: number | null;
    deletionTime?: moment.Moment | null;
    jumpAddress?: string | null;
    createUserName?: string | null;
    coverUrl?: string | null;
    pageview?: number;
    tenantId?: number;
    orderNumber?: number;
}

export class AdvertisingSpaceDto implements IAdvertisingSpaceDto {
    /** 学校名称 */
    schoolName?: string | null;
    /** 广告位 */
    advertisingSpaces?: AdvertisingSpace[] | null;

    constructor(data?: IAdvertisingSpaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            if (Array.isArray(_data["advertisingSpaces"])) {
                this.advertisingSpaces = [] as any;
                for (let item of _data["advertisingSpaces"])
                    this.advertisingSpaces!.push(AdvertisingSpace.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdvertisingSpaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisingSpaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        if (Array.isArray(this.advertisingSpaces)) {
            data["advertisingSpaces"] = [];
            for (let item of this.advertisingSpaces)
                data["advertisingSpaces"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AdvertisingSpaceDto {
        const json = this.toJSON();
        let result = new AdvertisingSpaceDto();
        result.init(json);
        return result;
    }
}

export interface IAdvertisingSpaceDto {
    /** 学校名称 */
    schoolName?: string | null;
    /** 广告位 */
    advertisingSpaces?: AdvertisingSpace[] | null;
}

/** 新增广告位输入 */
export class AdvertisingSpaceInput implements IAdvertisingSpaceInput {
    /** 广告位ID */
    id?: number;
    /** 跳转地址 */
    jumpAddress?: string | null;
    /** 广告位封面 */
    coverUrl?: string | null;
    /** 排序 */
    orderNumber?: number;
    /** 学校ID */
    tenantId?: number;

    constructor(data?: IAdvertisingSpaceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.jumpAddress = _data["jumpAddress"] !== undefined ? _data["jumpAddress"] : <any>null;
            this.coverUrl = _data["coverUrl"] !== undefined ? _data["coverUrl"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): AdvertisingSpaceInput {
        data = typeof data === 'object' ? data : {};
        let result = new AdvertisingSpaceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["jumpAddress"] = this.jumpAddress !== undefined ? this.jumpAddress : <any>null;
        data["coverUrl"] = this.coverUrl !== undefined ? this.coverUrl : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): AdvertisingSpaceInput {
        const json = this.toJSON();
        let result = new AdvertisingSpaceInput();
        result.init(json);
        return result;
    }
}

/** 新增广告位输入 */
export interface IAdvertisingSpaceInput {
    /** 广告位ID */
    id?: number;
    /** 跳转地址 */
    jumpAddress?: string | null;
    /** 广告位封面 */
    coverUrl?: string | null;
    /** 排序 */
    orderNumber?: number;
    /** 学校ID */
    tenantId?: number;
}

export class UpateOrderInput implements IUpateOrderInput {
    /** 广告ID */
    id?: number;
    /** 是否是上移  上移为true */
    isUp?: boolean;

    constructor(data?: IUpateOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isUp = _data["isUp"] !== undefined ? _data["isUp"] : <any>null;
        }
    }

    static fromJS(data: any): UpateOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpateOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isUp"] = this.isUp !== undefined ? this.isUp : <any>null;
        return data; 
    }

    clone(): UpateOrderInput {
        const json = this.toJSON();
        let result = new UpateOrderInput();
        result.init(json);
        return result;
    }
}

export interface IUpateOrderInput {
    /** 广告ID */
    id?: number;
    /** 是否是上移  上移为true */
    isUp?: boolean;
}

export class OrderRecordRegistration implements IOrderRecordRegistration {
    /** 学校ID */
    tenantId?: number;
    /** 学校名称 */
    schoolName?: string | null;
    /** 登记量 */
    registrationCount?: number;
    /** 完成登记量 */
    dealCount?: number;
    /** 申请退订 */
    unsubscribeCount?: number;

    constructor(data?: IOrderRecordRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            this.registrationCount = _data["registrationCount"] !== undefined ? _data["registrationCount"] : <any>null;
            this.dealCount = _data["dealCount"] !== undefined ? _data["dealCount"] : <any>null;
            this.unsubscribeCount = _data["unsubscribeCount"] !== undefined ? _data["unsubscribeCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        data["registrationCount"] = this.registrationCount !== undefined ? this.registrationCount : <any>null;
        data["dealCount"] = this.dealCount !== undefined ? this.dealCount : <any>null;
        data["unsubscribeCount"] = this.unsubscribeCount !== undefined ? this.unsubscribeCount : <any>null;
        return data; 
    }

    clone(): OrderRecordRegistration {
        const json = this.toJSON();
        let result = new OrderRecordRegistration();
        result.init(json);
        return result;
    }
}

export interface IOrderRecordRegistration {
    /** 学校ID */
    tenantId?: number;
    /** 学校名称 */
    schoolName?: string | null;
    /** 登记量 */
    registrationCount?: number;
    /** 完成登记量 */
    dealCount?: number;
    /** 申请退订 */
    unsubscribeCount?: number;
}

/** 获取学校联通登记情况 */
export class OrderRecordRegistrationDto implements IOrderRecordRegistrationDto {
    items?: OrderRecordRegistration[] | null;
    totalCount?: number;
    /** 总登记量 */
    allRegistrationCount?: number;
    /** 总完成登记量 */
    allDealCount?: number;
    /** 总申请退订 */
    allUnsubscribeCount?: number;

    constructor(data?: IOrderRecordRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderRecordRegistration.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.allRegistrationCount = _data["allRegistrationCount"] !== undefined ? _data["allRegistrationCount"] : <any>null;
            this.allDealCount = _data["allDealCount"] !== undefined ? _data["allDealCount"] : <any>null;
            this.allUnsubscribeCount = _data["allUnsubscribeCount"] !== undefined ? _data["allUnsubscribeCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["allRegistrationCount"] = this.allRegistrationCount !== undefined ? this.allRegistrationCount : <any>null;
        data["allDealCount"] = this.allDealCount !== undefined ? this.allDealCount : <any>null;
        data["allUnsubscribeCount"] = this.allUnsubscribeCount !== undefined ? this.allUnsubscribeCount : <any>null;
        return data; 
    }

    clone(): OrderRecordRegistrationDto {
        const json = this.toJSON();
        let result = new OrderRecordRegistrationDto();
        result.init(json);
        return result;
    }
}

/** 获取学校联通登记情况 */
export interface IOrderRecordRegistrationDto {
    items?: OrderRecordRegistration[] | null;
    totalCount?: number;
    /** 总登记量 */
    allRegistrationCount?: number;
    /** 总完成登记量 */
    allDealCount?: number;
    /** 总申请退订 */
    allUnsubscribeCount?: number;
}

export class OrderRecordBySchoolDto implements IOrderRecordBySchoolDto {
    /** 记录ID */
    id?: string;
    /** 支付学生Id */
    faceTempleteId?: number;
    orderRecordState?: OrderRecordState;
    /** 订单状态 中文 */
    orderRecordStateStr?: string | null;
    studentName?: string | null;
    /** 年级 */
    gradeNo?: number;
    /** 班级 */
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    /** 班级名称 */
    className?: string | null;
    /** 家长名字 */
    parentName?: string | null;
    /** 专享价格 */
    exclusivePrice?: number;
    /** 套餐ID */
    cardHandlingRegistrationPackageId?: number;
    /** 处理时间   登记时间就是创建时间 */
    dealTime?: moment.Moment | null;
    /** 登记时间 */
    creationTime?: moment.Moment;
    /** Vip天数 */
    vipDays?: number;
    /** 办理电话 */
    phoneNumber?: string | null;
    /** 办理电话 */
    handlingTelephone?: string | null;
    /** 沟通备注 */
    communicationRemarks?: string | null;
    registrationType?: RegistrationType;
    /** 头像 */
    faceImg?: string | null;

    constructor(data?: IOrderRecordBySchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.faceTempleteId = _data["faceTempleteId"] !== undefined ? _data["faceTempleteId"] : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.orderRecordStateStr = _data["orderRecordStateStr"] !== undefined ? _data["orderRecordStateStr"] : <any>null;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : <any>null;
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            this.classNo = _data["classNo"] !== undefined ? _data["classNo"] : <any>null;
            this.majorName = _data["majorName"] !== undefined ? _data["majorName"] : <any>null;
            this.majorClassNo = _data["majorClassNo"] !== undefined ? _data["majorClassNo"] : <any>null;
            this.className = _data["className"] !== undefined ? _data["className"] : <any>null;
            this.parentName = _data["parentName"] !== undefined ? _data["parentName"] : <any>null;
            this.exclusivePrice = _data["exclusivePrice"] !== undefined ? _data["exclusivePrice"] : <any>null;
            this.cardHandlingRegistrationPackageId = _data["cardHandlingRegistrationPackageId"] !== undefined ? _data["cardHandlingRegistrationPackageId"] : <any>null;
            this.dealTime = _data["dealTime"] ? moment.parseZone(_data["dealTime"].toString()) : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.vipDays = _data["vipDays"] !== undefined ? _data["vipDays"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.handlingTelephone = _data["handlingTelephone"] !== undefined ? _data["handlingTelephone"] : <any>null;
            this.communicationRemarks = _data["communicationRemarks"] !== undefined ? _data["communicationRemarks"] : <any>null;
            this.registrationType = _data["registrationType"] !== undefined ? _data["registrationType"] : <any>null;
            this.faceImg = _data["faceImg"] !== undefined ? _data["faceImg"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordBySchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordBySchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["faceTempleteId"] = this.faceTempleteId !== undefined ? this.faceTempleteId : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["orderRecordStateStr"] = this.orderRecordStateStr !== undefined ? this.orderRecordStateStr : <any>null;
        data["studentName"] = this.studentName !== undefined ? this.studentName : <any>null;
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["classNo"] = this.classNo !== undefined ? this.classNo : <any>null;
        data["majorName"] = this.majorName !== undefined ? this.majorName : <any>null;
        data["majorClassNo"] = this.majorClassNo !== undefined ? this.majorClassNo : <any>null;
        data["className"] = this.className !== undefined ? this.className : <any>null;
        data["parentName"] = this.parentName !== undefined ? this.parentName : <any>null;
        data["exclusivePrice"] = this.exclusivePrice !== undefined ? this.exclusivePrice : <any>null;
        data["cardHandlingRegistrationPackageId"] = this.cardHandlingRegistrationPackageId !== undefined ? this.cardHandlingRegistrationPackageId : <any>null;
        data["dealTime"] = this.dealTime ? this.dealTime.toISOString(true) : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["vipDays"] = this.vipDays !== undefined ? this.vipDays : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["handlingTelephone"] = this.handlingTelephone !== undefined ? this.handlingTelephone : <any>null;
        data["communicationRemarks"] = this.communicationRemarks !== undefined ? this.communicationRemarks : <any>null;
        data["registrationType"] = this.registrationType !== undefined ? this.registrationType : <any>null;
        data["faceImg"] = this.faceImg !== undefined ? this.faceImg : <any>null;
        return data; 
    }

    clone(): OrderRecordBySchoolDto {
        const json = this.toJSON();
        let result = new OrderRecordBySchoolDto();
        result.init(json);
        return result;
    }
}

export interface IOrderRecordBySchoolDto {
    /** 记录ID */
    id?: string;
    /** 支付学生Id */
    faceTempleteId?: number;
    orderRecordState?: OrderRecordState;
    /** 订单状态 中文 */
    orderRecordStateStr?: string | null;
    studentName?: string | null;
    /** 年级 */
    gradeNo?: number;
    /** 班级 */
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    /** 班级名称 */
    className?: string | null;
    /** 家长名字 */
    parentName?: string | null;
    /** 专享价格 */
    exclusivePrice?: number;
    /** 套餐ID */
    cardHandlingRegistrationPackageId?: number;
    /** 处理时间   登记时间就是创建时间 */
    dealTime?: moment.Moment | null;
    /** 登记时间 */
    creationTime?: moment.Moment;
    /** Vip天数 */
    vipDays?: number;
    /** 办理电话 */
    phoneNumber?: string | null;
    /** 办理电话 */
    handlingTelephone?: string | null;
    /** 沟通备注 */
    communicationRemarks?: string | null;
    registrationType?: RegistrationType;
    /** 头像 */
    faceImg?: string | null;
}

/** 获取学校的登记情况 */
export class OrderRecordRegistrationBySchoolIdDto implements IOrderRecordRegistrationBySchoolIdDto {
    items?: OrderRecordBySchoolDto[] | null;
    totalCount?: number;
    /** 总登记量 */
    allRegistrationCount?: number;
    /** 总完成登记量 */
    allDealCount?: number;
    /** 总申请退订 */
    allUnsubscribeCount?: number;

    constructor(data?: IOrderRecordRegistrationBySchoolIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderRecordBySchoolDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.allRegistrationCount = _data["allRegistrationCount"] !== undefined ? _data["allRegistrationCount"] : <any>null;
            this.allDealCount = _data["allDealCount"] !== undefined ? _data["allDealCount"] : <any>null;
            this.allUnsubscribeCount = _data["allUnsubscribeCount"] !== undefined ? _data["allUnsubscribeCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordRegistrationBySchoolIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordRegistrationBySchoolIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["allRegistrationCount"] = this.allRegistrationCount !== undefined ? this.allRegistrationCount : <any>null;
        data["allDealCount"] = this.allDealCount !== undefined ? this.allDealCount : <any>null;
        data["allUnsubscribeCount"] = this.allUnsubscribeCount !== undefined ? this.allUnsubscribeCount : <any>null;
        return data; 
    }

    clone(): OrderRecordRegistrationBySchoolIdDto {
        const json = this.toJSON();
        let result = new OrderRecordRegistrationBySchoolIdDto();
        result.init(json);
        return result;
    }
}

/** 获取学校的登记情况 */
export interface IOrderRecordRegistrationBySchoolIdDto {
    items?: OrderRecordBySchoolDto[] | null;
    totalCount?: number;
    /** 总登记量 */
    allRegistrationCount?: number;
    /** 总完成登记量 */
    allDealCount?: number;
    /** 总申请退订 */
    allUnsubscribeCount?: number;
}

export class OrderRecordAll implements IOrderRecordAll {
    /** 学校Id */
    tenantId?: number;
    /** 记录ID */
    id?: string;
    /** 支付学生Id */
    faceTempleteId?: number;
    orderRecordState?: OrderRecordState;
    /** 订单状态 中文 */
    orderRecordStateStr?: string | null;
    tenantName?: string | null;
    studentName?: string | null;
    /** 年级 */
    gradeNo?: number;
    /** 班级 */
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    /** 班级名称 */
    className?: string | null;
    /** 家长名字 */
    parentName?: string | null;
    /** 专享价格 */
    exclusivePrice?: number;
    /** 套餐ID */
    cardHandlingRegistrationPackageId?: number;
    /** 处理时间   登记时间就是创建时间 */
    dealTime?: moment.Moment | null;
    /** 登记时间 */
    creationTime?: moment.Moment;
    /** Vip天数 */
    vipDays?: number;
    /** 办理电话 */
    phoneNumber?: string | null;
    /** 办理电话 */
    handlingTelephone?: string | null;
    /** 沟通备注 */
    communicationRemarks?: string | null;
    registrationType?: RegistrationType;
    /** 头像 */
    faceImg?: string | null;

    constructor(data?: IOrderRecordAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.faceTempleteId = _data["faceTempleteId"] !== undefined ? _data["faceTempleteId"] : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.orderRecordStateStr = _data["orderRecordStateStr"] !== undefined ? _data["orderRecordStateStr"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : <any>null;
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            this.classNo = _data["classNo"] !== undefined ? _data["classNo"] : <any>null;
            this.majorName = _data["majorName"] !== undefined ? _data["majorName"] : <any>null;
            this.majorClassNo = _data["majorClassNo"] !== undefined ? _data["majorClassNo"] : <any>null;
            this.className = _data["className"] !== undefined ? _data["className"] : <any>null;
            this.parentName = _data["parentName"] !== undefined ? _data["parentName"] : <any>null;
            this.exclusivePrice = _data["exclusivePrice"] !== undefined ? _data["exclusivePrice"] : <any>null;
            this.cardHandlingRegistrationPackageId = _data["cardHandlingRegistrationPackageId"] !== undefined ? _data["cardHandlingRegistrationPackageId"] : <any>null;
            this.dealTime = _data["dealTime"] ? moment.parseZone(_data["dealTime"].toString()) : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.vipDays = _data["vipDays"] !== undefined ? _data["vipDays"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.handlingTelephone = _data["handlingTelephone"] !== undefined ? _data["handlingTelephone"] : <any>null;
            this.communicationRemarks = _data["communicationRemarks"] !== undefined ? _data["communicationRemarks"] : <any>null;
            this.registrationType = _data["registrationType"] !== undefined ? _data["registrationType"] : <any>null;
            this.faceImg = _data["faceImg"] !== undefined ? _data["faceImg"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordAll {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["faceTempleteId"] = this.faceTempleteId !== undefined ? this.faceTempleteId : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["orderRecordStateStr"] = this.orderRecordStateStr !== undefined ? this.orderRecordStateStr : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["studentName"] = this.studentName !== undefined ? this.studentName : <any>null;
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["classNo"] = this.classNo !== undefined ? this.classNo : <any>null;
        data["majorName"] = this.majorName !== undefined ? this.majorName : <any>null;
        data["majorClassNo"] = this.majorClassNo !== undefined ? this.majorClassNo : <any>null;
        data["className"] = this.className !== undefined ? this.className : <any>null;
        data["parentName"] = this.parentName !== undefined ? this.parentName : <any>null;
        data["exclusivePrice"] = this.exclusivePrice !== undefined ? this.exclusivePrice : <any>null;
        data["cardHandlingRegistrationPackageId"] = this.cardHandlingRegistrationPackageId !== undefined ? this.cardHandlingRegistrationPackageId : <any>null;
        data["dealTime"] = this.dealTime ? this.dealTime.toISOString(true) : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["vipDays"] = this.vipDays !== undefined ? this.vipDays : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["handlingTelephone"] = this.handlingTelephone !== undefined ? this.handlingTelephone : <any>null;
        data["communicationRemarks"] = this.communicationRemarks !== undefined ? this.communicationRemarks : <any>null;
        data["registrationType"] = this.registrationType !== undefined ? this.registrationType : <any>null;
        data["faceImg"] = this.faceImg !== undefined ? this.faceImg : <any>null;
        return data; 
    }

    clone(): OrderRecordAll {
        const json = this.toJSON();
        let result = new OrderRecordAll();
        result.init(json);
        return result;
    }
}

export interface IOrderRecordAll {
    /** 学校Id */
    tenantId?: number;
    /** 记录ID */
    id?: string;
    /** 支付学生Id */
    faceTempleteId?: number;
    orderRecordState?: OrderRecordState;
    /** 订单状态 中文 */
    orderRecordStateStr?: string | null;
    tenantName?: string | null;
    studentName?: string | null;
    /** 年级 */
    gradeNo?: number;
    /** 班级 */
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    /** 班级名称 */
    className?: string | null;
    /** 家长名字 */
    parentName?: string | null;
    /** 专享价格 */
    exclusivePrice?: number;
    /** 套餐ID */
    cardHandlingRegistrationPackageId?: number;
    /** 处理时间   登记时间就是创建时间 */
    dealTime?: moment.Moment | null;
    /** 登记时间 */
    creationTime?: moment.Moment;
    /** Vip天数 */
    vipDays?: number;
    /** 办理电话 */
    phoneNumber?: string | null;
    /** 办理电话 */
    handlingTelephone?: string | null;
    /** 沟通备注 */
    communicationRemarks?: string | null;
    registrationType?: RegistrationType;
    /** 头像 */
    faceImg?: string | null;
}

export class OrderRecordRegistrationAllDto implements IOrderRecordRegistrationAllDto {
    items?: OrderRecordAll[] | null;
    totalCount?: number;
    /** 总登记量 */
    allRegistrationCount?: number;
    /** 总完成登记量 */
    allDealCount?: number;
    /** 总申请退订 */
    allUnsubscribeCount?: number;

    constructor(data?: IOrderRecordRegistrationAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderRecordAll.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.allRegistrationCount = _data["allRegistrationCount"] !== undefined ? _data["allRegistrationCount"] : <any>null;
            this.allDealCount = _data["allDealCount"] !== undefined ? _data["allDealCount"] : <any>null;
            this.allUnsubscribeCount = _data["allUnsubscribeCount"] !== undefined ? _data["allUnsubscribeCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordRegistrationAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordRegistrationAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["allRegistrationCount"] = this.allRegistrationCount !== undefined ? this.allRegistrationCount : <any>null;
        data["allDealCount"] = this.allDealCount !== undefined ? this.allDealCount : <any>null;
        data["allUnsubscribeCount"] = this.allUnsubscribeCount !== undefined ? this.allUnsubscribeCount : <any>null;
        return data; 
    }

    clone(): OrderRecordRegistrationAllDto {
        const json = this.toJSON();
        let result = new OrderRecordRegistrationAllDto();
        result.init(json);
        return result;
    }
}

export interface IOrderRecordRegistrationAllDto {
    items?: OrderRecordAll[] | null;
    totalCount?: number;
    /** 总登记量 */
    allRegistrationCount?: number;
    /** 总完成登记量 */
    allDealCount?: number;
    /** 总申请退订 */
    allUnsubscribeCount?: number;
}

export class UpdateOrderRecordStateInput implements IUpdateOrderRecordStateInput {
    id?: string;
    /** 办理电话 */
    phoneNumber?: string | null;
    /** 学校ID */
    tenantId?: number;

    constructor(data?: IUpdateOrderRecordStateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateOrderRecordStateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderRecordStateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): UpdateOrderRecordStateInput {
        const json = this.toJSON();
        let result = new UpdateOrderRecordStateInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateOrderRecordStateInput {
    id?: string;
    /** 办理电话 */
    phoneNumber?: string | null;
    /** 学校ID */
    tenantId?: number;
}

/** 退订订单 */
export class OrderRecordUnsubscribeInput implements IOrderRecordUnsubscribeInput {
    /** 订单ID */
    id?: string;
    orderRecordState?: OrderRecordState;
    /** 是否同意退订 */
    isAgree?: boolean;
    /** 学校ID */
    tenantId?: number;

    constructor(data?: IOrderRecordUnsubscribeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.isAgree = _data["isAgree"] !== undefined ? _data["isAgree"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordUnsubscribeInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordUnsubscribeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["isAgree"] = this.isAgree !== undefined ? this.isAgree : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): OrderRecordUnsubscribeInput {
        const json = this.toJSON();
        let result = new OrderRecordUnsubscribeInput();
        result.init(json);
        return result;
    }
}

/** 退订订单 */
export interface IOrderRecordUnsubscribeInput {
    /** 订单ID */
    id?: string;
    orderRecordState?: OrderRecordState;
    /** 是否同意退订 */
    isAgree?: boolean;
    /** 学校ID */
    tenantId?: number;
}

/** 修改vip 到期时间输入 */
export class UpdateVipExpireDateInput implements IUpdateVipExpireDateInput {
    /** 订单ID */
    id?: string;
    /** 天数 */
    days?: number;
    /** 是否是增加 */
    isAdd?: boolean;
    /** 学校ID */
    tenantId?: number;

    constructor(data?: IUpdateVipExpireDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.days = _data["days"] !== undefined ? _data["days"] : <any>null;
            this.isAdd = _data["isAdd"] !== undefined ? _data["isAdd"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateVipExpireDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVipExpireDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["days"] = this.days !== undefined ? this.days : <any>null;
        data["isAdd"] = this.isAdd !== undefined ? this.isAdd : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): UpdateVipExpireDateInput {
        const json = this.toJSON();
        let result = new UpdateVipExpireDateInput();
        result.init(json);
        return result;
    }
}

/** 修改vip 到期时间输入 */
export interface IUpdateVipExpireDateInput {
    /** 订单ID */
    id?: string;
    /** 天数 */
    days?: number;
    /** 是否是增加 */
    isAdd?: boolean;
    /** 学校ID */
    tenantId?: number;
}

/** 创建沟通记录输入 */
export class CommunicationRecordInput implements ICommunicationRecordInput {
    /** 消息记录 */
    message?: string | null;
    /** 学校ID */
    tenantId?: number;
    /** 订单ID */
    orderRecordId?: string;

    constructor(data?: ICommunicationRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.orderRecordId = _data["orderRecordId"] !== undefined ? _data["orderRecordId"] : <any>null;
        }
    }

    static fromJS(data: any): CommunicationRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["orderRecordId"] = this.orderRecordId !== undefined ? this.orderRecordId : <any>null;
        return data; 
    }

    clone(): CommunicationRecordInput {
        const json = this.toJSON();
        let result = new CommunicationRecordInput();
        result.init(json);
        return result;
    }
}

/** 创建沟通记录输入 */
export interface ICommunicationRecordInput {
    /** 消息记录 */
    message?: string | null;
    /** 学校ID */
    tenantId?: number;
    /** 订单ID */
    orderRecordId?: string;
}

/** 获取沟通记录 */
export class CommunicationRecordDto implements ICommunicationRecordDto {
    /** 消息记录 */
    message?: string | null;
    /** 记录人姓名 */
    createUserName?: string | null;
    creationTime?: moment.Moment;
    /** 创建时间 */
    creationTimeStr?: string | null;

    constructor(data?: ICommunicationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.createUserName = _data["createUserName"] !== undefined ? _data["createUserName"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.creationTimeStr = _data["creationTimeStr"] !== undefined ? _data["creationTimeStr"] : <any>null;
        }
    }

    static fromJS(data: any): CommunicationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["createUserName"] = this.createUserName !== undefined ? this.createUserName : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["creationTimeStr"] = this.creationTimeStr !== undefined ? this.creationTimeStr : <any>null;
        return data; 
    }

    clone(): CommunicationRecordDto {
        const json = this.toJSON();
        let result = new CommunicationRecordDto();
        result.init(json);
        return result;
    }
}

/** 获取沟通记录 */
export interface ICommunicationRecordDto {
    /** 消息记录 */
    message?: string | null;
    /** 记录人姓名 */
    createUserName?: string | null;
    creationTime?: moment.Moment;
    /** 创建时间 */
    creationTimeStr?: string | null;
}

/** 订单详情 */
export class OrderRecordDetail implements IOrderRecordDetail {
    /** 订单ID */
    id?: string;
    /** 学校ID */
    tenantId?: number;
    studentName?: string | null;
    /** 登记电话 */
    phoneNumber?: string | null;
    /** 创建时间 */
    creationTime?: moment.Moment;
    /** 退订原因 */
    reason?: string | null;
    /** 退订描述 */
    remark?: string | null;
    /** 图片地址 */
    imgUrls?: string | null;
    /** 是否有退订消息 */
    isUnsubscribeRecord?: boolean;

    constructor(data?: IOrderRecordDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : <any>null;
            this.imgUrls = _data["imgUrls"] !== undefined ? _data["imgUrls"] : <any>null;
            this.isUnsubscribeRecord = _data["isUnsubscribeRecord"] !== undefined ? _data["isUnsubscribeRecord"] : <any>null;
        }
    }

    static fromJS(data: any): OrderRecordDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRecordDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["studentName"] = this.studentName !== undefined ? this.studentName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["remark"] = this.remark !== undefined ? this.remark : <any>null;
        data["imgUrls"] = this.imgUrls !== undefined ? this.imgUrls : <any>null;
        data["isUnsubscribeRecord"] = this.isUnsubscribeRecord !== undefined ? this.isUnsubscribeRecord : <any>null;
        return data; 
    }

    clone(): OrderRecordDetail {
        const json = this.toJSON();
        let result = new OrderRecordDetail();
        result.init(json);
        return result;
    }
}

/** 订单详情 */
export interface IOrderRecordDetail {
    /** 订单ID */
    id?: string;
    /** 学校ID */
    tenantId?: number;
    studentName?: string | null;
    /** 登记电话 */
    phoneNumber?: string | null;
    /** 创建时间 */
    creationTime?: moment.Moment;
    /** 退订原因 */
    reason?: string | null;
    /** 退订描述 */
    remark?: string | null;
    /** 图片地址 */
    imgUrls?: string | null;
    /** 是否有退订消息 */
    isUnsubscribeRecord?: boolean;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    id?: number;
    /** Parent Abp.Organizations.OrganizationUnit Id.
Null, if this OU is root. */
    parentId?: number | null;
    /** Display name of this role. */
    displayName?: string | null;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        return data; 
    }

    clone(): OrganizationUnitDto {
        const json = this.toJSON();
        let result = new OrganizationUnitDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitDto {
    id?: number;
    /** Parent Abp.Organizations.OrganizationUnit Id.
Null, if this OU is root. */
    parentId?: number | null;
    /** Display name of this role. */
    displayName?: string | null;
}

export class OrganizationUnitDtoPagedResultDto implements IOrganizationUnitDtoPagedResultDto {
    items?: OrganizationUnitDto[] | null;
    totalCount?: number;

    constructor(data?: IOrganizationUnitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationUnitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): OrganizationUnitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrganizationUnitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitDtoPagedResultDto {
    items?: OrganizationUnitDto[] | null;
    totalCount?: number;
}

export class CreateOrganizationUnitDto implements ICreateOrganizationUnitDto {
    /** Parent Abp.Organizations.OrganizationUnit Id.
Null, if this OU is root. */
    parentId?: number | null;
    /** Display name of this role. */
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        return data; 
    }

    clone(): CreateOrganizationUnitDto {
        const json = this.toJSON();
        let result = new CreateOrganizationUnitDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrganizationUnitDto {
    /** Parent Abp.Organizations.OrganizationUnit Id.
Null, if this OU is root. */
    parentId?: number | null;
    /** Display name of this role. */
    displayName: string;
}

/** 商品附件图 */
export class UpdateProductMoreFileDto implements IUpdateProductMoreFileDto {
    id?: number;
    /** 商品图片 */
    p_Path?: string | null;
    /** 附件类型 */
    attachmentType?: string | null;

    constructor(data?: IUpdateProductMoreFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.attachmentType = _data["attachmentType"] !== undefined ? _data["attachmentType"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProductMoreFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductMoreFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["attachmentType"] = this.attachmentType !== undefined ? this.attachmentType : <any>null;
        return data; 
    }

    clone(): UpdateProductMoreFileDto {
        const json = this.toJSON();
        let result = new UpdateProductMoreFileDto();
        result.init(json);
        return result;
    }
}

/** 商品附件图 */
export interface IUpdateProductMoreFileDto {
    id?: number;
    /** 商品图片 */
    p_Path?: string | null;
    /** 附件类型 */
    attachmentType?: string | null;
}

/** 商品规格表 */
export class CreateOrUpdateProductSpecificationDto implements ICreateOrUpdateProductSpecificationDto {
    id?: number;
    /** 规格名称 */
    specName?: string | null;
    /** 赠送积分 */
    integral?: number;
    /** 库存 */
    inventoryNum?: number;
    /** 折扣前价格 */
    beforePrice?: number;
    /** 折扣后价格 */
    afterPrice?: number;
    /** 是否选中 */
    isSelect?: boolean;

    constructor(data?: ICreateOrUpdateProductSpecificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.specName = _data["specName"] !== undefined ? _data["specName"] : <any>null;
            this.integral = _data["integral"] !== undefined ? _data["integral"] : <any>null;
            this.inventoryNum = _data["inventoryNum"] !== undefined ? _data["inventoryNum"] : <any>null;
            this.beforePrice = _data["beforePrice"] !== undefined ? _data["beforePrice"] : <any>null;
            this.afterPrice = _data["afterPrice"] !== undefined ? _data["afterPrice"] : <any>null;
            this.isSelect = _data["isSelect"] !== undefined ? _data["isSelect"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrUpdateProductSpecificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProductSpecificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["specName"] = this.specName !== undefined ? this.specName : <any>null;
        data["integral"] = this.integral !== undefined ? this.integral : <any>null;
        data["inventoryNum"] = this.inventoryNum !== undefined ? this.inventoryNum : <any>null;
        data["beforePrice"] = this.beforePrice !== undefined ? this.beforePrice : <any>null;
        data["afterPrice"] = this.afterPrice !== undefined ? this.afterPrice : <any>null;
        data["isSelect"] = this.isSelect !== undefined ? this.isSelect : <any>null;
        return data; 
    }

    clone(): CreateOrUpdateProductSpecificationDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateProductSpecificationDto();
        result.init(json);
        return result;
    }
}

/** 商品规格表 */
export interface ICreateOrUpdateProductSpecificationDto {
    id?: number;
    /** 规格名称 */
    specName?: string | null;
    /** 赠送积分 */
    integral?: number;
    /** 库存 */
    inventoryNum?: number;
    /** 折扣前价格 */
    beforePrice?: number;
    /** 折扣后价格 */
    afterPrice?: number;
    /** 是否选中 */
    isSelect?: boolean;
}

export class CreateProductDto implements ICreateProductDto {
    /** 商品名称 */
    name?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 商品类型ID */
    productCategoryId?: number;
    /** 商品图片 */
    p_Path?: string | null;
    /** 商品描述 */
    describe?: string | null;
    /** 商品热门指数 */
    state?: number;
    /** 是否上架 */
    isShow?: boolean;
    imageList?: UpdateProductMoreFileDto[] | null;
    /** 商品价格 */
    price?: number;
    /** 折扣前价格 */
    beforePrice?: number;
    /** 规格明细表 */
    specificationList?: CreateOrUpdateProductSpecificationDto[] | null;
    /** 服务类型 */
    salesType?: string | null;
    /** 赠送积分 */
    integral?: number;
    /** 是否包邮 */
    isFree?: boolean;
    /** 阅读数 */
    readCount?: number;
    /** 是否开启拼团 */
    isStartGroupBuying?: boolean;
    /** 拼团名称 */
    groupBuyingName?: string | null;
    /** 拼团金额 */
    groupBuyingAmount?: number;
    /** 是否显示火热属性 */
    isShowHot?: boolean;
    /** 是否显示倒计时和优惠 */
    isShowEndTimeAndDiscount?: boolean;
    /** 优惠结束时间 */
    endTimeOfPromotion?: moment.Moment | null;
    promotionRemark?: string | null;

    constructor(data?: ICreateProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : <any>null;
            this.productCategoryId = _data["productCategoryId"] !== undefined ? _data["productCategoryId"] : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
            if (Array.isArray(_data["imageList"])) {
                this.imageList = [] as any;
                for (let item of _data["imageList"])
                    this.imageList!.push(UpdateProductMoreFileDto.fromJS(item));
            }
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.beforePrice = _data["beforePrice"] !== undefined ? _data["beforePrice"] : <any>null;
            if (Array.isArray(_data["specificationList"])) {
                this.specificationList = [] as any;
                for (let item of _data["specificationList"])
                    this.specificationList!.push(CreateOrUpdateProductSpecificationDto.fromJS(item));
            }
            this.salesType = _data["salesType"] !== undefined ? _data["salesType"] : <any>null;
            this.integral = _data["integral"] !== undefined ? _data["integral"] : <any>null;
            this.isFree = _data["isFree"] !== undefined ? _data["isFree"] : <any>null;
            this.readCount = _data["readCount"] !== undefined ? _data["readCount"] : <any>null;
            this.isStartGroupBuying = _data["isStartGroupBuying"] !== undefined ? _data["isStartGroupBuying"] : <any>null;
            this.groupBuyingName = _data["groupBuyingName"] !== undefined ? _data["groupBuyingName"] : <any>null;
            this.groupBuyingAmount = _data["groupBuyingAmount"] !== undefined ? _data["groupBuyingAmount"] : <any>null;
            this.isShowHot = _data["isShowHot"] !== undefined ? _data["isShowHot"] : <any>null;
            this.isShowEndTimeAndDiscount = _data["isShowEndTimeAndDiscount"] !== undefined ? _data["isShowEndTimeAndDiscount"] : <any>null;
            this.endTimeOfPromotion = _data["endTimeOfPromotion"] ? moment.parseZone(_data["endTimeOfPromotion"].toString()) : <any>null;
            this.promotionRemark = _data["promotionRemark"] !== undefined ? _data["promotionRemark"] : <any>null;
        }
    }

    static fromJS(data: any): CreateProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : <any>null;
        data["productCategoryId"] = this.productCategoryId !== undefined ? this.productCategoryId : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["describe"] = this.describe !== undefined ? this.describe : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        if (Array.isArray(this.imageList)) {
            data["imageList"] = [];
            for (let item of this.imageList)
                data["imageList"].push(item.toJSON());
        }
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["beforePrice"] = this.beforePrice !== undefined ? this.beforePrice : <any>null;
        if (Array.isArray(this.specificationList)) {
            data["specificationList"] = [];
            for (let item of this.specificationList)
                data["specificationList"].push(item.toJSON());
        }
        data["salesType"] = this.salesType !== undefined ? this.salesType : <any>null;
        data["integral"] = this.integral !== undefined ? this.integral : <any>null;
        data["isFree"] = this.isFree !== undefined ? this.isFree : <any>null;
        data["readCount"] = this.readCount !== undefined ? this.readCount : <any>null;
        data["isStartGroupBuying"] = this.isStartGroupBuying !== undefined ? this.isStartGroupBuying : <any>null;
        data["groupBuyingName"] = this.groupBuyingName !== undefined ? this.groupBuyingName : <any>null;
        data["groupBuyingAmount"] = this.groupBuyingAmount !== undefined ? this.groupBuyingAmount : <any>null;
        data["isShowHot"] = this.isShowHot !== undefined ? this.isShowHot : <any>null;
        data["isShowEndTimeAndDiscount"] = this.isShowEndTimeAndDiscount !== undefined ? this.isShowEndTimeAndDiscount : <any>null;
        data["endTimeOfPromotion"] = this.endTimeOfPromotion ? this.endTimeOfPromotion.toISOString(true) : <any>null;
        data["promotionRemark"] = this.promotionRemark !== undefined ? this.promotionRemark : <any>null;
        return data; 
    }

    clone(): CreateProductDto {
        const json = this.toJSON();
        let result = new CreateProductDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProductDto {
    /** 商品名称 */
    name?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 商品类型ID */
    productCategoryId?: number;
    /** 商品图片 */
    p_Path?: string | null;
    /** 商品描述 */
    describe?: string | null;
    /** 商品热门指数 */
    state?: number;
    /** 是否上架 */
    isShow?: boolean;
    imageList?: UpdateProductMoreFileDto[] | null;
    /** 商品价格 */
    price?: number;
    /** 折扣前价格 */
    beforePrice?: number;
    /** 规格明细表 */
    specificationList?: CreateOrUpdateProductSpecificationDto[] | null;
    /** 服务类型 */
    salesType?: string | null;
    /** 赠送积分 */
    integral?: number;
    /** 是否包邮 */
    isFree?: boolean;
    /** 阅读数 */
    readCount?: number;
    /** 是否开启拼团 */
    isStartGroupBuying?: boolean;
    /** 拼团名称 */
    groupBuyingName?: string | null;
    /** 拼团金额 */
    groupBuyingAmount?: number;
    /** 是否显示火热属性 */
    isShowHot?: boolean;
    /** 是否显示倒计时和优惠 */
    isShowEndTimeAndDiscount?: boolean;
    /** 优惠结束时间 */
    endTimeOfPromotion?: moment.Moment | null;
    promotionRemark?: string | null;
}

/** 产品信息 */
export class ProductDto implements IProductDto {
    id?: number;
    /** 商品名称 */
    name?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    productCategoryId?: number;
    productCategory?: ProductCategory;
    /** 商品图片 */
    p_Path?: string | null;
    /** 商品描述 */
    describe?: string | null;
    /** 商品热门指数 */
    state?: number;
    /** 是否上架 */
    isShow?: boolean;
    imageList?: UpdateProductMoreFileDto[] | null;
    /** 规格明细表 */
    specificationList?: CreateOrUpdateProductSpecificationDto[] | null;
    /** 商品价格 */
    price?: number;
    /** 折扣前价格 */
    beforePrice?: number;
    /** 服务类型 */
    salesType?: string | null;
    /** 赠送积分 */
    integral?: number;
    /** 库存产品规格的总数量 */
    inventoryCount?: number;
    /** 该产品下面的总订单量 */
    saleSvolumeCount?: number;
    /** 添加时间 */
    creationTime?: moment.Moment | null;
    /** 是否包邮 */
    isFree?: boolean;
    /** 阅读数 */
    readCount?: number;
    /** 销售数量变化值 */
    saleNum?: number;
    /** 是否开启拼团 */
    isStartGroupBuying?: boolean;
    /** 拼团名称 */
    groupBuyingName?: string | null;
    /** 拼团金额 */
    groupBuyingAmount?: number;
    /** 是否显示火热属性 */
    isShowHot?: boolean;
    /** 是否显示倒计时和优惠 */
    isShowEndTimeAndDiscount?: boolean;
    /** 优惠结束时间 */
    endTimeOfPromotion?: moment.Moment | null;
    promotionRemark?: string | null;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : <any>null;
            this.productCategoryId = _data["productCategoryId"] !== undefined ? _data["productCategoryId"] : <any>null;
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
            if (Array.isArray(_data["imageList"])) {
                this.imageList = [] as any;
                for (let item of _data["imageList"])
                    this.imageList!.push(UpdateProductMoreFileDto.fromJS(item));
            }
            if (Array.isArray(_data["specificationList"])) {
                this.specificationList = [] as any;
                for (let item of _data["specificationList"])
                    this.specificationList!.push(CreateOrUpdateProductSpecificationDto.fromJS(item));
            }
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.beforePrice = _data["beforePrice"] !== undefined ? _data["beforePrice"] : <any>null;
            this.salesType = _data["salesType"] !== undefined ? _data["salesType"] : <any>null;
            this.integral = _data["integral"] !== undefined ? _data["integral"] : <any>null;
            this.inventoryCount = _data["inventoryCount"] !== undefined ? _data["inventoryCount"] : <any>null;
            this.saleSvolumeCount = _data["saleSvolumeCount"] !== undefined ? _data["saleSvolumeCount"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
            this.isFree = _data["isFree"] !== undefined ? _data["isFree"] : <any>null;
            this.readCount = _data["readCount"] !== undefined ? _data["readCount"] : <any>null;
            this.saleNum = _data["saleNum"] !== undefined ? _data["saleNum"] : <any>null;
            this.isStartGroupBuying = _data["isStartGroupBuying"] !== undefined ? _data["isStartGroupBuying"] : <any>null;
            this.groupBuyingName = _data["groupBuyingName"] !== undefined ? _data["groupBuyingName"] : <any>null;
            this.groupBuyingAmount = _data["groupBuyingAmount"] !== undefined ? _data["groupBuyingAmount"] : <any>null;
            this.isShowHot = _data["isShowHot"] !== undefined ? _data["isShowHot"] : <any>null;
            this.isShowEndTimeAndDiscount = _data["isShowEndTimeAndDiscount"] !== undefined ? _data["isShowEndTimeAndDiscount"] : <any>null;
            this.endTimeOfPromotion = _data["endTimeOfPromotion"] ? moment.parseZone(_data["endTimeOfPromotion"].toString()) : <any>null;
            this.promotionRemark = _data["promotionRemark"] !== undefined ? _data["promotionRemark"] : <any>null;
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : <any>null;
        data["productCategoryId"] = this.productCategoryId !== undefined ? this.productCategoryId : <any>null;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["describe"] = this.describe !== undefined ? this.describe : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        if (Array.isArray(this.imageList)) {
            data["imageList"] = [];
            for (let item of this.imageList)
                data["imageList"].push(item.toJSON());
        }
        if (Array.isArray(this.specificationList)) {
            data["specificationList"] = [];
            for (let item of this.specificationList)
                data["specificationList"].push(item.toJSON());
        }
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["beforePrice"] = this.beforePrice !== undefined ? this.beforePrice : <any>null;
        data["salesType"] = this.salesType !== undefined ? this.salesType : <any>null;
        data["integral"] = this.integral !== undefined ? this.integral : <any>null;
        data["inventoryCount"] = this.inventoryCount !== undefined ? this.inventoryCount : <any>null;
        data["saleSvolumeCount"] = this.saleSvolumeCount !== undefined ? this.saleSvolumeCount : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        data["isFree"] = this.isFree !== undefined ? this.isFree : <any>null;
        data["readCount"] = this.readCount !== undefined ? this.readCount : <any>null;
        data["saleNum"] = this.saleNum !== undefined ? this.saleNum : <any>null;
        data["isStartGroupBuying"] = this.isStartGroupBuying !== undefined ? this.isStartGroupBuying : <any>null;
        data["groupBuyingName"] = this.groupBuyingName !== undefined ? this.groupBuyingName : <any>null;
        data["groupBuyingAmount"] = this.groupBuyingAmount !== undefined ? this.groupBuyingAmount : <any>null;
        data["isShowHot"] = this.isShowHot !== undefined ? this.isShowHot : <any>null;
        data["isShowEndTimeAndDiscount"] = this.isShowEndTimeAndDiscount !== undefined ? this.isShowEndTimeAndDiscount : <any>null;
        data["endTimeOfPromotion"] = this.endTimeOfPromotion ? this.endTimeOfPromotion.toISOString(true) : <any>null;
        data["promotionRemark"] = this.promotionRemark !== undefined ? this.promotionRemark : <any>null;
        return data; 
    }

    clone(): ProductDto {
        const json = this.toJSON();
        let result = new ProductDto();
        result.init(json);
        return result;
    }
}

/** 产品信息 */
export interface IProductDto {
    id?: number;
    /** 商品名称 */
    name?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    productCategoryId?: number;
    productCategory?: ProductCategory;
    /** 商品图片 */
    p_Path?: string | null;
    /** 商品描述 */
    describe?: string | null;
    /** 商品热门指数 */
    state?: number;
    /** 是否上架 */
    isShow?: boolean;
    imageList?: UpdateProductMoreFileDto[] | null;
    /** 规格明细表 */
    specificationList?: CreateOrUpdateProductSpecificationDto[] | null;
    /** 商品价格 */
    price?: number;
    /** 折扣前价格 */
    beforePrice?: number;
    /** 服务类型 */
    salesType?: string | null;
    /** 赠送积分 */
    integral?: number;
    /** 库存产品规格的总数量 */
    inventoryCount?: number;
    /** 该产品下面的总订单量 */
    saleSvolumeCount?: number;
    /** 添加时间 */
    creationTime?: moment.Moment | null;
    /** 是否包邮 */
    isFree?: boolean;
    /** 阅读数 */
    readCount?: number;
    /** 销售数量变化值 */
    saleNum?: number;
    /** 是否开启拼团 */
    isStartGroupBuying?: boolean;
    /** 拼团名称 */
    groupBuyingName?: string | null;
    /** 拼团金额 */
    groupBuyingAmount?: number;
    /** 是否显示火热属性 */
    isShowHot?: boolean;
    /** 是否显示倒计时和优惠 */
    isShowEndTimeAndDiscount?: boolean;
    /** 优惠结束时间 */
    endTimeOfPromotion?: moment.Moment | null;
    promotionRemark?: string | null;
}

export class ProductDtoPagedResultDto implements IProductDtoPagedResultDto {
    items?: ProductDto[] | null;
    totalCount?: number;

    constructor(data?: IProductDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): ProductDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): ProductDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductDtoPagedResultDto {
    items?: ProductDto[] | null;
    totalCount?: number;
}

/** 修改产品 */
export class UpdateProductDto implements IUpdateProductDto {
    id?: number;
    /** 商品名称 */
    name?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 商品类型ID */
    productCategoryId?: number;
    productCategory?: ProductCategory;
    /** 商品图片 */
    p_Path?: string | null;
    /** 商品描述 */
    describe?: string | null;
    /** 商品热门指数 */
    state?: number;
    /** 是否上架 */
    isShow?: boolean;
    imageList?: UpdateProductMoreFileDto[] | null;
    /** 折扣前价格 */
    beforePrice?: number;
    /** 商品价格 */
    price?: number;
    /** 规格明细表 */
    specificationList?: CreateOrUpdateProductSpecificationDto[] | null;
    /** 服务类型 */
    salesType?: string | null;
    /** 赠送积分 */
    integral?: number;
    /** 是否包邮 */
    isFree?: boolean;
    /** 阅读数 */
    readCount?: number;
    /** 销售数量变化值 */
    saleNum?: number;
    /** 是否开启拼团 */
    isStartGroupBuying?: boolean;
    /** 拼团名称 */
    groupBuyingName?: string | null;
    /** 拼团金额 */
    groupBuyingAmount?: number;
    /** 是否显示火热属性 */
    isShowHot?: boolean;
    /** 是否显示倒计时和优惠 */
    isShowEndTimeAndDiscount?: boolean;
    /** 优惠结束时间 */
    endTimeOfPromotion?: moment.Moment | null;
    promotionRemark?: string | null;

    constructor(data?: IUpdateProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : <any>null;
            this.productCategoryId = _data["productCategoryId"] !== undefined ? _data["productCategoryId"] : <any>null;
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>null;
            this.p_Path = _data["p_Path"] !== undefined ? _data["p_Path"] : <any>null;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
            if (Array.isArray(_data["imageList"])) {
                this.imageList = [] as any;
                for (let item of _data["imageList"])
                    this.imageList!.push(UpdateProductMoreFileDto.fromJS(item));
            }
            this.beforePrice = _data["beforePrice"] !== undefined ? _data["beforePrice"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            if (Array.isArray(_data["specificationList"])) {
                this.specificationList = [] as any;
                for (let item of _data["specificationList"])
                    this.specificationList!.push(CreateOrUpdateProductSpecificationDto.fromJS(item));
            }
            this.salesType = _data["salesType"] !== undefined ? _data["salesType"] : <any>null;
            this.integral = _data["integral"] !== undefined ? _data["integral"] : <any>null;
            this.isFree = _data["isFree"] !== undefined ? _data["isFree"] : <any>null;
            this.readCount = _data["readCount"] !== undefined ? _data["readCount"] : <any>null;
            this.saleNum = _data["saleNum"] !== undefined ? _data["saleNum"] : <any>null;
            this.isStartGroupBuying = _data["isStartGroupBuying"] !== undefined ? _data["isStartGroupBuying"] : <any>null;
            this.groupBuyingName = _data["groupBuyingName"] !== undefined ? _data["groupBuyingName"] : <any>null;
            this.groupBuyingAmount = _data["groupBuyingAmount"] !== undefined ? _data["groupBuyingAmount"] : <any>null;
            this.isShowHot = _data["isShowHot"] !== undefined ? _data["isShowHot"] : <any>null;
            this.isShowEndTimeAndDiscount = _data["isShowEndTimeAndDiscount"] !== undefined ? _data["isShowEndTimeAndDiscount"] : <any>null;
            this.endTimeOfPromotion = _data["endTimeOfPromotion"] ? moment.parseZone(_data["endTimeOfPromotion"].toString()) : <any>null;
            this.promotionRemark = _data["promotionRemark"] !== undefined ? _data["promotionRemark"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : <any>null;
        data["productCategoryId"] = this.productCategoryId !== undefined ? this.productCategoryId : <any>null;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>null;
        data["p_Path"] = this.p_Path !== undefined ? this.p_Path : <any>null;
        data["describe"] = this.describe !== undefined ? this.describe : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        if (Array.isArray(this.imageList)) {
            data["imageList"] = [];
            for (let item of this.imageList)
                data["imageList"].push(item.toJSON());
        }
        data["beforePrice"] = this.beforePrice !== undefined ? this.beforePrice : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        if (Array.isArray(this.specificationList)) {
            data["specificationList"] = [];
            for (let item of this.specificationList)
                data["specificationList"].push(item.toJSON());
        }
        data["salesType"] = this.salesType !== undefined ? this.salesType : <any>null;
        data["integral"] = this.integral !== undefined ? this.integral : <any>null;
        data["isFree"] = this.isFree !== undefined ? this.isFree : <any>null;
        data["readCount"] = this.readCount !== undefined ? this.readCount : <any>null;
        data["saleNum"] = this.saleNum !== undefined ? this.saleNum : <any>null;
        data["isStartGroupBuying"] = this.isStartGroupBuying !== undefined ? this.isStartGroupBuying : <any>null;
        data["groupBuyingName"] = this.groupBuyingName !== undefined ? this.groupBuyingName : <any>null;
        data["groupBuyingAmount"] = this.groupBuyingAmount !== undefined ? this.groupBuyingAmount : <any>null;
        data["isShowHot"] = this.isShowHot !== undefined ? this.isShowHot : <any>null;
        data["isShowEndTimeAndDiscount"] = this.isShowEndTimeAndDiscount !== undefined ? this.isShowEndTimeAndDiscount : <any>null;
        data["endTimeOfPromotion"] = this.endTimeOfPromotion ? this.endTimeOfPromotion.toISOString(true) : <any>null;
        data["promotionRemark"] = this.promotionRemark !== undefined ? this.promotionRemark : <any>null;
        return data; 
    }

    clone(): UpdateProductDto {
        const json = this.toJSON();
        let result = new UpdateProductDto();
        result.init(json);
        return result;
    }
}

/** 修改产品 */
export interface IUpdateProductDto {
    id?: number;
    /** 商品名称 */
    name?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 商品类型ID */
    productCategoryId?: number;
    productCategory?: ProductCategory;
    /** 商品图片 */
    p_Path?: string | null;
    /** 商品描述 */
    describe?: string | null;
    /** 商品热门指数 */
    state?: number;
    /** 是否上架 */
    isShow?: boolean;
    imageList?: UpdateProductMoreFileDto[] | null;
    /** 折扣前价格 */
    beforePrice?: number;
    /** 商品价格 */
    price?: number;
    /** 规格明细表 */
    specificationList?: CreateOrUpdateProductSpecificationDto[] | null;
    /** 服务类型 */
    salesType?: string | null;
    /** 赠送积分 */
    integral?: number;
    /** 是否包邮 */
    isFree?: boolean;
    /** 阅读数 */
    readCount?: number;
    /** 销售数量变化值 */
    saleNum?: number;
    /** 是否开启拼团 */
    isStartGroupBuying?: boolean;
    /** 拼团名称 */
    groupBuyingName?: string | null;
    /** 拼团金额 */
    groupBuyingAmount?: number;
    /** 是否显示火热属性 */
    isShowHot?: boolean;
    /** 是否显示倒计时和优惠 */
    isShowEndTimeAndDiscount?: boolean;
    /** 优惠结束时间 */
    endTimeOfPromotion?: moment.Moment | null;
    promotionRemark?: string | null;
}

/** 服务类型 */
export class SalesServiceTypeDtos implements ISalesServiceTypeDtos {
    /** 服务类型ID */
    id?: number;
    /** 服务类型名称 */
    name?: string | null;
    /** 是否选中(返回未选中) */
    isSelect?: boolean;

    constructor(data?: ISalesServiceTypeDtos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isSelect = _data["isSelect"] !== undefined ? _data["isSelect"] : <any>null;
        }
    }

    static fromJS(data: any): SalesServiceTypeDtos {
        data = typeof data === 'object' ? data : {};
        let result = new SalesServiceTypeDtos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isSelect"] = this.isSelect !== undefined ? this.isSelect : <any>null;
        return data; 
    }

    clone(): SalesServiceTypeDtos {
        const json = this.toJSON();
        let result = new SalesServiceTypeDtos();
        result.init(json);
        return result;
    }
}

/** 服务类型 */
export interface ISalesServiceTypeDtos {
    /** 服务类型ID */
    id?: number;
    /** 服务类型名称 */
    name?: string | null;
    /** 是否选中(返回未选中) */
    isSelect?: boolean;
}

export class CreateProductCategoryDto implements ICreateProductCategoryDto {
    /** 商品分类名称 */
    name?: string | null;
    /** 商品分类描述 */
    describe?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 类型单位 */
    unitType?: number;
    /** 是否上架 */
    isShow?: boolean;

    constructor(data?: ICreateProductCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : <any>null;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : <any>null;
            this.unitType = _data["unitType"] !== undefined ? _data["unitType"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
        }
    }

    static fromJS(data: any): CreateProductCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["describe"] = this.describe !== undefined ? this.describe : <any>null;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : <any>null;
        data["unitType"] = this.unitType !== undefined ? this.unitType : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        return data; 
    }

    clone(): CreateProductCategoryDto {
        const json = this.toJSON();
        let result = new CreateProductCategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProductCategoryDto {
    /** 商品分类名称 */
    name?: string | null;
    /** 商品分类描述 */
    describe?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 类型单位 */
    unitType?: number;
    /** 是否上架 */
    isShow?: boolean;
}

/** 产品分类信息 */
export class ProductCategoryDto implements IProductCategoryDto {
    id?: number;
    /** 商品分类名称 */
    name?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 商品分类描述 */
    describe?: string | null;
    /** 类型单位 */
    unitType?: number;
    /** 是否上架 */
    isShow?: boolean;

    constructor(data?: IProductCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : <any>null;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : <any>null;
            this.unitType = _data["unitType"] !== undefined ? _data["unitType"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
        }
    }

    static fromJS(data: any): ProductCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : <any>null;
        data["describe"] = this.describe !== undefined ? this.describe : <any>null;
        data["unitType"] = this.unitType !== undefined ? this.unitType : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        return data; 
    }

    clone(): ProductCategoryDto {
        const json = this.toJSON();
        let result = new ProductCategoryDto();
        result.init(json);
        return result;
    }
}

/** 产品分类信息 */
export interface IProductCategoryDto {
    id?: number;
    /** 商品分类名称 */
    name?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 商品分类描述 */
    describe?: string | null;
    /** 类型单位 */
    unitType?: number;
    /** 是否上架 */
    isShow?: boolean;
}

export class Int64EntityDto implements IInt64EntityDto {
    id?: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data; 
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id?: number;
}

/** 产品分类下拉框键值对 */
export class ProductCategoryKeyVueDto implements IProductCategoryKeyVueDto {
    /** 显示的ID值 */
    value?: number;
    /** 显示的名称 */
    label?: string | null;

    constructor(data?: IProductCategoryKeyVueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
        }
    }

    static fromJS(data: any): ProductCategoryKeyVueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryKeyVueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data; 
    }

    clone(): ProductCategoryKeyVueDto {
        const json = this.toJSON();
        let result = new ProductCategoryKeyVueDto();
        result.init(json);
        return result;
    }
}

/** 产品分类下拉框键值对 */
export interface IProductCategoryKeyVueDto {
    /** 显示的ID值 */
    value?: number;
    /** 显示的名称 */
    label?: string | null;
}

export class ProductCategoryDtoPagedResultDto implements IProductCategoryDtoPagedResultDto {
    items?: ProductCategoryDto[] | null;
    totalCount?: number;

    constructor(data?: IProductCategoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductCategoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): ProductCategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): ProductCategoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductCategoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductCategoryDtoPagedResultDto {
    items?: ProductCategoryDto[] | null;
    totalCount?: number;
}

/** 修改产品 */
export class UpdateProductCategoryDto implements IUpdateProductCategoryDto {
    id?: number;
    /** 商品分类名称 */
    name?: string | null;
    /** 商品分类描述 */
    describe?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 类型单位 */
    unitType?: number;
    /** 是否上架 */
    isShow?: boolean;

    constructor(data?: IUpdateProductCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.describe = _data["describe"] !== undefined ? _data["describe"] : <any>null;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : <any>null;
            this.unitType = _data["unitType"] !== undefined ? _data["unitType"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProductCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["describe"] = this.describe !== undefined ? this.describe : <any>null;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : <any>null;
        data["unitType"] = this.unitType !== undefined ? this.unitType : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        return data; 
    }

    clone(): UpdateProductCategoryDto {
        const json = this.toJSON();
        let result = new UpdateProductCategoryDto();
        result.init(json);
        return result;
    }
}

/** 修改产品 */
export interface IUpdateProductCategoryDto {
    id?: number;
    /** 商品分类名称 */
    name?: string | null;
    /** 商品分类描述 */
    describe?: string | null;
    /** 商品副标题 */
    subtitle?: string | null;
    /** 类型单位 */
    unitType?: number;
    /** 是否上架 */
    isShow?: boolean;
}

export class CreatePromotionalOrderDto implements ICreatePromotionalOrderDto {
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 商品ID */
    product_ID?: number;
    /** 订单总价格 */
    toTalMoney?: number;
    orderRecordWayType?: OrderWayType;
    orderRecordForType?: OrderForType;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 备注描述 */
    description?: string | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
    /** 学生姓名和绑定码 */
    studentNameAndCode?: string | null;
    /** 学校姓名 */
    studentTenantName?: string | null;
    /** 抵扣金额 */
    deductionAmount?: number;

    constructor(data?: ICreatePromotionalOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.product_ID = _data["product_ID"] !== undefined ? _data["product_ID"] : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
            this.orderRecordWayType = _data["orderRecordWayType"] !== undefined ? _data["orderRecordWayType"] : <any>null;
            this.orderRecordForType = _data["orderRecordForType"] !== undefined ? _data["orderRecordForType"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.paidTime = _data["paidTime"] ? moment.parseZone(_data["paidTime"].toString()) : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
            this.studentNameAndCode = _data["studentNameAndCode"] !== undefined ? _data["studentNameAndCode"] : <any>null;
            this.studentTenantName = _data["studentTenantName"] !== undefined ? _data["studentTenantName"] : <any>null;
            this.deductionAmount = _data["deductionAmount"] !== undefined ? _data["deductionAmount"] : <any>null;
        }
    }

    static fromJS(data: any): CreatePromotionalOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePromotionalOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["product_ID"] = this.product_ID !== undefined ? this.product_ID : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        data["orderRecordWayType"] = this.orderRecordWayType !== undefined ? this.orderRecordWayType : <any>null;
        data["orderRecordForType"] = this.orderRecordForType !== undefined ? this.orderRecordForType : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["paidTime"] = this.paidTime ? this.paidTime.toISOString(true) : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        data["studentNameAndCode"] = this.studentNameAndCode !== undefined ? this.studentNameAndCode : <any>null;
        data["studentTenantName"] = this.studentTenantName !== undefined ? this.studentTenantName : <any>null;
        data["deductionAmount"] = this.deductionAmount !== undefined ? this.deductionAmount : <any>null;
        return data; 
    }

    clone(): CreatePromotionalOrderDto {
        const json = this.toJSON();
        let result = new CreatePromotionalOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePromotionalOrderDto {
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 商品ID */
    product_ID?: number;
    /** 订单总价格 */
    toTalMoney?: number;
    orderRecordWayType?: OrderWayType;
    orderRecordForType?: OrderForType;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 备注描述 */
    description?: string | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
    /** 学生姓名和绑定码 */
    studentNameAndCode?: string | null;
    /** 学校姓名 */
    studentTenantName?: string | null;
    /** 抵扣金额 */
    deductionAmount?: number;
}

/** 预约单 */
export class PromotionalOrderDto implements IPromotionalOrderDto {
    id?: string;
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 商品ID */
    product_ID?: number;
    /** 订单总价格 */
    toTalMoney?: number;
    orderRecordWayType?: OrderWayType;
    orderRecordForType?: OrderForType;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 备注描述 */
    description?: string | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
    /** 学生姓名和绑定码 */
    studentNameAndCode?: string | null;
    /** 学校姓名 */
    studentTenantName?: string | null;
    /** 抵扣金额 */
    deductionAmount?: number;
    product?: ProductDto;
    isUse?: boolean;
    /** 下单时间 */
    creationTime?: moment.Moment | null;

    constructor(data?: IPromotionalOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.product_ID = _data["product_ID"] !== undefined ? _data["product_ID"] : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
            this.orderRecordWayType = _data["orderRecordWayType"] !== undefined ? _data["orderRecordWayType"] : <any>null;
            this.orderRecordForType = _data["orderRecordForType"] !== undefined ? _data["orderRecordForType"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.paidTime = _data["paidTime"] ? moment.parseZone(_data["paidTime"].toString()) : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
            this.studentNameAndCode = _data["studentNameAndCode"] !== undefined ? _data["studentNameAndCode"] : <any>null;
            this.studentTenantName = _data["studentTenantName"] !== undefined ? _data["studentTenantName"] : <any>null;
            this.deductionAmount = _data["deductionAmount"] !== undefined ? _data["deductionAmount"] : <any>null;
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>null;
            this.isUse = _data["isUse"] !== undefined ? _data["isUse"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PromotionalOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionalOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["product_ID"] = this.product_ID !== undefined ? this.product_ID : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        data["orderRecordWayType"] = this.orderRecordWayType !== undefined ? this.orderRecordWayType : <any>null;
        data["orderRecordForType"] = this.orderRecordForType !== undefined ? this.orderRecordForType : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["paidTime"] = this.paidTime ? this.paidTime.toISOString(true) : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        data["studentNameAndCode"] = this.studentNameAndCode !== undefined ? this.studentNameAndCode : <any>null;
        data["studentTenantName"] = this.studentTenantName !== undefined ? this.studentTenantName : <any>null;
        data["deductionAmount"] = this.deductionAmount !== undefined ? this.deductionAmount : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["isUse"] = this.isUse !== undefined ? this.isUse : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        return data; 
    }

    clone(): PromotionalOrderDto {
        const json = this.toJSON();
        let result = new PromotionalOrderDto();
        result.init(json);
        return result;
    }
}

/** 预约单 */
export interface IPromotionalOrderDto {
    id?: string;
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 商品ID */
    product_ID?: number;
    /** 订单总价格 */
    toTalMoney?: number;
    orderRecordWayType?: OrderWayType;
    orderRecordForType?: OrderForType;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 备注描述 */
    description?: string | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
    /** 学生姓名和绑定码 */
    studentNameAndCode?: string | null;
    /** 学校姓名 */
    studentTenantName?: string | null;
    /** 抵扣金额 */
    deductionAmount?: number;
    product?: ProductDto;
    isUse?: boolean;
    /** 下单时间 */
    creationTime?: moment.Moment | null;
}

export class PromotionalOrderDtoPagedResultDto implements IPromotionalOrderDtoPagedResultDto {
    items?: PromotionalOrderDto[] | null;
    totalCount?: number;

    constructor(data?: IPromotionalOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PromotionalOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PromotionalOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionalOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): PromotionalOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PromotionalOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPromotionalOrderDtoPagedResultDto {
    items?: PromotionalOrderDto[] | null;
    totalCount?: number;
}

/** 修改产品 */
export class UpdatePromotionalOrderDto implements IUpdatePromotionalOrderDto {
    id?: string;
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 商品ID */
    product_ID?: number;
    /** 订单总价格 */
    toTalMoney?: number;
    orderRecordWayType?: OrderWayType;
    orderRecordForType?: OrderForType;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 备注描述 */
    description?: string | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
    /** 抵扣金额 */
    deductionAmount?: number;

    constructor(data?: IUpdatePromotionalOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.serialNo = _data["serialNo"] !== undefined ? _data["serialNo"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.product_ID = _data["product_ID"] !== undefined ? _data["product_ID"] : <any>null;
            this.toTalMoney = _data["toTalMoney"] !== undefined ? _data["toTalMoney"] : <any>null;
            this.orderRecordWayType = _data["orderRecordWayType"] !== undefined ? _data["orderRecordWayType"] : <any>null;
            this.orderRecordForType = _data["orderRecordForType"] !== undefined ? _data["orderRecordForType"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.paidTime = _data["paidTime"] ? moment.parseZone(_data["paidTime"].toString()) : <any>null;
            this.orderRecordState = _data["orderRecordState"] !== undefined ? _data["orderRecordState"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.contactName = _data["contactName"] !== undefined ? _data["contactName"] : <any>null;
            this.contactPhone = _data["contactPhone"] !== undefined ? _data["contactPhone"] : <any>null;
            this.deductionAmount = _data["deductionAmount"] !== undefined ? _data["deductionAmount"] : <any>null;
        }
    }

    static fromJS(data: any): UpdatePromotionalOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePromotionalOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["serialNo"] = this.serialNo !== undefined ? this.serialNo : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["product_ID"] = this.product_ID !== undefined ? this.product_ID : <any>null;
        data["toTalMoney"] = this.toTalMoney !== undefined ? this.toTalMoney : <any>null;
        data["orderRecordWayType"] = this.orderRecordWayType !== undefined ? this.orderRecordWayType : <any>null;
        data["orderRecordForType"] = this.orderRecordForType !== undefined ? this.orderRecordForType : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["paidTime"] = this.paidTime ? this.paidTime.toISOString(true) : <any>null;
        data["orderRecordState"] = this.orderRecordState !== undefined ? this.orderRecordState : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["contactName"] = this.contactName !== undefined ? this.contactName : <any>null;
        data["contactPhone"] = this.contactPhone !== undefined ? this.contactPhone : <any>null;
        data["deductionAmount"] = this.deductionAmount !== undefined ? this.deductionAmount : <any>null;
        return data; 
    }

    clone(): UpdatePromotionalOrderDto {
        const json = this.toJSON();
        let result = new UpdatePromotionalOrderDto();
        result.init(json);
        return result;
    }
}

/** 修改产品 */
export interface IUpdatePromotionalOrderDto {
    id?: string;
    /** 订单号 */
    orderNumber?: string | null;
    /** 支付返回流水号,成功后赋值 */
    serialNo?: string | null;
    /** 购物学生绑定码 */
    code?: string | null;
    /** 商品ID */
    product_ID?: number;
    /** 订单总价格 */
    toTalMoney?: number;
    orderRecordWayType?: OrderWayType;
    orderRecordForType?: OrderForType;
    /** 实际付款金额 */
    amount?: number;
    /** 支付时间 */
    paidTime?: moment.Moment | null;
    orderRecordState?: OrderState;
    /** 备注描述 */
    description?: string | null;
    /** 联系人姓名 */
    contactName?: string | null;
    /** 联系人电话 */
    contactPhone?: string | null;
    /** 抵扣金额 */
    deductionAmount?: number;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName?: string | null;
    description?: string | null;
    permissions?: string[] | null;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.normalizedName = _data["normalizedName"] !== undefined ? _data["normalizedName"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["normalizedName"] = this.normalizedName !== undefined ? this.normalizedName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data; 
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName?: string | null;
    description?: string | null;
    permissions?: string[] | null;
}

export class RoleDto implements IRoleDto {
    id?: number;
    name!: string;
    displayName!: string;
    normalizedName?: string | null;
    description?: string | null;
    permissions?: string[] | null;
    /** 是否已选 */
    isChecked?: boolean;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.normalizedName = _data["normalizedName"] !== undefined ? _data["normalizedName"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.isChecked = _data["isChecked"] !== undefined ? _data["isChecked"] : <any>null;
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["normalizedName"] = this.normalizedName !== undefined ? this.normalizedName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["isChecked"] = this.isChecked !== undefined ? this.isChecked : <any>null;
        return data; 
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id?: number;
    name: string;
    displayName: string;
    normalizedName?: string | null;
    description?: string | null;
    permissions?: string[] | null;
    /** 是否已选 */
    isChecked?: boolean;
}

export class RoleListDto implements IRoleListDto {
    id?: number;
    name?: string | null;
    displayName?: string | null;
    isStatic?: boolean;
    isDefault?: boolean;
    creationTime?: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : <any>null;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        return data; 
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id?: number;
    name?: string | null;
    displayName?: string | null;
    isStatic?: boolean;
    isDefault?: boolean;
    creationTime?: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items?: RoleListDto[] | null;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items?: RoleListDto[] | null;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName?: string | null;
    name?: string | null;
    displayName?: string | null;
    description?: string | null;
    isGrantedByDefault?: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"] !== undefined ? _data["parentName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isGrantedByDefault = _data["isGrantedByDefault"] !== undefined ? _data["isGrantedByDefault"] : <any>null;
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName !== undefined ? this.parentName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isGrantedByDefault"] = this.isGrantedByDefault !== undefined ? this.isGrantedByDefault : <any>null;
        return data; 
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    parentName?: string | null;
    name?: string | null;
    displayName?: string | null;
    description?: string | null;
    isGrantedByDefault?: boolean;
}

export class FlatPermissionDtoListResultDto implements IFlatPermissionDtoListResultDto {
    items?: FlatPermissionDto[] | null;

    constructor(data?: IFlatPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlatPermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FlatPermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new FlatPermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDtoListResultDto {
    items?: FlatPermissionDto[] | null;
}

export class RoleEditDto implements IRoleEditDto {
    id?: number;
    name!: string;
    displayName!: string;
    description?: string | null;
    isStatic?: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : <any>null;
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : <any>null;
        return data; 
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id?: number;
    name: string;
    displayName: string;
    description?: string | null;
    isStatic?: boolean;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role?: RoleEditDto;
    permissions?: FlatPermissionDto[] | null;
    grantedPermissionNames?: string[] | null;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role?: RoleEditDto;
    permissions?: FlatPermissionDto[] | null;
    grantedPermissionNames?: string[] | null;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items?: RoleDto[] | null;
    totalCount?: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items?: RoleDto[] | null;
    totalCount?: number;
}

/** 添加学校Dto */
export class CreateTenantDto implements ICreateTenantDto {
    id?: number;
    /** Name */
    name!: string;
    /** 所在位置 */
    position?: string | null;
    /** 简介 */
    introduction?: string | null;
    /** <see cref="T:Abp.Organizations.OrganizationUnit" />'s Id which this entity belongs to. */
    organizationUnitId?: number;
    /** 学校类型 */
    schoolType?: string | null;
    /** 是否可添加带专业班级 */
    isAddMajorClass?: boolean;
    /** 经营类型：自营、代理、重点保障 */
    billingType?: number;
    /** 收费类型：C端、B端、C端B端 */
    businessType?: number;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.introduction = _data["introduction"] !== undefined ? _data["introduction"] : <any>null;
            this.organizationUnitId = _data["organizationUnitId"] !== undefined ? _data["organizationUnitId"] : <any>null;
            this.schoolType = _data["schoolType"] !== undefined ? _data["schoolType"] : <any>null;
            this.isAddMajorClass = _data["isAddMajorClass"] !== undefined ? _data["isAddMajorClass"] : <any>null;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : <any>null;
            this.businessType = _data["businessType"] !== undefined ? _data["businessType"] : <any>null;
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["introduction"] = this.introduction !== undefined ? this.introduction : <any>null;
        data["organizationUnitId"] = this.organizationUnitId !== undefined ? this.organizationUnitId : <any>null;
        data["schoolType"] = this.schoolType !== undefined ? this.schoolType : <any>null;
        data["isAddMajorClass"] = this.isAddMajorClass !== undefined ? this.isAddMajorClass : <any>null;
        data["billingType"] = this.billingType !== undefined ? this.billingType : <any>null;
        data["businessType"] = this.businessType !== undefined ? this.businessType : <any>null;
        return data; 
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

/** 添加学校Dto */
export interface ICreateTenantDto {
    id?: number;
    /** Name */
    name: string;
    /** 所在位置 */
    position?: string | null;
    /** 简介 */
    introduction?: string | null;
    /** <see cref="T:Abp.Organizations.OrganizationUnit" />'s Id which this entity belongs to. */
    organizationUnitId?: number;
    /** 学校类型 */
    schoolType?: string | null;
    /** 是否可添加带专业班级 */
    isAddMajorClass?: boolean;
    /** 经营类型：自营、代理、重点保障 */
    billingType?: number;
    /** 收费类型：C端、B端、C端B端 */
    businessType?: number;
}

/** 学校Dto */
export class TenantDto implements ITenantDto {
    id?: number;
    /** TenancyName */
    tenancyName?: string | null;
    /** Name */
    name?: string | null;
    /** 纬度 */
    latitude?: number;
    /** 经度 */
    longitude?: number;
    /** 所在位置 */
    position?: string | null;
    /** 简介 */
    introduction?: string | null;
    /** 是否注册 */
    isRegisterd?: boolean;
    /** <see cref="T:Abp.Organizations.OrganizationUnit" />'s Id which this entity belongs to. */
    organizationUnitId?: number;
    /** 学校类型 */
    schoolType?: string | null;
    /** 转换码 */
    code?: string | null;
    /** 映射海康云学校ID */
    cloudStudentID?: string | null;
    /** 新生报名二维码图片 */
    signBarCodeImg?: string | null;
    /** 经营类型：自营、代理、重点保障 */
    billingType?: number;
    /** 收费类型：C端、B端、C端B端 */
    businessType?: number;
    /** 是否可添加带专业班级 */
    isAddMajorClass?: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenancyName = _data["tenancyName"] !== undefined ? _data["tenancyName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.introduction = _data["introduction"] !== undefined ? _data["introduction"] : <any>null;
            this.isRegisterd = _data["isRegisterd"] !== undefined ? _data["isRegisterd"] : <any>null;
            this.organizationUnitId = _data["organizationUnitId"] !== undefined ? _data["organizationUnitId"] : <any>null;
            this.schoolType = _data["schoolType"] !== undefined ? _data["schoolType"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.cloudStudentID = _data["cloudStudentID"] !== undefined ? _data["cloudStudentID"] : <any>null;
            this.signBarCodeImg = _data["signBarCodeImg"] !== undefined ? _data["signBarCodeImg"] : <any>null;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : <any>null;
            this.businessType = _data["businessType"] !== undefined ? _data["businessType"] : <any>null;
            this.isAddMajorClass = _data["isAddMajorClass"] !== undefined ? _data["isAddMajorClass"] : <any>null;
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenancyName"] = this.tenancyName !== undefined ? this.tenancyName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["introduction"] = this.introduction !== undefined ? this.introduction : <any>null;
        data["isRegisterd"] = this.isRegisterd !== undefined ? this.isRegisterd : <any>null;
        data["organizationUnitId"] = this.organizationUnitId !== undefined ? this.organizationUnitId : <any>null;
        data["schoolType"] = this.schoolType !== undefined ? this.schoolType : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["cloudStudentID"] = this.cloudStudentID !== undefined ? this.cloudStudentID : <any>null;
        data["signBarCodeImg"] = this.signBarCodeImg !== undefined ? this.signBarCodeImg : <any>null;
        data["billingType"] = this.billingType !== undefined ? this.billingType : <any>null;
        data["businessType"] = this.businessType !== undefined ? this.businessType : <any>null;
        data["isAddMajorClass"] = this.isAddMajorClass !== undefined ? this.isAddMajorClass : <any>null;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

/** 学校Dto */
export interface ITenantDto {
    id?: number;
    /** TenancyName */
    tenancyName?: string | null;
    /** Name */
    name?: string | null;
    /** 纬度 */
    latitude?: number;
    /** 经度 */
    longitude?: number;
    /** 所在位置 */
    position?: string | null;
    /** 简介 */
    introduction?: string | null;
    /** 是否注册 */
    isRegisterd?: boolean;
    /** <see cref="T:Abp.Organizations.OrganizationUnit" />'s Id which this entity belongs to. */
    organizationUnitId?: number;
    /** 学校类型 */
    schoolType?: string | null;
    /** 转换码 */
    code?: string | null;
    /** 映射海康云学校ID */
    cloudStudentID?: string | null;
    /** 新生报名二维码图片 */
    signBarCodeImg?: string | null;
    /** 经营类型：自营、代理、重点保障 */
    billingType?: number;
    /** 收费类型：C端、B端、C端B端 */
    businessType?: number;
    /** 是否可添加带专业班级 */
    isAddMajorClass?: boolean;
}

export class ClassDto implements IClassDto {
    name?: string | null;
    classNo?: number;

    constructor(data?: IClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.classNo = _data["classNo"] !== undefined ? _data["classNo"] : <any>null;
        }
    }

    static fromJS(data: any): ClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["classNo"] = this.classNo !== undefined ? this.classNo : <any>null;
        return data; 
    }

    clone(): ClassDto {
        const json = this.toJSON();
        let result = new ClassDto();
        result.init(json);
        return result;
    }
}

export interface IClassDto {
    name?: string | null;
    classNo?: number;
}

export class GradeClassesDto implements IGradeClassesDto {
    name?: string | null;
    gradeNo?: number;
    classes?: ClassDto[] | null;

    constructor(data?: IGradeClassesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            if (Array.isArray(_data["classes"])) {
                this.classes = [] as any;
                for (let item of _data["classes"])
                    this.classes!.push(ClassDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GradeClassesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GradeClassesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        if (Array.isArray(this.classes)) {
            data["classes"] = [];
            for (let item of this.classes)
                data["classes"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GradeClassesDto {
        const json = this.toJSON();
        let result = new GradeClassesDto();
        result.init(json);
        return result;
    }
}

export interface IGradeClassesDto {
    name?: string | null;
    gradeNo?: number;
    classes?: ClassDto[] | null;
}

export class GradeClassesDtoListResultDto implements IGradeClassesDtoListResultDto {
    items?: GradeClassesDto[] | null;

    constructor(data?: IGradeClassesDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GradeClassesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GradeClassesDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GradeClassesDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GradeClassesDtoListResultDto {
        const json = this.toJSON();
        let result = new GradeClassesDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IGradeClassesDtoListResultDto {
    items?: GradeClassesDto[] | null;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items?: TenantDto[] | null;
    totalCount?: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items?: TenantDto[] | null;
    totalCount?: number;
}

/** 修改学校Dto */
export class UpdateTenantDto implements IUpdateTenantDto {
    id?: number;
    /** Name */
    name!: string;
    /** 所在位置 */
    position?: string | null;
    /** 简介 */
    introduction?: string | null;
    /** 是否注册 */
    isRegisterd?: boolean;
    /** <see cref="T:Abp.Organizations.OrganizationUnit" />'s Id which this entity belongs to. */
    organizationUnitId?: number;
    /** 学校类型 */
    schoolType?: string | null;

    constructor(data?: IUpdateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.introduction = _data["introduction"] !== undefined ? _data["introduction"] : <any>null;
            this.isRegisterd = _data["isRegisterd"] !== undefined ? _data["isRegisterd"] : <any>null;
            this.organizationUnitId = _data["organizationUnitId"] !== undefined ? _data["organizationUnitId"] : <any>null;
            this.schoolType = _data["schoolType"] !== undefined ? _data["schoolType"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["introduction"] = this.introduction !== undefined ? this.introduction : <any>null;
        data["isRegisterd"] = this.isRegisterd !== undefined ? this.isRegisterd : <any>null;
        data["organizationUnitId"] = this.organizationUnitId !== undefined ? this.organizationUnitId : <any>null;
        data["schoolType"] = this.schoolType !== undefined ? this.schoolType : <any>null;
        return data; 
    }

    clone(): UpdateTenantDto {
        const json = this.toJSON();
        let result = new UpdateTenantDto();
        result.init(json);
        return result;
    }
}

/** 修改学校Dto */
export interface IUpdateTenantDto {
    id?: number;
    /** Name */
    name: string;
    /** 所在位置 */
    position?: string | null;
    /** 简介 */
    introduction?: string | null;
    /** 是否注册 */
    isRegisterd?: boolean;
    /** <see cref="T:Abp.Organizations.OrganizationUnit" />'s Id which this entity belongs to. */
    organizationUnitId?: number;
    /** 学校类型 */
    schoolType?: string | null;
}

export class ChangScoreInputDto implements IChangScoreInputDto {
    tenantId?: number;
    isScanVip?: boolean;

    constructor(data?: IChangScoreInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.isScanVip = _data["isScanVip"] !== undefined ? _data["isScanVip"] : <any>null;
        }
    }

    static fromJS(data: any): ChangScoreInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangScoreInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["isScanVip"] = this.isScanVip !== undefined ? this.isScanVip : <any>null;
        return data; 
    }

    clone(): ChangScoreInputDto {
        const json = this.toJSON();
        let result = new ChangScoreInputDto();
        result.init(json);
        return result;
    }
}

export interface IChangScoreInputDto {
    tenantId?: number;
    isScanVip?: boolean;
}

export class ScoreSettingPageOutDto implements IScoreSettingPageOutDto {
    /** 是否VIP可看 */
    isVipScan?: boolean;
    /** 学校编号 */
    tenantId?: number;
    /** 学校名称 */
    schoolName?: string | null;

    constructor(data?: IScoreSettingPageOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVipScan = _data["isVipScan"] !== undefined ? _data["isVipScan"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
        }
    }

    static fromJS(data: any): ScoreSettingPageOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreSettingPageOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVipScan"] = this.isVipScan !== undefined ? this.isVipScan : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        return data; 
    }

    clone(): ScoreSettingPageOutDto {
        const json = this.toJSON();
        let result = new ScoreSettingPageOutDto();
        result.init(json);
        return result;
    }
}

export interface IScoreSettingPageOutDto {
    /** 是否VIP可看 */
    isVipScan?: boolean;
    /** 学校编号 */
    tenantId?: number;
    /** 学校名称 */
    schoolName?: string | null;
}

export class ScoreSettingPageOutDtoPagedResultDto implements IScoreSettingPageOutDtoPagedResultDto {
    items?: ScoreSettingPageOutDto[] | null;
    totalCount?: number;

    constructor(data?: IScoreSettingPageOutDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScoreSettingPageOutDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): ScoreSettingPageOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreSettingPageOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): ScoreSettingPageOutDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ScoreSettingPageOutDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IScoreSettingPageOutDtoPagedResultDto {
    items?: ScoreSettingPageOutDto[] | null;
    totalCount?: number;
}

export class ServiceChargeConfigDto implements IServiceChargeConfigDto {
    id?: number;
    annualCost?: number;
    tenantId?: number;
    tenantName?: string | null;

    constructor(data?: IServiceChargeConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.annualCost = _data["annualCost"] !== undefined ? _data["annualCost"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceChargeConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["annualCost"] = this.annualCost !== undefined ? this.annualCost : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        return data; 
    }

    clone(): ServiceChargeConfigDto {
        const json = this.toJSON();
        let result = new ServiceChargeConfigDto();
        result.init(json);
        return result;
    }
}

export interface IServiceChargeConfigDto {
    id?: number;
    annualCost?: number;
    tenantId?: number;
    tenantName?: string | null;
}

export class ServiceChargeConfigDtoListResultDto implements IServiceChargeConfigDtoListResultDto {
    items?: ServiceChargeConfigDto[] | null;

    constructor(data?: IServiceChargeConfigDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceChargeConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceChargeConfigDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeConfigDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ServiceChargeConfigDtoListResultDto {
        const json = this.toJSON();
        let result = new ServiceChargeConfigDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceChargeConfigDtoListResultDto {
    items?: ServiceChargeConfigDto[] | null;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version?: string | null;
    releaseDate?: moment.Moment;
    features?: { [key: string]: boolean; } | null;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.releaseDate = _data["releaseDate"] ? moment.parseZone(_data["releaseDate"].toString()) : <any>null;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        this.features![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString(true) : <any>null;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key] !== undefined ? this.features[key] : <any>null;
            }
        }
        return data; 
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version?: string | null;
    releaseDate?: moment.Moment;
    features?: { [key: string]: boolean; } | null;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id?: number;
    name?: string | null;
    surname?: string | null;
    userName?: string | null;
    emailAddress?: string | null;
    /** 是否是教育局账号 */
    isEdcationUser?: boolean;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.surname = _data["surname"] !== undefined ? _data["surname"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.isEdcationUser = _data["isEdcationUser"] !== undefined ? _data["isEdcationUser"] : <any>null;
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["surname"] = this.surname !== undefined ? this.surname : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["isEdcationUser"] = this.isEdcationUser !== undefined ? this.isEdcationUser : <any>null;
        return data; 
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id?: number;
    name?: string | null;
    surname?: string | null;
    userName?: string | null;
    emailAddress?: string | null;
    /** 是否是教育局账号 */
    isEdcationUser?: boolean;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id?: number;
    tenancyName?: string | null;
    name?: string | null;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenancyName = _data["tenancyName"] !== undefined ? _data["tenancyName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenancyName"] = this.tenancyName !== undefined ? this.tenancyName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data; 
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id?: number;
    tenancyName?: string | null;
    name?: string | null;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application?: ApplicationInfoDto;
    user?: UserLoginInfoDto;
    tenant?: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>null;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>null;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>null;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>null;
        return data; 
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application?: ApplicationInfoDto;
    user?: UserLoginInfoDto;
    tenant?: TenantLoginInfoDto;
}

export class DailyAttendanceInspectionReportItem implements IDailyAttendanceInspectionReportItem {
    /** 学校ID */
    tenantId?: number;
    /** 学校名称 */
    tenantName?: string | null;
    /** 应到人数 */
    shouldArriveNum?: number;
    /** 实到人数 */
    actualArriveNum?: number;
    /** 病假人数 */
    sickLeaveNum?: number;
    /** 事假人数 */
    leaveCompassionateNum?: number;
    /** 未报学生人数 */
    notReportedStudentNum?: number;

    constructor(data?: IDailyAttendanceInspectionReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.shouldArriveNum = _data["shouldArriveNum"] !== undefined ? _data["shouldArriveNum"] : <any>null;
            this.actualArriveNum = _data["actualArriveNum"] !== undefined ? _data["actualArriveNum"] : <any>null;
            this.sickLeaveNum = _data["sickLeaveNum"] !== undefined ? _data["sickLeaveNum"] : <any>null;
            this.leaveCompassionateNum = _data["leaveCompassionateNum"] !== undefined ? _data["leaveCompassionateNum"] : <any>null;
            this.notReportedStudentNum = _data["notReportedStudentNum"] !== undefined ? _data["notReportedStudentNum"] : <any>null;
        }
    }

    static fromJS(data: any): DailyAttendanceInspectionReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new DailyAttendanceInspectionReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["shouldArriveNum"] = this.shouldArriveNum !== undefined ? this.shouldArriveNum : <any>null;
        data["actualArriveNum"] = this.actualArriveNum !== undefined ? this.actualArriveNum : <any>null;
        data["sickLeaveNum"] = this.sickLeaveNum !== undefined ? this.sickLeaveNum : <any>null;
        data["leaveCompassionateNum"] = this.leaveCompassionateNum !== undefined ? this.leaveCompassionateNum : <any>null;
        data["notReportedStudentNum"] = this.notReportedStudentNum !== undefined ? this.notReportedStudentNum : <any>null;
        return data; 
    }

    clone(): DailyAttendanceInspectionReportItem {
        const json = this.toJSON();
        let result = new DailyAttendanceInspectionReportItem();
        result.init(json);
        return result;
    }
}

export interface IDailyAttendanceInspectionReportItem {
    /** 学校ID */
    tenantId?: number;
    /** 学校名称 */
    tenantName?: string | null;
    /** 应到人数 */
    shouldArriveNum?: number;
    /** 实到人数 */
    actualArriveNum?: number;
    /** 病假人数 */
    sickLeaveNum?: number;
    /** 事假人数 */
    leaveCompassionateNum?: number;
    /** 未报学生人数 */
    notReportedStudentNum?: number;
}

export class DailyAttendanceInspectionReportDto implements IDailyAttendanceInspectionReportDto {
    items?: DailyAttendanceInspectionReportItem[] | null;
    totalCount?: number;
    staticItem?: DailyAttendanceInspectionReportItem;

    constructor(data?: IDailyAttendanceInspectionReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DailyAttendanceInspectionReportItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.staticItem = _data["staticItem"] ? DailyAttendanceInspectionReportItem.fromJS(_data["staticItem"]) : <any>null;
        }
    }

    static fromJS(data: any): DailyAttendanceInspectionReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyAttendanceInspectionReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["staticItem"] = this.staticItem ? this.staticItem.toJSON() : <any>null;
        return data; 
    }

    clone(): DailyAttendanceInspectionReportDto {
        const json = this.toJSON();
        let result = new DailyAttendanceInspectionReportDto();
        result.init(json);
        return result;
    }
}

export interface IDailyAttendanceInspectionReportDto {
    items?: DailyAttendanceInspectionReportItem[] | null;
    totalCount?: number;
    staticItem?: DailyAttendanceInspectionReportItem;
}

export enum StudentDailyAttendanceSnapshotStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum LeaveType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
    _21 = 21,
    _49 = 49,
    _50 = 50,
}

export class DailyAttendanceInspectionReportItemBySchool implements IDailyAttendanceInspectionReportItemBySchool {
    name?: string | null;
    gradeNo?: number;
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    readonly className?: string | null;
    leaveType?: LeaveType;
    /** 请假类型 */
    readonly leaveTypeStr?: string | null;
    /** 考勤时间 迟到时间 或者 病事假的结束时间 */
    attendanceTime?: moment.Moment | null;
    /** 返校时间 */
    backSchoolTime?: moment.Moment | null;
    attendanceSnapshotStatus?: StudentDailyAttendanceSnapshotStatus;
    readonly studentDailyAttendanceSnapshotStatusStr?: string | null;
    creationTime?: moment.Moment;

    constructor(data?: IDailyAttendanceInspectionReportItemBySchool) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            this.classNo = _data["classNo"] !== undefined ? _data["classNo"] : <any>null;
            this.majorName = _data["majorName"] !== undefined ? _data["majorName"] : <any>null;
            this.majorClassNo = _data["majorClassNo"] !== undefined ? _data["majorClassNo"] : <any>null;
            (<any>this).className = _data["className"] !== undefined ? _data["className"] : <any>null;
            this.leaveType = _data["leaveType"] !== undefined ? _data["leaveType"] : <any>null;
            (<any>this).leaveTypeStr = _data["leaveTypeStr"] !== undefined ? _data["leaveTypeStr"] : <any>null;
            this.attendanceTime = _data["attendanceTime"] ? moment.parseZone(_data["attendanceTime"].toString()) : <any>null;
            this.backSchoolTime = _data["backSchoolTime"] ? moment.parseZone(_data["backSchoolTime"].toString()) : <any>null;
            this.attendanceSnapshotStatus = _data["attendanceSnapshotStatus"] !== undefined ? _data["attendanceSnapshotStatus"] : <any>null;
            (<any>this).studentDailyAttendanceSnapshotStatusStr = _data["studentDailyAttendanceSnapshotStatusStr"] !== undefined ? _data["studentDailyAttendanceSnapshotStatusStr"] : <any>null;
            this.creationTime = _data["creationTime"] ? moment.parseZone(_data["creationTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DailyAttendanceInspectionReportItemBySchool {
        data = typeof data === 'object' ? data : {};
        let result = new DailyAttendanceInspectionReportItemBySchool();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["classNo"] = this.classNo !== undefined ? this.classNo : <any>null;
        data["majorName"] = this.majorName !== undefined ? this.majorName : <any>null;
        data["majorClassNo"] = this.majorClassNo !== undefined ? this.majorClassNo : <any>null;
        data["className"] = this.className !== undefined ? this.className : <any>null;
        data["leaveType"] = this.leaveType !== undefined ? this.leaveType : <any>null;
        data["leaveTypeStr"] = this.leaveTypeStr !== undefined ? this.leaveTypeStr : <any>null;
        data["attendanceTime"] = this.attendanceTime ? this.attendanceTime.toISOString(true) : <any>null;
        data["backSchoolTime"] = this.backSchoolTime ? this.backSchoolTime.toISOString(true) : <any>null;
        data["attendanceSnapshotStatus"] = this.attendanceSnapshotStatus !== undefined ? this.attendanceSnapshotStatus : <any>null;
        data["studentDailyAttendanceSnapshotStatusStr"] = this.studentDailyAttendanceSnapshotStatusStr !== undefined ? this.studentDailyAttendanceSnapshotStatusStr : <any>null;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString(true) : <any>null;
        return data; 
    }

    clone(): DailyAttendanceInspectionReportItemBySchool {
        const json = this.toJSON();
        let result = new DailyAttendanceInspectionReportItemBySchool();
        result.init(json);
        return result;
    }
}

export interface IDailyAttendanceInspectionReportItemBySchool {
    name?: string | null;
    gradeNo?: number;
    classNo?: number;
    /** 专业名称 */
    majorName?: string | null;
    /** 专业班级号
当为职中或者非12年教育的班级时，使用该班级号代替ClassNo */
    majorClassNo?: string | null;
    className?: string | null;
    leaveType?: LeaveType;
    /** 请假类型 */
    leaveTypeStr?: string | null;
    /** 考勤时间 迟到时间 或者 病事假的结束时间 */
    attendanceTime?: moment.Moment | null;
    /** 返校时间 */
    backSchoolTime?: moment.Moment | null;
    attendanceSnapshotStatus?: StudentDailyAttendanceSnapshotStatus;
    studentDailyAttendanceSnapshotStatusStr?: string | null;
    creationTime?: moment.Moment;
}

export class DailyAttendanceInspectionReportSchoolDto implements IDailyAttendanceInspectionReportSchoolDto {
    items?: DailyAttendanceInspectionReportItemBySchool[] | null;
    totalCount?: number;
    staticItem?: DailyAttendanceInspectionReportItem;

    constructor(data?: IDailyAttendanceInspectionReportSchoolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DailyAttendanceInspectionReportItemBySchool.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
            this.staticItem = _data["staticItem"] ? DailyAttendanceInspectionReportItem.fromJS(_data["staticItem"]) : <any>null;
        }
    }

    static fromJS(data: any): DailyAttendanceInspectionReportSchoolDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyAttendanceInspectionReportSchoolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        data["staticItem"] = this.staticItem ? this.staticItem.toJSON() : <any>null;
        return data; 
    }

    clone(): DailyAttendanceInspectionReportSchoolDto {
        const json = this.toJSON();
        let result = new DailyAttendanceInspectionReportSchoolDto();
        result.init(json);
        return result;
    }
}

export interface IDailyAttendanceInspectionReportSchoolDto {
    items?: DailyAttendanceInspectionReportItemBySchool[] | null;
    totalCount?: number;
    staticItem?: DailyAttendanceInspectionReportItem;
}

export class LabelThree implements ILabelThree {
    value?: string | null;
    label?: string | null;

    constructor(data?: ILabelThree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
        }
    }

    static fromJS(data: any): LabelThree {
        data = typeof data === 'object' ? data : {};
        let result = new LabelThree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        return data; 
    }

    clone(): LabelThree {
        const json = this.toJSON();
        let result = new LabelThree();
        result.init(json);
        return result;
    }
}

export interface ILabelThree {
    value?: string | null;
    label?: string | null;
}

export class OrganizationUnitsItem implements IOrganizationUnitsItem {
    value?: string | null;
    label?: string | null;
    children?: LabelThree[] | null;

    constructor(data?: IOrganizationUnitsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(LabelThree.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitsItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrganizationUnitsItem {
        const json = this.toJSON();
        let result = new OrganizationUnitsItem();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitsItem {
    value?: string | null;
    label?: string | null;
    children?: LabelThree[] | null;
}

export class OrganizationUnitsDto implements IOrganizationUnitsDto {
    value?: string | null;
    label?: string | null;
    children?: OrganizationUnitsItem[] | null;

    constructor(data?: IOrganizationUnitsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(OrganizationUnitsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrganizationUnitsDto {
        const json = this.toJSON();
        let result = new OrganizationUnitsDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitsDto {
    value?: string | null;
    label?: string | null;
    children?: OrganizationUnitsItem[] | null;
}

export class PositionDetail implements IPositionDetail {
    /** 区  镇 */
    district?: string | null;
    /** 未到校人数 */
    notInSchoolCount?: number;

    constructor(data?: IPositionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.district = _data["district"] !== undefined ? _data["district"] : <any>null;
            this.notInSchoolCount = _data["notInSchoolCount"] !== undefined ? _data["notInSchoolCount"] : <any>null;
        }
    }

    static fromJS(data: any): PositionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["district"] = this.district !== undefined ? this.district : <any>null;
        data["notInSchoolCount"] = this.notInSchoolCount !== undefined ? this.notInSchoolCount : <any>null;
        return data; 
    }

    clone(): PositionDetail {
        const json = this.toJSON();
        let result = new PositionDetail();
        result.init(json);
        return result;
    }
}

export interface IPositionDetail {
    /** 区  镇 */
    district?: string | null;
    /** 未到校人数 */
    notInSchoolCount?: number;
}

/** 获取整个地区的数据 */
export class DailyAttendanceInspectionByPosition implements IDailyAttendanceInspectionByPosition {
    staticItem?: DailyAttendanceInspectionReportItem;
    positionDetails?: PositionDetail[] | null;

    constructor(data?: IDailyAttendanceInspectionByPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staticItem = _data["staticItem"] ? DailyAttendanceInspectionReportItem.fromJS(_data["staticItem"]) : <any>null;
            if (Array.isArray(_data["positionDetails"])) {
                this.positionDetails = [] as any;
                for (let item of _data["positionDetails"])
                    this.positionDetails!.push(PositionDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyAttendanceInspectionByPosition {
        data = typeof data === 'object' ? data : {};
        let result = new DailyAttendanceInspectionByPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staticItem"] = this.staticItem ? this.staticItem.toJSON() : <any>null;
        if (Array.isArray(this.positionDetails)) {
            data["positionDetails"] = [];
            for (let item of this.positionDetails)
                data["positionDetails"].push(item.toJSON());
        }
        return data; 
    }

    clone(): DailyAttendanceInspectionByPosition {
        const json = this.toJSON();
        let result = new DailyAttendanceInspectionByPosition();
        result.init(json);
        return result;
    }
}

/** 获取整个地区的数据 */
export interface IDailyAttendanceInspectionByPosition {
    staticItem?: DailyAttendanceInspectionReportItem;
    positionDetails?: PositionDetail[] | null;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items?: UserDto[] | null;
    totalCount?: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items?: UserDto[] | null;
    totalCount?: number;
}

export class CreateUserInput implements ICreateUserInput {
    phoneNumber?: string | null;
    name?: string | null;
    /** 是否是教育局账号 */
    isEdcationUser?: boolean;

    constructor(data?: ICreateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isEdcationUser = _data["isEdcationUser"] !== undefined ? _data["isEdcationUser"] : <any>null;
        }
    }

    static fromJS(data: any): CreateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isEdcationUser"] = this.isEdcationUser !== undefined ? this.isEdcationUser : <any>null;
        return data; 
    }

    clone(): CreateUserInput {
        const json = this.toJSON();
        let result = new CreateUserInput();
        result.init(json);
        return result;
    }
}

export interface ICreateUserInput {
    phoneNumber?: string | null;
    name?: string | null;
    /** 是否是教育局账号 */
    isEdcationUser?: boolean;
}

export class RegionLimitDto implements IRegionLimitDto {
    /** 省 */
    province?: string | null;
    /** 市 */
    city?: string | null;
    /** 区 */
    district?: string | null;

    constructor(data?: IRegionLimitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.province = _data["province"] !== undefined ? _data["province"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.district = _data["district"] !== undefined ? _data["district"] : <any>null;
        }
    }

    static fromJS(data: any): RegionLimitDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionLimitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["district"] = this.district !== undefined ? this.district : <any>null;
        return data; 
    }

    clone(): RegionLimitDto {
        const json = this.toJSON();
        let result = new RegionLimitDto();
        result.init(json);
        return result;
    }
}

export interface IRegionLimitDto {
    /** 省 */
    province?: string | null;
    /** 市 */
    city?: string | null;
    /** 区 */
    district?: string | null;
}

export class CreateOrUpdateEdcationPassionInput implements ICreateOrUpdateEdcationPassionInput {
    /** 用户ID */
    userId?: number;
    /** 对应的管理地区 */
    regionLimitDtos?: RegionLimitDto[] | null;

    constructor(data?: ICreateOrUpdateEdcationPassionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["regionLimitDtos"])) {
                this.regionLimitDtos = [] as any;
                for (let item of _data["regionLimitDtos"])
                    this.regionLimitDtos!.push(RegionLimitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEdcationPassionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEdcationPassionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.regionLimitDtos)) {
            data["regionLimitDtos"] = [];
            for (let item of this.regionLimitDtos)
                data["regionLimitDtos"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateOrUpdateEdcationPassionInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateEdcationPassionInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateEdcationPassionInput {
    /** 用户ID */
    userId?: number;
    /** 对应的管理地区 */
    regionLimitDtos?: RegionLimitDto[] | null;
}

export class UserRegionLimit implements IUserRegionLimit {
    id?: number;
    userId?: number;
    province?: string | null;
    city?: string | null;
    district?: string | null;

    constructor(data?: IUserRegionLimit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.province = _data["province"] !== undefined ? _data["province"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.district = _data["district"] !== undefined ? _data["district"] : <any>null;
        }
    }

    static fromJS(data: any): UserRegionLimit {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegionLimit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["district"] = this.district !== undefined ? this.district : <any>null;
        return data; 
    }

    clone(): UserRegionLimit {
        const json = this.toJSON();
        let result = new UserRegionLimit();
        result.init(json);
        return result;
    }
}

export interface IUserRegionLimit {
    id?: number;
    userId?: number;
    province?: string | null;
    city?: string | null;
    district?: string | null;
}

export class ResetPasswordDto implements IResetPasswordDto {
    userId!: number;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data; 
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    userId: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        return data; 
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class SchoolPermissionSet implements ISchoolPermissionSet {
    /** 学校Id */
    tenantId?: number | null;
    /** 是否为服务商 */
    isMaintain?: boolean;
    /** 是否为三方服务商 */
    isServiceProvier?: boolean;
    /** 是否关联 */
    isRelation?: boolean;

    constructor(data?: ISchoolPermissionSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.isMaintain = _data["isMaintain"] !== undefined ? _data["isMaintain"] : <any>null;
            this.isServiceProvier = _data["isServiceProvier"] !== undefined ? _data["isServiceProvier"] : <any>null;
            this.isRelation = _data["isRelation"] !== undefined ? _data["isRelation"] : <any>null;
        }
    }

    static fromJS(data: any): SchoolPermissionSet {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolPermissionSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["isMaintain"] = this.isMaintain !== undefined ? this.isMaintain : <any>null;
        data["isServiceProvier"] = this.isServiceProvier !== undefined ? this.isServiceProvier : <any>null;
        data["isRelation"] = this.isRelation !== undefined ? this.isRelation : <any>null;
        return data; 
    }

    clone(): SchoolPermissionSet {
        const json = this.toJSON();
        let result = new SchoolPermissionSet();
        result.init(json);
        return result;
    }
}

export interface ISchoolPermissionSet {
    /** 学校Id */
    tenantId?: number | null;
    /** 是否为服务商 */
    isMaintain?: boolean;
    /** 是否为三方服务商 */
    isServiceProvier?: boolean;
    /** 是否关联 */
    isRelation?: boolean;
}

export class AddSchoolManagerInput implements IAddSchoolManagerInput {
    userId?: number;
    schoolPermissionSettings?: SchoolPermissionSet[] | null;

    constructor(data?: IAddSchoolManagerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["schoolPermissionSettings"])) {
                this.schoolPermissionSettings = [] as any;
                for (let item of _data["schoolPermissionSettings"])
                    this.schoolPermissionSettings!.push(SchoolPermissionSet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddSchoolManagerInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddSchoolManagerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.schoolPermissionSettings)) {
            data["schoolPermissionSettings"] = [];
            for (let item of this.schoolPermissionSettings)
                data["schoolPermissionSettings"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AddSchoolManagerInput {
        const json = this.toJSON();
        let result = new AddSchoolManagerInput();
        result.init(json);
        return result;
    }
}

export interface IAddSchoolManagerInput {
    userId?: number;
    schoolPermissionSettings?: SchoolPermissionSet[] | null;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items?: RoleDto[] | null;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items?: RoleDto[] | null;
}

export class UpdateUserRoleInput implements IUpdateUserRoleInput {
    /** 用户Id */
    userId!: number;
    /** 角色Id列表 */
    roleIds!: number[];

    constructor(data?: IUpdateUserRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roleIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data; 
    }

    clone(): UpdateUserRoleInput {
        const json = this.toJSON();
        let result = new UpdateUserRoleInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserRoleInput {
    /** 用户Id */
    userId: number;
    /** 角色Id列表 */
    roleIds: number[];
}

export class SimpleTenantDtoPagedResultDto implements ISimpleTenantDtoPagedResultDto {
    items?: SimpleTenantDto[] | null;
    totalCount?: number;

    constructor(data?: ISimpleTenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleTenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): SimpleTenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleTenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): SimpleTenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SimpleTenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISimpleTenantDtoPagedResultDto {
    items?: SimpleTenantDto[] | null;
    totalCount?: number;
}

export class UserByTypeDto implements IUserByTypeDto {
    id?: number;
    name?: string | null;
    phoneNumber?: string | null;
    tenantId?: number;
    tenantName?: string | null;
    isOpenVipManager?: boolean;

    constructor(data?: IUserByTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.tenantName = _data["tenantName"] !== undefined ? _data["tenantName"] : <any>null;
            this.isOpenVipManager = _data["isOpenVipManager"] !== undefined ? _data["isOpenVipManager"] : <any>null;
        }
    }

    static fromJS(data: any): UserByTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserByTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["tenantName"] = this.tenantName !== undefined ? this.tenantName : <any>null;
        data["isOpenVipManager"] = this.isOpenVipManager !== undefined ? this.isOpenVipManager : <any>null;
        return data; 
    }

    clone(): UserByTypeDto {
        const json = this.toJSON();
        let result = new UserByTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUserByTypeDto {
    id?: number;
    name?: string | null;
    phoneNumber?: string | null;
    tenantId?: number;
    tenantName?: string | null;
    isOpenVipManager?: boolean;
}

export class UserByTypeDtoPagedResultDto implements IUserByTypeDtoPagedResultDto {
    items?: UserByTypeDto[] | null;
    totalCount?: number;

    constructor(data?: IUserByTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserByTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): UserByTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserByTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): UserByTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserByTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserByTypeDtoPagedResultDto {
    items?: UserByTypeDto[] | null;
    totalCount?: number;
}

/** 开启或者关闭会员课修改权限 */
export class CreateOrDeleteUserPurViewInput implements ICreateOrDeleteUserPurViewInput {
    userId?: number;
    tenantId?: number;
    /** 是否开启了会员可修改权限 */
    isOpenVipManager?: boolean;

    constructor(data?: ICreateOrDeleteUserPurViewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.isOpenVipManager = _data["isOpenVipManager"] !== undefined ? _data["isOpenVipManager"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrDeleteUserPurViewInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrDeleteUserPurViewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["isOpenVipManager"] = this.isOpenVipManager !== undefined ? this.isOpenVipManager : <any>null;
        return data; 
    }

    clone(): CreateOrDeleteUserPurViewInput {
        const json = this.toJSON();
        let result = new CreateOrDeleteUserPurViewInput();
        result.init(json);
        return result;
    }
}

/** 开启或者关闭会员课修改权限 */
export interface ICreateOrDeleteUserPurViewInput {
    userId?: number;
    tenantId?: number;
    /** 是否开启了会员可修改权限 */
    isOpenVipManager?: boolean;
}

export enum PlatformType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class UserCountDto implements IUserCountDto {
    /** 今日新增用户 */
    todayUserCount?: number;
    /** 昨日新增用户 */
    yestodayUserCount?: number;
    /** 7天新增用户 */
    day7UserCount?: number;
    /** 总用户 */
    totalUserCount?: number;

    constructor(data?: IUserCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.todayUserCount = _data["todayUserCount"] !== undefined ? _data["todayUserCount"] : <any>null;
            this.yestodayUserCount = _data["yestodayUserCount"] !== undefined ? _data["yestodayUserCount"] : <any>null;
            this.day7UserCount = _data["day7UserCount"] !== undefined ? _data["day7UserCount"] : <any>null;
            this.totalUserCount = _data["totalUserCount"] !== undefined ? _data["totalUserCount"] : <any>null;
        }
    }

    static fromJS(data: any): UserCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todayUserCount"] = this.todayUserCount !== undefined ? this.todayUserCount : <any>null;
        data["yestodayUserCount"] = this.yestodayUserCount !== undefined ? this.yestodayUserCount : <any>null;
        data["day7UserCount"] = this.day7UserCount !== undefined ? this.day7UserCount : <any>null;
        data["totalUserCount"] = this.totalUserCount !== undefined ? this.totalUserCount : <any>null;
        return data; 
    }

    clone(): UserCountDto {
        const json = this.toJSON();
        let result = new UserCountDto();
        result.init(json);
        return result;
    }
}

export interface IUserCountDto {
    /** 今日新增用户 */
    todayUserCount?: number;
    /** 昨日新增用户 */
    yestodayUserCount?: number;
    /** 7天新增用户 */
    day7UserCount?: number;
    /** 总用户 */
    totalUserCount?: number;
}

/** 用户消费 */
export class UserPaymentDto implements IUserPaymentDto {
    /** 付费用户 */
    paidUserCount?: number;
    /** 未付费用户 */
    notPaidUserCount?: number;

    constructor(data?: IUserPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paidUserCount = _data["paidUserCount"] !== undefined ? _data["paidUserCount"] : <any>null;
            this.notPaidUserCount = _data["notPaidUserCount"] !== undefined ? _data["notPaidUserCount"] : <any>null;
        }
    }

    static fromJS(data: any): UserPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidUserCount"] = this.paidUserCount !== undefined ? this.paidUserCount : <any>null;
        data["notPaidUserCount"] = this.notPaidUserCount !== undefined ? this.notPaidUserCount : <any>null;
        return data; 
    }

    clone(): UserPaymentDto {
        const json = this.toJSON();
        let result = new UserPaymentDto();
        result.init(json);
        return result;
    }
}

/** 用户消费 */
export interface IUserPaymentDto {
    /** 付费用户 */
    paidUserCount?: number;
    /** 未付费用户 */
    notPaidUserCount?: number;
}

export class UserActiveDto implements IUserActiveDto {
    /** 一个星期 */
    weekCount?: number;
    /** 一个月 */
    aMonthCount?: number;
    /** 三个月 */
    month3Count?: number;

    constructor(data?: IUserActiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekCount = _data["weekCount"] !== undefined ? _data["weekCount"] : <any>null;
            this.aMonthCount = _data["aMonthCount"] !== undefined ? _data["aMonthCount"] : <any>null;
            this.month3Count = _data["month3Count"] !== undefined ? _data["month3Count"] : <any>null;
        }
    }

    static fromJS(data: any): UserActiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekCount"] = this.weekCount !== undefined ? this.weekCount : <any>null;
        data["aMonthCount"] = this.aMonthCount !== undefined ? this.aMonthCount : <any>null;
        data["month3Count"] = this.month3Count !== undefined ? this.month3Count : <any>null;
        return data; 
    }

    clone(): UserActiveDto {
        const json = this.toJSON();
        let result = new UserActiveDto();
        result.init(json);
        return result;
    }
}

export interface IUserActiveDto {
    /** 一个星期 */
    weekCount?: number;
    /** 一个月 */
    aMonthCount?: number;
    /** 三个月 */
    month3Count?: number;
}

export enum VipPayPriceSettingType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class VipRarionGrade implements IVipRarionGrade {
    gradeNo?: number;
    gradeName?: string | null;
    chicked?: boolean;

    constructor(data?: IVipRarionGrade) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gradeNo = _data["gradeNo"] !== undefined ? _data["gradeNo"] : <any>null;
            this.gradeName = _data["gradeName"] !== undefined ? _data["gradeName"] : <any>null;
            this.chicked = _data["chicked"] !== undefined ? _data["chicked"] : <any>null;
        }
    }

    static fromJS(data: any): VipRarionGrade {
        data = typeof data === 'object' ? data : {};
        let result = new VipRarionGrade();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gradeNo"] = this.gradeNo !== undefined ? this.gradeNo : <any>null;
        data["gradeName"] = this.gradeName !== undefined ? this.gradeName : <any>null;
        data["chicked"] = this.chicked !== undefined ? this.chicked : <any>null;
        return data; 
    }

    clone(): VipRarionGrade {
        const json = this.toJSON();
        let result = new VipRarionGrade();
        result.init(json);
        return result;
    }
}

export interface IVipRarionGrade {
    gradeNo?: number;
    gradeName?: string | null;
    chicked?: boolean;
}

export class VipPriceDto implements IVipPriceDto {
    /** 配置ID */
    id?: number;
    /** 学校ID */
    tenantId?: number;
    /** VIP充值原价 */
    originalAmout?: number;
    /** VIP充值实际价 */
    amount?: number;
    /** VIP充值描述 */
    description?: string | null;
    /** 是否启用 */
    isEnable?: boolean;
    /** Vip月份数量 */
    month?: number;
    /** 会员截至日期 */
    expiredDateTime?: moment.Moment | null;
    /** 微信充值排序号码 */
    sortedNo?: number;
    type?: VipPayPriceSettingType;
    registrationType?: RegistrationType;
    /** 会员赠送的天数 */
    days?: number;
    /** 是否默认 选中 */
    isDefaltChick?: boolean;
    /** 仅限年级查看 */
    gradeNo?: number[] | null;
    vipRarionGrade?: VipRarionGrade[] | null;

    constructor(data?: IVipPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.originalAmout = _data["originalAmout"] !== undefined ? _data["originalAmout"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : <any>null;
            this.month = _data["month"] !== undefined ? _data["month"] : <any>null;
            this.expiredDateTime = _data["expiredDateTime"] ? moment.parseZone(_data["expiredDateTime"].toString()) : <any>null;
            this.sortedNo = _data["sortedNo"] !== undefined ? _data["sortedNo"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.registrationType = _data["registrationType"] !== undefined ? _data["registrationType"] : <any>null;
            this.days = _data["days"] !== undefined ? _data["days"] : <any>null;
            this.isDefaltChick = _data["isDefaltChick"] !== undefined ? _data["isDefaltChick"] : <any>null;
            if (Array.isArray(_data["gradeNo"])) {
                this.gradeNo = [] as any;
                for (let item of _data["gradeNo"])
                    this.gradeNo!.push(item);
            }
            if (Array.isArray(_data["vipRarionGrade"])) {
                this.vipRarionGrade = [] as any;
                for (let item of _data["vipRarionGrade"])
                    this.vipRarionGrade!.push(VipRarionGrade.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VipPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new VipPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["originalAmout"] = this.originalAmout !== undefined ? this.originalAmout : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : <any>null;
        data["month"] = this.month !== undefined ? this.month : <any>null;
        data["expiredDateTime"] = this.expiredDateTime ? this.expiredDateTime.toISOString(true) : <any>null;
        data["sortedNo"] = this.sortedNo !== undefined ? this.sortedNo : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["registrationType"] = this.registrationType !== undefined ? this.registrationType : <any>null;
        data["days"] = this.days !== undefined ? this.days : <any>null;
        data["isDefaltChick"] = this.isDefaltChick !== undefined ? this.isDefaltChick : <any>null;
        if (Array.isArray(this.gradeNo)) {
            data["gradeNo"] = [];
            for (let item of this.gradeNo)
                data["gradeNo"].push(item);
        }
        if (Array.isArray(this.vipRarionGrade)) {
            data["vipRarionGrade"] = [];
            for (let item of this.vipRarionGrade)
                data["vipRarionGrade"].push(item.toJSON());
        }
        return data; 
    }

    clone(): VipPriceDto {
        const json = this.toJSON();
        let result = new VipPriceDto();
        result.init(json);
        return result;
    }
}

export interface IVipPriceDto {
    /** 配置ID */
    id?: number;
    /** 学校ID */
    tenantId?: number;
    /** VIP充值原价 */
    originalAmout?: number;
    /** VIP充值实际价 */
    amount?: number;
    /** VIP充值描述 */
    description?: string | null;
    /** 是否启用 */
    isEnable?: boolean;
    /** Vip月份数量 */
    month?: number;
    /** 会员截至日期 */
    expiredDateTime?: moment.Moment | null;
    /** 微信充值排序号码 */
    sortedNo?: number;
    type?: VipPayPriceSettingType;
    registrationType?: RegistrationType;
    /** 会员赠送的天数 */
    days?: number;
    /** 是否默认 选中 */
    isDefaltChick?: boolean;
    /** 仅限年级查看 */
    gradeNo?: number[] | null;
    vipRarionGrade?: VipRarionGrade[] | null;
}

export class QRCodeContentSetting implements IQRCodeContentSetting {
    id?: number;
    gradeClassRequire?: boolean;
    gradeClassIsOpen?: boolean;
    gradeIsOpen?: boolean;
    gradeRequire?: boolean;
    studentNameRequire?: boolean;
    studentNameIsOpen?: boolean;
    parentNameRequire?: boolean;
    parentNameIsOpen?: boolean;
    remarkRequire?: boolean;
    remarkIsOpen?: boolean;
    tenantId?: number;

    constructor(data?: IQRCodeContentSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.gradeClassRequire = _data["gradeClassRequire"] !== undefined ? _data["gradeClassRequire"] : <any>null;
            this.gradeClassIsOpen = _data["gradeClassIsOpen"] !== undefined ? _data["gradeClassIsOpen"] : <any>null;
            this.gradeIsOpen = _data["gradeIsOpen"] !== undefined ? _data["gradeIsOpen"] : <any>null;
            this.gradeRequire = _data["gradeRequire"] !== undefined ? _data["gradeRequire"] : <any>null;
            this.studentNameRequire = _data["studentNameRequire"] !== undefined ? _data["studentNameRequire"] : <any>null;
            this.studentNameIsOpen = _data["studentNameIsOpen"] !== undefined ? _data["studentNameIsOpen"] : <any>null;
            this.parentNameRequire = _data["parentNameRequire"] !== undefined ? _data["parentNameRequire"] : <any>null;
            this.parentNameIsOpen = _data["parentNameIsOpen"] !== undefined ? _data["parentNameIsOpen"] : <any>null;
            this.remarkRequire = _data["remarkRequire"] !== undefined ? _data["remarkRequire"] : <any>null;
            this.remarkIsOpen = _data["remarkIsOpen"] !== undefined ? _data["remarkIsOpen"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): QRCodeContentSetting {
        data = typeof data === 'object' ? data : {};
        let result = new QRCodeContentSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["gradeClassRequire"] = this.gradeClassRequire !== undefined ? this.gradeClassRequire : <any>null;
        data["gradeClassIsOpen"] = this.gradeClassIsOpen !== undefined ? this.gradeClassIsOpen : <any>null;
        data["gradeIsOpen"] = this.gradeIsOpen !== undefined ? this.gradeIsOpen : <any>null;
        data["gradeRequire"] = this.gradeRequire !== undefined ? this.gradeRequire : <any>null;
        data["studentNameRequire"] = this.studentNameRequire !== undefined ? this.studentNameRequire : <any>null;
        data["studentNameIsOpen"] = this.studentNameIsOpen !== undefined ? this.studentNameIsOpen : <any>null;
        data["parentNameRequire"] = this.parentNameRequire !== undefined ? this.parentNameRequire : <any>null;
        data["parentNameIsOpen"] = this.parentNameIsOpen !== undefined ? this.parentNameIsOpen : <any>null;
        data["remarkRequire"] = this.remarkRequire !== undefined ? this.remarkRequire : <any>null;
        data["remarkIsOpen"] = this.remarkIsOpen !== undefined ? this.remarkIsOpen : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): QRCodeContentSetting {
        const json = this.toJSON();
        let result = new QRCodeContentSetting();
        result.init(json);
        return result;
    }
}

export interface IQRCodeContentSetting {
    id?: number;
    gradeClassRequire?: boolean;
    gradeClassIsOpen?: boolean;
    gradeIsOpen?: boolean;
    gradeRequire?: boolean;
    studentNameRequire?: boolean;
    studentNameIsOpen?: boolean;
    parentNameRequire?: boolean;
    parentNameIsOpen?: boolean;
    remarkRequire?: boolean;
    remarkIsOpen?: boolean;
    tenantId?: number;
}

/** 充值选项设置 */
export class OptionSettingsDto implements IOptionSettingsDto {
    /** 学校Id */
    schoolId?: number;
    /** 学校名字 */
    schoolName?: string | null;
    /** 是否使用联通办卡登记 */
    isShow?: boolean;
    /** 配置项 */
    vipPrices?: VipPriceDto[] | null;
    /** 二维码填写设置说明总结 */
    qrCodeSettingStr?: string | null;
    qrCodeContentSetting?: QRCodeContentSetting;
    schoolVipType?: string | null;

    constructor(data?: IOptionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schoolId = _data["schoolId"] !== undefined ? _data["schoolId"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
            if (Array.isArray(_data["vipPrices"])) {
                this.vipPrices = [] as any;
                for (let item of _data["vipPrices"])
                    this.vipPrices!.push(VipPriceDto.fromJS(item));
            }
            this.qrCodeSettingStr = _data["qrCodeSettingStr"] !== undefined ? _data["qrCodeSettingStr"] : <any>null;
            this.qrCodeContentSetting = _data["qrCodeContentSetting"] ? QRCodeContentSetting.fromJS(_data["qrCodeContentSetting"]) : <any>null;
            this.schoolVipType = _data["schoolVipType"] !== undefined ? _data["schoolVipType"] : <any>null;
        }
    }

    static fromJS(data: any): OptionSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schoolId"] = this.schoolId !== undefined ? this.schoolId : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        if (Array.isArray(this.vipPrices)) {
            data["vipPrices"] = [];
            for (let item of this.vipPrices)
                data["vipPrices"].push(item.toJSON());
        }
        data["qrCodeSettingStr"] = this.qrCodeSettingStr !== undefined ? this.qrCodeSettingStr : <any>null;
        data["qrCodeContentSetting"] = this.qrCodeContentSetting ? this.qrCodeContentSetting.toJSON() : <any>null;
        data["schoolVipType"] = this.schoolVipType !== undefined ? this.schoolVipType : <any>null;
        return data; 
    }

    clone(): OptionSettingsDto {
        const json = this.toJSON();
        let result = new OptionSettingsDto();
        result.init(json);
        return result;
    }
}

/** 充值选项设置 */
export interface IOptionSettingsDto {
    /** 学校Id */
    schoolId?: number;
    /** 学校名字 */
    schoolName?: string | null;
    /** 是否使用联通办卡登记 */
    isShow?: boolean;
    /** 配置项 */
    vipPrices?: VipPriceDto[] | null;
    /** 二维码填写设置说明总结 */
    qrCodeSettingStr?: string | null;
    qrCodeContentSetting?: QRCodeContentSetting;
    schoolVipType?: string | null;
}

export class OptionSettingsDtoPagedResultDto implements IOptionSettingsDtoPagedResultDto {
    items?: OptionSettingsDto[] | null;
    totalCount?: number;

    constructor(data?: IOptionSettingsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OptionSettingsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): OptionSettingsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionSettingsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): OptionSettingsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OptionSettingsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOptionSettingsDtoPagedResultDto {
    items?: OptionSettingsDto[] | null;
    totalCount?: number;
}

export enum TenantVipType {
    _0 = 0,
    _1 = 1,
}

export enum SchoolVipCharge {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum NoVipPushAndShowStatu {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class TenantVipTypeSetting implements ITenantVipTypeSetting {
    id?: number;
    tenantId?: number;
    toCallLength?: number;
    tenantVipType?: TenantVipType;
    isOpenUniAttendance?: boolean;
    isOpenUniDormitory?: boolean;
    schoolVipCharges?: SchoolVipCharge;
    isSchoolPayAll?: boolean;
    isShowWxCall?: boolean;
    noVipPushAndShowStatus?: NoVipPushAndShowStatu;

    constructor(data?: ITenantVipTypeSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.toCallLength = _data["toCallLength"] !== undefined ? _data["toCallLength"] : <any>null;
            this.tenantVipType = _data["tenantVipType"] !== undefined ? _data["tenantVipType"] : <any>null;
            this.isOpenUniAttendance = _data["isOpenUniAttendance"] !== undefined ? _data["isOpenUniAttendance"] : <any>null;
            this.isOpenUniDormitory = _data["isOpenUniDormitory"] !== undefined ? _data["isOpenUniDormitory"] : <any>null;
            this.schoolVipCharges = _data["schoolVipCharges"] !== undefined ? _data["schoolVipCharges"] : <any>null;
            this.isSchoolPayAll = _data["isSchoolPayAll"] !== undefined ? _data["isSchoolPayAll"] : <any>null;
            this.isShowWxCall = _data["isShowWxCall"] !== undefined ? _data["isShowWxCall"] : <any>null;
            this.noVipPushAndShowStatus = _data["noVipPushAndShowStatus"] !== undefined ? _data["noVipPushAndShowStatus"] : <any>null;
        }
    }

    static fromJS(data: any): TenantVipTypeSetting {
        data = typeof data === 'object' ? data : {};
        let result = new TenantVipTypeSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["toCallLength"] = this.toCallLength !== undefined ? this.toCallLength : <any>null;
        data["tenantVipType"] = this.tenantVipType !== undefined ? this.tenantVipType : <any>null;
        data["isOpenUniAttendance"] = this.isOpenUniAttendance !== undefined ? this.isOpenUniAttendance : <any>null;
        data["isOpenUniDormitory"] = this.isOpenUniDormitory !== undefined ? this.isOpenUniDormitory : <any>null;
        data["schoolVipCharges"] = this.schoolVipCharges !== undefined ? this.schoolVipCharges : <any>null;
        data["isSchoolPayAll"] = this.isSchoolPayAll !== undefined ? this.isSchoolPayAll : <any>null;
        data["isShowWxCall"] = this.isShowWxCall !== undefined ? this.isShowWxCall : <any>null;
        data["noVipPushAndShowStatus"] = this.noVipPushAndShowStatus !== undefined ? this.noVipPushAndShowStatus : <any>null;
        return data; 
    }

    clone(): TenantVipTypeSetting {
        const json = this.toJSON();
        let result = new TenantVipTypeSetting();
        result.init(json);
        return result;
    }
}

export interface ITenantVipTypeSetting {
    id?: number;
    tenantId?: number;
    toCallLength?: number;
    tenantVipType?: TenantVipType;
    isOpenUniAttendance?: boolean;
    isOpenUniDormitory?: boolean;
    schoolVipCharges?: SchoolVipCharge;
    isSchoolPayAll?: boolean;
    isShowWxCall?: boolean;
    noVipPushAndShowStatus?: NoVipPushAndShowStatu;
}

export class OptionRecordsDto implements IOptionRecordsDto {
    id?: number;
    /** 操作时间 */
    modificationTime?: moment.Moment;
    /** 标题 */
    title?: string | null;
    /** 操作人 */
    operator?: string | null;
    /** 操作人电话 */
    oPhone?: string | null;

    constructor(data?: IOptionRecordsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.modificationTime = _data["modificationTime"] ? moment.parseZone(_data["modificationTime"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.operator = _data["operator"] !== undefined ? _data["operator"] : <any>null;
            this.oPhone = _data["oPhone"] !== undefined ? _data["oPhone"] : <any>null;
        }
    }

    static fromJS(data: any): OptionRecordsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptionRecordsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["modificationTime"] = this.modificationTime ? this.modificationTime.toISOString(true) : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["operator"] = this.operator !== undefined ? this.operator : <any>null;
        data["oPhone"] = this.oPhone !== undefined ? this.oPhone : <any>null;
        return data; 
    }

    clone(): OptionRecordsDto {
        const json = this.toJSON();
        let result = new OptionRecordsDto();
        result.init(json);
        return result;
    }
}

export interface IOptionRecordsDto {
    id?: number;
    /** 操作时间 */
    modificationTime?: moment.Moment;
    /** 标题 */
    title?: string | null;
    /** 操作人 */
    operator?: string | null;
    /** 操作人电话 */
    oPhone?: string | null;
}

/** 通过学校ID 获取该学校的会员配置 */
export class GetVipPriceSettingByTenantIdDto implements IGetVipPriceSettingByTenantIdDto {
    /** 学校ID */
    id?: number;
    /** 描述 */
    description?: string | null;
    /** VIP充值原价 */
    originalAmout?: number;
    /** 实际充值价格 */
    amount?: number;
    /** Vip月份数量 */
    month?: number;
    /** 是否启用 */
    isEnable?: boolean;
    /** 充值截至日期 */
    expiredDateTime?: moment.Moment | null;
    /** 微信充值排序号码 */
    sortedNo?: number;
    type?: VipPayPriceSettingType;
    /** 标题名称 */
    title?: string | null;
    /** 内容提示 */
    comment?: string | null;
    registrationType?: RegistrationType;
    /** 会员赠送的天数 */
    days?: number;
    isDefaltChick?: boolean;
    /** 仅限年级查看 */
    relatedGrade?: string | null;
    gradeNo?: number[] | null;
    vipRarionGrade?: VipRarionGrade[] | null;

    constructor(data?: IGetVipPriceSettingByTenantIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.originalAmout = _data["originalAmout"] !== undefined ? _data["originalAmout"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.month = _data["month"] !== undefined ? _data["month"] : <any>null;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : <any>null;
            this.expiredDateTime = _data["expiredDateTime"] ? moment.parseZone(_data["expiredDateTime"].toString()) : <any>null;
            this.sortedNo = _data["sortedNo"] !== undefined ? _data["sortedNo"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.registrationType = _data["registrationType"] !== undefined ? _data["registrationType"] : <any>null;
            this.days = _data["days"] !== undefined ? _data["days"] : <any>null;
            this.isDefaltChick = _data["isDefaltChick"] !== undefined ? _data["isDefaltChick"] : <any>null;
            this.relatedGrade = _data["relatedGrade"] !== undefined ? _data["relatedGrade"] : <any>null;
            if (Array.isArray(_data["gradeNo"])) {
                this.gradeNo = [] as any;
                for (let item of _data["gradeNo"])
                    this.gradeNo!.push(item);
            }
            if (Array.isArray(_data["vipRarionGrade"])) {
                this.vipRarionGrade = [] as any;
                for (let item of _data["vipRarionGrade"])
                    this.vipRarionGrade!.push(VipRarionGrade.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVipPriceSettingByTenantIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVipPriceSettingByTenantIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["originalAmout"] = this.originalAmout !== undefined ? this.originalAmout : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["month"] = this.month !== undefined ? this.month : <any>null;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : <any>null;
        data["expiredDateTime"] = this.expiredDateTime ? this.expiredDateTime.toISOString(true) : <any>null;
        data["sortedNo"] = this.sortedNo !== undefined ? this.sortedNo : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["registrationType"] = this.registrationType !== undefined ? this.registrationType : <any>null;
        data["days"] = this.days !== undefined ? this.days : <any>null;
        data["isDefaltChick"] = this.isDefaltChick !== undefined ? this.isDefaltChick : <any>null;
        data["relatedGrade"] = this.relatedGrade !== undefined ? this.relatedGrade : <any>null;
        if (Array.isArray(this.gradeNo)) {
            data["gradeNo"] = [];
            for (let item of this.gradeNo)
                data["gradeNo"].push(item);
        }
        if (Array.isArray(this.vipRarionGrade)) {
            data["vipRarionGrade"] = [];
            for (let item of this.vipRarionGrade)
                data["vipRarionGrade"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetVipPriceSettingByTenantIdDto {
        const json = this.toJSON();
        let result = new GetVipPriceSettingByTenantIdDto();
        result.init(json);
        return result;
    }
}

/** 通过学校ID 获取该学校的会员配置 */
export interface IGetVipPriceSettingByTenantIdDto {
    /** 学校ID */
    id?: number;
    /** 描述 */
    description?: string | null;
    /** VIP充值原价 */
    originalAmout?: number;
    /** 实际充值价格 */
    amount?: number;
    /** Vip月份数量 */
    month?: number;
    /** 是否启用 */
    isEnable?: boolean;
    /** 充值截至日期 */
    expiredDateTime?: moment.Moment | null;
    /** 微信充值排序号码 */
    sortedNo?: number;
    type?: VipPayPriceSettingType;
    /** 标题名称 */
    title?: string | null;
    /** 内容提示 */
    comment?: string | null;
    registrationType?: RegistrationType;
    /** 会员赠送的天数 */
    days?: number;
    isDefaltChick?: boolean;
    /** 仅限年级查看 */
    relatedGrade?: string | null;
    gradeNo?: number[] | null;
    vipRarionGrade?: VipRarionGrade[] | null;
}

export enum UpdatePackageType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class CardHandlingRegistrationPackage implements ICardHandlingRegistrationPackage {
    id?: number;
    updatePackageType?: UpdatePackageType;
    cardHandlingRegistrationId?: number;
    title?: string | null;
    introduce?: string | null;
    isShow?: boolean;
    marketPrice?: number;
    exclusivePrice?: number;
    sortNumber?: number;
    tenantId?: number;

    constructor(data?: ICardHandlingRegistrationPackage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.updatePackageType = _data["updatePackageType"] !== undefined ? _data["updatePackageType"] : <any>null;
            this.cardHandlingRegistrationId = _data["cardHandlingRegistrationId"] !== undefined ? _data["cardHandlingRegistrationId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.introduce = _data["introduce"] !== undefined ? _data["introduce"] : <any>null;
            this.isShow = _data["isShow"] !== undefined ? _data["isShow"] : <any>null;
            this.marketPrice = _data["marketPrice"] !== undefined ? _data["marketPrice"] : <any>null;
            this.exclusivePrice = _data["exclusivePrice"] !== undefined ? _data["exclusivePrice"] : <any>null;
            this.sortNumber = _data["sortNumber"] !== undefined ? _data["sortNumber"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
        }
    }

    static fromJS(data: any): CardHandlingRegistrationPackage {
        data = typeof data === 'object' ? data : {};
        let result = new CardHandlingRegistrationPackage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["updatePackageType"] = this.updatePackageType !== undefined ? this.updatePackageType : <any>null;
        data["cardHandlingRegistrationId"] = this.cardHandlingRegistrationId !== undefined ? this.cardHandlingRegistrationId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["introduce"] = this.introduce !== undefined ? this.introduce : <any>null;
        data["isShow"] = this.isShow !== undefined ? this.isShow : <any>null;
        data["marketPrice"] = this.marketPrice !== undefined ? this.marketPrice : <any>null;
        data["exclusivePrice"] = this.exclusivePrice !== undefined ? this.exclusivePrice : <any>null;
        data["sortNumber"] = this.sortNumber !== undefined ? this.sortNumber : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        return data; 
    }

    clone(): CardHandlingRegistrationPackage {
        const json = this.toJSON();
        let result = new CardHandlingRegistrationPackage();
        result.init(json);
        return result;
    }
}

export interface ICardHandlingRegistrationPackage {
    id?: number;
    updatePackageType?: UpdatePackageType;
    cardHandlingRegistrationId?: number;
    title?: string | null;
    introduce?: string | null;
    isShow?: boolean;
    marketPrice?: number;
    exclusivePrice?: number;
    sortNumber?: number;
    tenantId?: number;
}

export class CardHandlingRegistration implements ICardHandlingRegistration {
    id?: number;
    vipPayPriceSettingId?: number;
    tenantId?: number;
    detailedIntroduction?: string | null;
    title?: string | null;
    ruleName?: string | null;
    ruleComment?: string | null;
    registrationType?: RegistrationType;
    cardHandlingRegistrationPackage?: CardHandlingRegistrationPackage[] | null;

    constructor(data?: ICardHandlingRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.vipPayPriceSettingId = _data["vipPayPriceSettingId"] !== undefined ? _data["vipPayPriceSettingId"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.detailedIntroduction = _data["detailedIntroduction"] !== undefined ? _data["detailedIntroduction"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.ruleName = _data["ruleName"] !== undefined ? _data["ruleName"] : <any>null;
            this.ruleComment = _data["ruleComment"] !== undefined ? _data["ruleComment"] : <any>null;
            this.registrationType = _data["registrationType"] !== undefined ? _data["registrationType"] : <any>null;
            if (Array.isArray(_data["cardHandlingRegistrationPackage"])) {
                this.cardHandlingRegistrationPackage = [] as any;
                for (let item of _data["cardHandlingRegistrationPackage"])
                    this.cardHandlingRegistrationPackage!.push(CardHandlingRegistrationPackage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardHandlingRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new CardHandlingRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["vipPayPriceSettingId"] = this.vipPayPriceSettingId !== undefined ? this.vipPayPriceSettingId : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["detailedIntroduction"] = this.detailedIntroduction !== undefined ? this.detailedIntroduction : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["ruleName"] = this.ruleName !== undefined ? this.ruleName : <any>null;
        data["ruleComment"] = this.ruleComment !== undefined ? this.ruleComment : <any>null;
        data["registrationType"] = this.registrationType !== undefined ? this.registrationType : <any>null;
        if (Array.isArray(this.cardHandlingRegistrationPackage)) {
            data["cardHandlingRegistrationPackage"] = [];
            for (let item of this.cardHandlingRegistrationPackage)
                data["cardHandlingRegistrationPackage"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CardHandlingRegistration {
        const json = this.toJSON();
        let result = new CardHandlingRegistration();
        result.init(json);
        return result;
    }
}

export interface ICardHandlingRegistration {
    id?: number;
    vipPayPriceSettingId?: number;
    tenantId?: number;
    detailedIntroduction?: string | null;
    title?: string | null;
    ruleName?: string | null;
    ruleComment?: string | null;
    registrationType?: RegistrationType;
    cardHandlingRegistrationPackage?: CardHandlingRegistrationPackage[] | null;
}

/** 联通办卡登记套餐 */
export class RegistrationPackageDto implements IRegistrationPackageDto {
    /** 设置Id */
    vipPayPriceSettingId?: number;
    /** VIP充值描述 */
    description?: string | null;
    /** 是否启用 */
    isEnable?: boolean;
    /** 时长描述 */
    durationDescribe?: string | null;
    registrationType?: RegistrationType;
    /** 会员赠送的天数 */
    days?: number;
    /** 登记类型 */
    cardHandlingRegistrations?: CardHandlingRegistration[] | null;

    constructor(data?: IRegistrationPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vipPayPriceSettingId = _data["vipPayPriceSettingId"] !== undefined ? _data["vipPayPriceSettingId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.isEnable = _data["isEnable"] !== undefined ? _data["isEnable"] : <any>null;
            this.durationDescribe = _data["durationDescribe"] !== undefined ? _data["durationDescribe"] : <any>null;
            this.registrationType = _data["registrationType"] !== undefined ? _data["registrationType"] : <any>null;
            this.days = _data["days"] !== undefined ? _data["days"] : <any>null;
            if (Array.isArray(_data["cardHandlingRegistrations"])) {
                this.cardHandlingRegistrations = [] as any;
                for (let item of _data["cardHandlingRegistrations"])
                    this.cardHandlingRegistrations!.push(CardHandlingRegistration.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegistrationPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vipPayPriceSettingId"] = this.vipPayPriceSettingId !== undefined ? this.vipPayPriceSettingId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isEnable"] = this.isEnable !== undefined ? this.isEnable : <any>null;
        data["durationDescribe"] = this.durationDescribe !== undefined ? this.durationDescribe : <any>null;
        data["registrationType"] = this.registrationType !== undefined ? this.registrationType : <any>null;
        data["days"] = this.days !== undefined ? this.days : <any>null;
        if (Array.isArray(this.cardHandlingRegistrations)) {
            data["cardHandlingRegistrations"] = [];
            for (let item of this.cardHandlingRegistrations)
                data["cardHandlingRegistrations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): RegistrationPackageDto {
        const json = this.toJSON();
        let result = new RegistrationPackageDto();
        result.init(json);
        return result;
    }
}

/** 联通办卡登记套餐 */
export interface IRegistrationPackageDto {
    /** 设置Id */
    vipPayPriceSettingId?: number;
    /** VIP充值描述 */
    description?: string | null;
    /** 是否启用 */
    isEnable?: boolean;
    /** 时长描述 */
    durationDescribe?: string | null;
    registrationType?: RegistrationType;
    /** 会员赠送的天数 */
    days?: number;
    /** 登记类型 */
    cardHandlingRegistrations?: CardHandlingRegistration[] | null;
}

export class ChangPushInputDto implements IChangPushInputDto {
    tenantId?: number;
    isVipPush?: boolean;
    /** 是否显示商城 */
    isShowShop?: boolean;

    constructor(data?: IChangPushInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.isVipPush = _data["isVipPush"] !== undefined ? _data["isVipPush"] : <any>null;
            this.isShowShop = _data["isShowShop"] !== undefined ? _data["isShowShop"] : <any>null;
        }
    }

    static fromJS(data: any): ChangPushInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangPushInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["isVipPush"] = this.isVipPush !== undefined ? this.isVipPush : <any>null;
        data["isShowShop"] = this.isShowShop !== undefined ? this.isShowShop : <any>null;
        return data; 
    }

    clone(): ChangPushInputDto {
        const json = this.toJSON();
        let result = new ChangPushInputDto();
        result.init(json);
        return result;
    }
}

export interface IChangPushInputDto {
    tenantId?: number;
    isVipPush?: boolean;
    /** 是否显示商城 */
    isShowShop?: boolean;
}

export class PushSettingPageOutDto implements IPushSettingPageOutDto {
    id?: number;
    /** 是否只推送Vip会员 */
    isVipPush?: boolean;
    /** 是否显示商城 */
    isShowShop?: boolean;
    /** 是否默认显示止值班领导 */
    isShowTeacherDuty?: boolean;
    /** 学校编号 */
    tenantId?: number;
    /** 学校名称 */
    schoolName?: string | null;
    /** 是否推送不在校学生信息 */
    isOpenWorkerAddStudent?: boolean;
    /** 是否非会员显示打卡信息 */
    isNotVipShowFace?: boolean;
    /** 是否允许领导审批自己 */
    isOpenLeadeApproveSelf?: boolean;
    /** 发布东西（校园拍和通知通告）是否需要审批 */
    isReleaseNeedApproval?: boolean;
    /** 是否登录需要短信验证 */
    isMessageLogin?: boolean;
    /** 新生报名是否推送 */
    ispushSignStudent?: boolean;
    /** 是否可以上传人脸照片 */
    isUpdateFace?: boolean;
    type?: number;
    /** 是否需要验证身份证号 */
    isIDNumberverification?: boolean;
    /** 是否允许宿管和保卫添加学生信息 */
    isOpenCreateLeaveByWork?: boolean;

    constructor(data?: IPushSettingPageOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isVipPush = _data["isVipPush"] !== undefined ? _data["isVipPush"] : <any>null;
            this.isShowShop = _data["isShowShop"] !== undefined ? _data["isShowShop"] : <any>null;
            this.isShowTeacherDuty = _data["isShowTeacherDuty"] !== undefined ? _data["isShowTeacherDuty"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.schoolName = _data["schoolName"] !== undefined ? _data["schoolName"] : <any>null;
            this.isOpenWorkerAddStudent = _data["isOpenWorkerAddStudent"] !== undefined ? _data["isOpenWorkerAddStudent"] : <any>null;
            this.isNotVipShowFace = _data["isNotVipShowFace"] !== undefined ? _data["isNotVipShowFace"] : <any>null;
            this.isOpenLeadeApproveSelf = _data["isOpenLeadeApproveSelf"] !== undefined ? _data["isOpenLeadeApproveSelf"] : <any>null;
            this.isReleaseNeedApproval = _data["isReleaseNeedApproval"] !== undefined ? _data["isReleaseNeedApproval"] : <any>null;
            this.isMessageLogin = _data["isMessageLogin"] !== undefined ? _data["isMessageLogin"] : <any>null;
            this.ispushSignStudent = _data["ispushSignStudent"] !== undefined ? _data["ispushSignStudent"] : <any>null;
            this.isUpdateFace = _data["isUpdateFace"] !== undefined ? _data["isUpdateFace"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.isIDNumberverification = _data["isIDNumberverification"] !== undefined ? _data["isIDNumberverification"] : <any>null;
            this.isOpenCreateLeaveByWork = _data["isOpenCreateLeaveByWork"] !== undefined ? _data["isOpenCreateLeaveByWork"] : <any>null;
        }
    }

    static fromJS(data: any): PushSettingPageOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushSettingPageOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isVipPush"] = this.isVipPush !== undefined ? this.isVipPush : <any>null;
        data["isShowShop"] = this.isShowShop !== undefined ? this.isShowShop : <any>null;
        data["isShowTeacherDuty"] = this.isShowTeacherDuty !== undefined ? this.isShowTeacherDuty : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["schoolName"] = this.schoolName !== undefined ? this.schoolName : <any>null;
        data["isOpenWorkerAddStudent"] = this.isOpenWorkerAddStudent !== undefined ? this.isOpenWorkerAddStudent : <any>null;
        data["isNotVipShowFace"] = this.isNotVipShowFace !== undefined ? this.isNotVipShowFace : <any>null;
        data["isOpenLeadeApproveSelf"] = this.isOpenLeadeApproveSelf !== undefined ? this.isOpenLeadeApproveSelf : <any>null;
        data["isReleaseNeedApproval"] = this.isReleaseNeedApproval !== undefined ? this.isReleaseNeedApproval : <any>null;
        data["isMessageLogin"] = this.isMessageLogin !== undefined ? this.isMessageLogin : <any>null;
        data["ispushSignStudent"] = this.ispushSignStudent !== undefined ? this.ispushSignStudent : <any>null;
        data["isUpdateFace"] = this.isUpdateFace !== undefined ? this.isUpdateFace : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["isIDNumberverification"] = this.isIDNumberverification !== undefined ? this.isIDNumberverification : <any>null;
        data["isOpenCreateLeaveByWork"] = this.isOpenCreateLeaveByWork !== undefined ? this.isOpenCreateLeaveByWork : <any>null;
        return data; 
    }

    clone(): PushSettingPageOutDto {
        const json = this.toJSON();
        let result = new PushSettingPageOutDto();
        result.init(json);
        return result;
    }
}

export interface IPushSettingPageOutDto {
    id?: number;
    /** 是否只推送Vip会员 */
    isVipPush?: boolean;
    /** 是否显示商城 */
    isShowShop?: boolean;
    /** 是否默认显示止值班领导 */
    isShowTeacherDuty?: boolean;
    /** 学校编号 */
    tenantId?: number;
    /** 学校名称 */
    schoolName?: string | null;
    /** 是否推送不在校学生信息 */
    isOpenWorkerAddStudent?: boolean;
    /** 是否非会员显示打卡信息 */
    isNotVipShowFace?: boolean;
    /** 是否允许领导审批自己 */
    isOpenLeadeApproveSelf?: boolean;
    /** 发布东西（校园拍和通知通告）是否需要审批 */
    isReleaseNeedApproval?: boolean;
    /** 是否登录需要短信验证 */
    isMessageLogin?: boolean;
    /** 新生报名是否推送 */
    ispushSignStudent?: boolean;
    /** 是否可以上传人脸照片 */
    isUpdateFace?: boolean;
    type?: number;
    /** 是否需要验证身份证号 */
    isIDNumberverification?: boolean;
    /** 是否允许宿管和保卫添加学生信息 */
    isOpenCreateLeaveByWork?: boolean;
}

export class PushSettingPageOutDtoPagedResultDto implements IPushSettingPageOutDtoPagedResultDto {
    items?: PushSettingPageOutDto[] | null;
    totalCount?: number;

    constructor(data?: IPushSettingPageOutDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PushSettingPageOutDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PushSettingPageOutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushSettingPageOutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data; 
    }

    clone(): PushSettingPageOutDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PushSettingPageOutDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPushSettingPageOutDtoPagedResultDto {
    items?: PushSettingPageOutDto[] | null;
    totalCount?: number;
}

export class PushNotInSchoolInfoDto implements IPushNotInSchoolInfoDto {
    id?: number;
    /** 是否推送不在校学生信息 */
    isPushNotInSchool?: boolean;
    /** 开始推送的时间 */
    pushTimeStr?: string | null;
    /** 时分 */
    pushTimeTwoStr?: string | null;
    /** 时分 */
    pushTimeThreeStr?: string | null;

    constructor(data?: IPushNotInSchoolInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isPushNotInSchool = _data["isPushNotInSchool"] !== undefined ? _data["isPushNotInSchool"] : <any>null;
            this.pushTimeStr = _data["pushTimeStr"] !== undefined ? _data["pushTimeStr"] : <any>null;
            this.pushTimeTwoStr = _data["pushTimeTwoStr"] !== undefined ? _data["pushTimeTwoStr"] : <any>null;
            this.pushTimeThreeStr = _data["pushTimeThreeStr"] !== undefined ? _data["pushTimeThreeStr"] : <any>null;
        }
    }

    static fromJS(data: any): PushNotInSchoolInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PushNotInSchoolInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isPushNotInSchool"] = this.isPushNotInSchool !== undefined ? this.isPushNotInSchool : <any>null;
        data["pushTimeStr"] = this.pushTimeStr !== undefined ? this.pushTimeStr : <any>null;
        data["pushTimeTwoStr"] = this.pushTimeTwoStr !== undefined ? this.pushTimeTwoStr : <any>null;
        data["pushTimeThreeStr"] = this.pushTimeThreeStr !== undefined ? this.pushTimeThreeStr : <any>null;
        return data; 
    }

    clone(): PushNotInSchoolInfoDto {
        const json = this.toJSON();
        let result = new PushNotInSchoolInfoDto();
        result.init(json);
        return result;
    }
}

export interface IPushNotInSchoolInfoDto {
    id?: number;
    /** 是否推送不在校学生信息 */
    isPushNotInSchool?: boolean;
    /** 开始推送的时间 */
    pushTimeStr?: string | null;
    /** 时分 */
    pushTimeTwoStr?: string | null;
    /** 时分 */
    pushTimeThreeStr?: string | null;
}

export class Children implements IChildren {
    value?: number;
    label?: string | null;
    userType?: UserType;

    constructor(data?: IChildren) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : <any>null;
        }
    }

    static fromJS(data: any): Children {
        data = typeof data === 'object' ? data : {};
        let result = new Children();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["userType"] = this.userType !== undefined ? this.userType : <any>null;
        return data; 
    }

    clone(): Children {
        const json = this.toJSON();
        let result = new Children();
        result.init(json);
        return result;
    }
}

export interface IChildren {
    value?: number;
    label?: string | null;
    userType?: UserType;
}

export class TeacherGroupDto implements ITeacherGroupDto {
    value?: number;
    label?: string | null;
    disabled?: boolean;
    children?: Children[] | null;

    constructor(data?: ITeacherGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Children.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeacherGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TeacherGroupDto {
        const json = this.toJSON();
        let result = new TeacherGroupDto();
        result.init(json);
        return result;
    }
}

export interface ITeacherGroupDto {
    value?: number;
    label?: string | null;
    disabled?: boolean;
    children?: Children[] | null;
}

/** 教师距离打卡设置 */
export class TeacherRangeClockDto implements ITeacherRangeClockDto {
    /** 是否开启范围打卡 */
    isOpenScopeClockIn?: boolean;
    /** 经度 */
    longitude?: number;
    /** 纬度 */
    latitude?: number;
    /** 可打卡范围 */
    clockDistance?: number;
    /** 学校ID */
    tenantId?: number;
    teacherIds?: number[] | null;
    /** 教师考勤打卡设置 */
    teacherAttendanceManagerUserId?: number | null;
    teacherAttendanceManagerUserName?: string | null;
    /** 范围打卡 是否不需要上传照片直接上传考勤 */
    isNotNeedFaceimg?: boolean;
    teacherGroupDto?: TeacherGroupDto[] | null;

    constructor(data?: ITeacherRangeClockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOpenScopeClockIn = _data["isOpenScopeClockIn"] !== undefined ? _data["isOpenScopeClockIn"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.clockDistance = _data["clockDistance"] !== undefined ? _data["clockDistance"] : <any>null;
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            if (Array.isArray(_data["teacherIds"])) {
                this.teacherIds = [] as any;
                for (let item of _data["teacherIds"])
                    this.teacherIds!.push(item);
            }
            this.teacherAttendanceManagerUserId = _data["teacherAttendanceManagerUserId"] !== undefined ? _data["teacherAttendanceManagerUserId"] : <any>null;
            this.teacherAttendanceManagerUserName = _data["teacherAttendanceManagerUserName"] !== undefined ? _data["teacherAttendanceManagerUserName"] : <any>null;
            this.isNotNeedFaceimg = _data["isNotNeedFaceimg"] !== undefined ? _data["isNotNeedFaceimg"] : <any>null;
            if (Array.isArray(_data["teacherGroupDto"])) {
                this.teacherGroupDto = [] as any;
                for (let item of _data["teacherGroupDto"])
                    this.teacherGroupDto!.push(TeacherGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeacherRangeClockDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherRangeClockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOpenScopeClockIn"] = this.isOpenScopeClockIn !== undefined ? this.isOpenScopeClockIn : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["clockDistance"] = this.clockDistance !== undefined ? this.clockDistance : <any>null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        if (Array.isArray(this.teacherIds)) {
            data["teacherIds"] = [];
            for (let item of this.teacherIds)
                data["teacherIds"].push(item);
        }
        data["teacherAttendanceManagerUserId"] = this.teacherAttendanceManagerUserId !== undefined ? this.teacherAttendanceManagerUserId : <any>null;
        data["teacherAttendanceManagerUserName"] = this.teacherAttendanceManagerUserName !== undefined ? this.teacherAttendanceManagerUserName : <any>null;
        data["isNotNeedFaceimg"] = this.isNotNeedFaceimg !== undefined ? this.isNotNeedFaceimg : <any>null;
        if (Array.isArray(this.teacherGroupDto)) {
            data["teacherGroupDto"] = [];
            for (let item of this.teacherGroupDto)
                data["teacherGroupDto"].push(item.toJSON());
        }
        return data; 
    }

    clone(): TeacherRangeClockDto {
        const json = this.toJSON();
        let result = new TeacherRangeClockDto();
        result.init(json);
        return result;
    }
}

/** 教师距离打卡设置 */
export interface ITeacherRangeClockDto {
    /** 是否开启范围打卡 */
    isOpenScopeClockIn?: boolean;
    /** 经度 */
    longitude?: number;
    /** 纬度 */
    latitude?: number;
    /** 可打卡范围 */
    clockDistance?: number;
    /** 学校ID */
    tenantId?: number;
    teacherIds?: number[] | null;
    /** 教师考勤打卡设置 */
    teacherAttendanceManagerUserId?: number | null;
    teacherAttendanceManagerUserName?: string | null;
    /** 范围打卡 是否不需要上传照片直接上传考勤 */
    isNotNeedFaceimg?: boolean;
    teacherGroupDto?: TeacherGroupDto[] | null;
}

export class TeacherInfoByNameOrPhone implements ITeacherInfoByNameOrPhone {
    /** 教师考勤打卡设置 */
    teacherAttendanceManagerUserId?: number | null;
    teacherAttendanceManagerUserName?: string | null;
    teacherAttendanceManagerUserPhone?: string | null;

    constructor(data?: ITeacherInfoByNameOrPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teacherAttendanceManagerUserId = _data["teacherAttendanceManagerUserId"] !== undefined ? _data["teacherAttendanceManagerUserId"] : <any>null;
            this.teacherAttendanceManagerUserName = _data["teacherAttendanceManagerUserName"] !== undefined ? _data["teacherAttendanceManagerUserName"] : <any>null;
            this.teacherAttendanceManagerUserPhone = _data["teacherAttendanceManagerUserPhone"] !== undefined ? _data["teacherAttendanceManagerUserPhone"] : <any>null;
        }
    }

    static fromJS(data: any): TeacherInfoByNameOrPhone {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherInfoByNameOrPhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teacherAttendanceManagerUserId"] = this.teacherAttendanceManagerUserId !== undefined ? this.teacherAttendanceManagerUserId : <any>null;
        data["teacherAttendanceManagerUserName"] = this.teacherAttendanceManagerUserName !== undefined ? this.teacherAttendanceManagerUserName : <any>null;
        data["teacherAttendanceManagerUserPhone"] = this.teacherAttendanceManagerUserPhone !== undefined ? this.teacherAttendanceManagerUserPhone : <any>null;
        return data; 
    }

    clone(): TeacherInfoByNameOrPhone {
        const json = this.toJSON();
        let result = new TeacherInfoByNameOrPhone();
        result.init(json);
        return result;
    }
}

export interface ITeacherInfoByNameOrPhone {
    /** 教师考勤打卡设置 */
    teacherAttendanceManagerUserId?: number | null;
    teacherAttendanceManagerUserName?: string | null;
    teacherAttendanceManagerUserPhone?: string | null;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class StudentStaticTimeIntervalItem implements IStudentStaticTimeIntervalItem {
    startDayOfWeek?: DayOfWeek;
    /** 时段开始时间 */
    startTime?: string | null;

    constructor(data?: IStudentStaticTimeIntervalItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDayOfWeek = _data["startDayOfWeek"] !== undefined ? _data["startDayOfWeek"] : <any>null;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : <any>null;
        }
    }

    static fromJS(data: any): StudentStaticTimeIntervalItem {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStaticTimeIntervalItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDayOfWeek"] = this.startDayOfWeek !== undefined ? this.startDayOfWeek : <any>null;
        data["startTime"] = this.startTime !== undefined ? this.startTime : <any>null;
        return data; 
    }

    clone(): StudentStaticTimeIntervalItem {
        const json = this.toJSON();
        let result = new StudentStaticTimeIntervalItem();
        result.init(json);
        return result;
    }
}

export interface IStudentStaticTimeIntervalItem {
    startDayOfWeek?: DayOfWeek;
    /** 时段开始时间 */
    startTime?: string | null;
}

export class StudentStaticTimeIntervalDto implements IStudentStaticTimeIntervalDto {
    tenantId?: number;
    isOpenPushMasterWithStudentStatic?: boolean;
    studentStaticTimeIntervalItem?: StudentStaticTimeIntervalItem[] | null;

    constructor(data?: IStudentStaticTimeIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"] !== undefined ? _data["tenantId"] : <any>null;
            this.isOpenPushMasterWithStudentStatic = _data["isOpenPushMasterWithStudentStatic"] !== undefined ? _data["isOpenPushMasterWithStudentStatic"] : <any>null;
            if (Array.isArray(_data["studentStaticTimeIntervalItem"])) {
                this.studentStaticTimeIntervalItem = [] as any;
                for (let item of _data["studentStaticTimeIntervalItem"])
                    this.studentStaticTimeIntervalItem!.push(StudentStaticTimeIntervalItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentStaticTimeIntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStaticTimeIntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : <any>null;
        data["isOpenPushMasterWithStudentStatic"] = this.isOpenPushMasterWithStudentStatic !== undefined ? this.isOpenPushMasterWithStudentStatic : <any>null;
        if (Array.isArray(this.studentStaticTimeIntervalItem)) {
            data["studentStaticTimeIntervalItem"] = [];
            for (let item of this.studentStaticTimeIntervalItem)
                data["studentStaticTimeIntervalItem"].push(item.toJSON());
        }
        return data; 
    }

    clone(): StudentStaticTimeIntervalDto {
        const json = this.toJSON();
        let result = new StudentStaticTimeIntervalDto();
        result.init(json);
        return result;
    }
}

export interface IStudentStaticTimeIntervalDto {
    tenantId?: number;
    isOpenPushMasterWithStudentStatic?: boolean;
    studentStaticTimeIntervalItem?: StudentStaticTimeIntervalItem[] | null;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}